function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//deplace avant pour que ce soit declare hors du fetch
var translationJSon;
var infoCountriesJSon; // var ajax = new XMLHttpRequest();
// ajax.open("get", "//www.kusakurashop.jp/cdn/shop/t/6/assets/site-js-locales.json?v=99423969116504100891713314425", true);
// ajax.send();

fetch("//www.kusakurashop.jp/cdn/shop/t/6/assets/site-js-locales.json?v=99423969116504100891713314425", {
  method: 'GET'
}).then(function (response) {
  return response.json().then(function (data) {
    // ajax.addEventListener('load', function (e) {
    translationJSon = data;
    fetch("//www.kusakurashop.jp/cdn/shop/t/6/assets/site-js-countries.json?v=12640871635132238801709170695", {
      method: 'GET'
    }).then(function (responseCountries) {
      return responseCountries.json().then(function (dataCountries) {
        infoCountriesJSon = dataCountries;

        var laLang = document.querySelector('[data-currency-primary]').getAttribute("lang");
        if(typeof translations_judge_me_json !== 'undefined'){
          var translations_judge_me_json_parsed = JSON.parse(translations_judge_me_json);
          console.log("translations_judge_me_json_parsed",translations_judge_me_json_parsed);
        }
        (function () {
          function r(e, n, t) {
            function o(i, f) {
              if (!n[i]) {
                if (!e[i]) {
                  var c = "function" == typeof require && require;
                  if (!f && c) return c(i, !0);
                  if (u) return u(i, !0);
                  var a = new Error("Cannot find module '" + i + "'");
                  throw a.code = "MODULE_NOT_FOUND", a;
                }

                var p = n[i] = {
                  exports: {}
                };
                e[i][0].call(p.exports, function (r) {
                  var n = e[i][1][r];
                  return o(n || r);
                }, p, p.exports, r, e, n, t);
              }

              return n[i].exports;
            }

            for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
              o(t[i]);
            }

            return o;
          }

          return r;
        })()({
          1: [function (require, module, exports) {
            var _ = require('./_lib.js');

            var Affix = function Affix(element) {
              this.ele = element;
              this.parent = this.ele.parentNode;
              this.FromTop = this.ele.dataset.affixFromTop;
              this.wrapper = document.querySelector('.offcanvas-main');

              this._addEventListerners();

              this.mirrorEle = document.querySelector(this.ele.dataset.mirror);
            };

            Affix.prototype.fix = function () {
              var parentPos = this._getPosition(this.parent);

              var elePos = this._getPosition(this.ele);

              var offset = this.parent.offsetHeight + parentPos.y;
              var toggledClass = this.ele.dataset.affix; //if (this.ele.className == "site-header" || this.ele.className == "site-header fixed" ){
              //}

              if (this.FromTop == undefined) {
                if (offset < elePos.y && this._isFixed()) {
                  if (toggledClass) {
                    this.ele.classList.add(toggledClass);
                  } else {
                    this.ele.classList.remove("fixed");
                  }

                  if (this.mirrorEle) {
                    this.mirrorEle.classList.remove(toggledClass);
                  }
                } else if (offset > this._windowSize().y && !this._isFixed()) {
                  if (toggledClass) {
                    this.ele.classList.remove(toggledClass);
                  } else {
                    this.ele.classList.add("fixed");
                  }

                  if (this.mirrorEle) {
                    this.mirrorEle.classList.add(toggledClass);
                  }
                }
              } else {
                if (this.FromTop == "true") {
                  offset += this.ele.offsetHeight;

                  if (offset < this._windowSize().y && !this._isFixed()) {
                    this.ele.classList.add("fixed");
                  } else if (offset > this._windowSize().y && this._isFixed()) {
                    this.ele.classList.remove("fixed");
                  }
                } else {
                  if (this.wrapper.scrollTop > this.FromTop) {
                    this.ele.classList.add("fixed");
                  } else {
                    this.ele.classList.remove("fixed");
                  }
                }
              }
            }; // Private


            Affix.prototype._addEventListerners = function () {
              var _this = this;

              if ("the-budoexport-blog" != "" && document.body.classList.contains("the-budoexport-blog")) {
                return;
              }

              this.wrapper.addEventListener('scroll', _.debounce(function () {
                _this.fix();
              }));
            };

            Affix.prototype._isFixed = function () {
              if (this.ele.dataset.affix !== "") {
                return !this.ele.classList.contains(this.ele.dataset.affix);
              } else {
                return this.ele.classList.contains("fixed");
              }
            };

            Affix.prototype._getPosition = function (element) {
              var xPosition = 0;
              var yPosition = 0;

              while (element) {
                xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
                yPosition += element.offsetTop - element.scrollTop + element.clientTop;
                element = element.offsetParent;
              }

              return {
                x: xPosition,
                y: yPosition
              };
            };

            Affix.prototype._windowSize = function () {
              var w = window,
                  d = document,
                  e = d.documentElement,
                  g = d.getElementsByTagName('body')[0],
                  x = w.innerWidth || e.clientWidth || g.clientWidth,
                  y = w.innerHeight || e.clientHeight || g.clientHeight;
              return {
                x: x,
                y: y
              };
            };

            var AffixList = function AffixList() {
              this.eles = document.querySelectorAll('[data-affix]');

              _.each(this.eles, function (element) {
                new Affix(element);
              });
            };

            module.exports = AffixList;
          }, {
            "./_lib.js": 14
          }],
          2: [function (require, module, exports) {
            /*
               Carousel:
                To create a carousel you will need the following base markup:
                 <div data-carousel>
                  <div data-carousel-actions>
                    <a href="#" data-carousel-action="prev">Liquid error: This liquid context does not allow includes.<span class="icon-text-hidden">Previous</span></a>
                    <a href="#" data-carousel-action="next">Liquid error: This liquid context does not allow includes.<span class="icon-text-hidden">Next</span></a>
                  </div>
                   <div data-carousel-clip>
                    <ul>
                      <li id="item-1"> Carousel slide/item </li>
                      ...
                    </ul>
                  </div>
                </div>
                 The slides/carousel-items are contained inside the `data-carousel-clip` element.
                This also includes the next and previous action buttons to move the slides left or right.
                The slides can also be moved by swiping left or right on a touch device.
                 To include preview or go-to links add this markup inside the `data-carousel` element at the bottom:
                 <div data-carousel-previews>
                  <ul class="list-inline">
                    <li>
                      <a href="#item-1">Item 1</a>
                    </li>
                    ...
                  </ul>
                </div>
                 The preview-links href attribute targets the id of the slide/item.
                 This carousel is responsive and can show multiple items/columns in a single view.
                It can also show different columns at different breakpoints.
                By default the columns are: { xs:1, sm: 1, md: 1, lg: 1, xl:1 }
                 To show multiple item columns add a `data-carousel-cols` attribute to the `data-carousel` element.
                E.g. This will show two items at the `xs` screen breakpoint set by the css, three at `sm`, four at `md`, etc.
                <div data-carousel data-carousel-cols="xs:2, sm:3, md:4, lg:5, xl:6">
                  ...
                </div>
                 To have slide other than the first show on load add a `data-carousel-start` attribute with a value of the target slides id to the `data-carousel` element.
                <div data-carousel data-carousel-start="#item-1">
                  ...
                </div>
                  To autoplay add the attribute `data-autoplay` to the main element.
                By default it will loop every [n]seconds. To change the interval add the number of millisecond to the data-autoplay attributes value
                <div data-carousel data-autoplay="5000">
                  ...
                </div>
             */
            var _ = require('./_lib.js');

            var mq = require('./_mq-size.js');
            /*
              Single Carousel
            */


            var Carousel = function Carousel(ele) {
              this.ele = ele;
              this.clip = this.ele.querySelector('[data-carousel-clip]');
              this.lis = this.clip.querySelectorAll('[data-carousel-clip]>ul>li');
              this.variousHeight = false;

              if (this.lis.length > 0) {
                this.actions = this.ele.querySelectorAll('[data-carousel-action]');
                this.previews = this.ele.querySelectorAll('[data-carousel-previews] a');
                this.firstSlide = this.ele.dataset.carouselStart;
                this.autoplay = this.ele.hasAttribute('data-autoplay');
                this.colSizes = this._getColSizes();

                this._addEventListerners();

                this.setCarouselWidth();
                this.checkCarouselHeight();

                if (this.firstSlide) {
                  this.goToSlide(this.firstSlide);
                }

                if (this.autoplay) {
                  this.startAutoplay();
                }
              } else {
                // Hide the carousel if we have no slides
                this.ele.style.display = 'none';
              }
            }; // Move slides


            Carousel.prototype.moveCarousel = function (direction) {
              // Calc index based on direction
              var colSize = this.colSizes[mq.size()];

              if (direction === 'next' && this.currentIndex + 1 <= this.lis.length - 1) {
                this.currentIndex = this.currentIndex + colSize;
              } else if (direction === 'prev' && this.currentIndex - 1 >= 0) {
                this.currentIndex = this.currentIndex - colSize;
              } // Shift slides


              this._shiftSlides();

              this._setStates();
            };

            Carousel.prototype.goToSlide = function (target) {
              // Calc index based on target
              var targetEle = this.clip.querySelector(target);

              if (targetEle) {
                _.each(this.lis, function (li, index) {
                  if (li === targetEle) {
                    this.currentIndex = index;
                  }
                }, this);
              } // Shift slides


              this._shiftSlides();

              this._setStates();
            };

            Carousel.prototype.startAutoplay = function () {
              var _this = this,
                  slideOneId = '#' + this.lis[0].id,
                  interval = parseInt(this.ele.dataset.autoplay) || 4000;

              this.intervalId = setInterval(function () {
                if (_this.currentIndex === _this.lis.length - 1) {
                  _this.goToSlide(slideOneId);
                } else {
                  _this.moveCarousel('next');
                }
              }, interval);
            }; // Set widths


            Carousel.prototype.setCarouselWidth = function () {
              // [re]set the current slides index
              this.currentIndex = 0; // Calc sizes

              var colSize = this.colSizes[mq.size()];
              var liSize = this.clip.offsetWidth / colSize; // always base off the clip size as that hasn't been set in js

              var padding = this._getPadding(this.lis[0]);

              var liWidth = Math.round(liSize + padding / colSize); // set each slides with

              _.each(this.lis, function (li) {
                li.style.transform = '';
                li.style.width = liWidth + 'px';
                var video = li.querySelector('iframe');

                if (video) {
                  video.style.height = video.offsetWidth / 16 * 9 + "px";
                }
              }, this); // set the overall width of the slide container (not the clip)


              this.carouselWidth = liWidth * this.lis.length + 1; // add 1 just for good measure to stop float issues

              this.clip.querySelector('ul').style.width = this.carouselWidth + 'px'; //save active current image

              for (i = 0; i < this.previews.length; i++) {
                if (this.previews[i].classList.contains('is-active')) {
                  var current_img = this.previews[i].getAttribute('href');
                  break;
                }
              } // Update action and preview states


              this._setStates();

              this.goToSlide(current_img);
            }; //Check if various lis height


            Carousel.prototype.checkCarouselHeight = function () {
              for (var i = 1; i < this.lis.length; i++) {
                //Images of carousel have sometimes one pixel height difference
                if (Math.abs(this.lis[0].offsetHeight - this.lis[i].offsetHeight) > 2) {
                  this.variousHeight = true;
                  break;
                }
              }
            };

            Carousel.prototype.imageWidth = function () {
              var widths = [];
              var widthsLis = [];

              _.each(this.lis, function (li, index) {
                widths.push(li.querySelector('img,iframe').offsetWidth);
                widthsLis.push(li.offsetWidth);
              }, this);

              if (Math.min.apply(Math, widths) != 0) {
                return Math.min.apply(Math, widths);
              }

              return Math.min.apply(Math, widthsLis);
            };

            Carousel.prototype.itemTransition = function (transition) {
              _.each(this.lis, function (li) {
                li.style.transition = transition;
              });
            };
            /* Private */


            Carousel.prototype._addEventListerners = function () {
              var _this = this; // Add transition after the page has loaded so we don't get the odd transition


              window.addEventListener('load', function () {
                _this.setCarouselWidth();

                _this.itemTransition('.3s');
              }); // Reste width on screen resize

              window.addEventListener('resize', _.debounce(function () {
                _this.itemTransition('none');

                _this.setCarouselWidth();

                _this.itemTransition('.3s');
              }));
              var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

              if (MutationObserver) {
                // define a new observer
                var obs = new MutationObserver(function (mutations, observer) {
                  if (mutations[0].addedNodes.length || mutations[0].removedNodes.length) {
                    _this.checkCarouselHeight();
                  }
                }); // have the observer observe foo for changes in children

                obs.observe(this.ele, {
                  childList: true,
                  subtree: true
                });
              } else if (window.addEventListener) {
                this.ele.addEventListener('DOMNodeInserted', function () {
                  _this.checkCarouselHeight();
                });
                this.ele.addEventListener('DOMNodeRemoved', function () {
                  _this.checkCarouselHeight();
                });
              } // Shift slides from action click


              _.each(this.actions, function (action) {
                action.addEventListener('click', function (e) {
                  e.preventDefault();

                  _this.moveCarousel(e.currentTarget.dataset.carouselAction);
                });
              }); // Shift slides from preview click


              _.each(this.previews, function (preview) {
                preview.addEventListener('click', function (e) {
                  e.preventDefault();

                  _this.goToSlide(e.currentTarget.getAttribute('href'));
                });
              }); // Shift slides from swipe


              this.ele.onswipeLeft = function () {
                _this.moveCarousel('next');

                return false;
              };

              this.ele.onswipeRight = function () {
                _this.moveCarousel('prev');

                return false;
              }; // Autoplay pause slides on hover


              this.ele.addEventListener('mouseenter', function () {
                if (_this.intervalId) {
                  window.clearInterval(_this.intervalId);
                  _this.intervalId = false;
                }
              });
              this.ele.addEventListener('mouseleave', function () {
                if (_this.autoplay) {
                  _this.startAutoplay();
                }
              });
            }; // Move slides

            Carousel.prototype._windowObject = function(value) {
              return value != null && typeof value === 'object' && 'setInterval' in value;
            };

            Carousel.prototype.is_safari = function() {
              var freeSelf = this._windowObject(typeof self == 'object' && self) && self;
              var navigator = freeSelf && freeSelf.navigator;
              var userAgent = (navigator && navigator.userAgent || '').toLowerCase();
              var match = userAgent.match(/version\/(\d+).+?safari/);
              return match !== null;
            };

            Carousel.prototype._shiftSlides = function () {
              var shift = 0;

              if (this.currentIndex > 0) {
                shift = this.lis[0].offsetWidth * this.currentIndex * -1;
              }

              var index = 0;

              _.each(this.lis, function (li) {
                if (this.variousHeight) {
                  if (index >= this.currentIndex && index < this.currentIndex + this.colSizes[mq.size()]) {
                    li.style.maxHeight = '';
                  } else {
                    li.style.maxHeight = '1px';
                  }
                }

                var is_safari = this.is_safari();
                if(is_safari){
                  li.style.removeProperty("transition");
                }

                li.style.webkitTransform = 'translateX(' + shift + 'px)';
                li.style.msTransform = 'translateX(' + shift + 'px)';
                li.style.transform = 'translateX(' + shift + 'px)';
                index++;
              }, this);
            }; // Set states


            Carousel.prototype._setStates = function () {
              this._setActionsState();

              this._setPreviewsState();
            };

            Carousel.prototype._setActionsState = function () {
              if (this.actions.length < 1) return; // Unset disabled class from actions

              _.each(this.actions, function (actionEle) {
                actionEle.classList.remove('is-disabled');
              }); // set disabled classes


              var diff;
              var colSize = this.colSizes[mq.size()];
              var remainder = this.lis.length % colSize;

              if (remainder > 0) {
                diff = this.lis.length - remainder;
              } else {
                diff = this.lis.length - colSize;
              }

              if (this.currentIndex >= diff) {
                this.ele.querySelector('[data-carousel-action="next"]').classList.add('is-disabled');
              }

              if (this.currentIndex === 0) {
                this.ele.querySelector('[data-carousel-action="prev"]').classList.add('is-disabled');
              }
            };

            Carousel.prototype._setPreviewsState = function () {
              var colSize = this.colSizes[mq.size()];

              _.each(this.previews, function (preview, index) {
                if (index >= this.currentIndex && index < this.currentIndex + colSize) {
                  preview.classList.add('is-active');
                } else {
                  preview.classList.remove('is-active');
                }
              }, this);
            }; // Utilities


            Carousel.prototype._getPadding = function (ele) {
              var styles = window.getComputedStyle(ele, null);
              return parseFloat(styles.getPropertyValue('padding-left')) + parseFloat(styles.getPropertyValue('padding-right'));
            };

            Carousel.prototype._getColSizes = function () {
              console;

              if (this.ele.dataset.carouselCols) {
                var colData = {},
                    cols = this.ele.dataset.carouselCols.split(/,\s*/);

                _.each(cols, function (col) {
                  col = col.split(':');
                  colData[col[0]] = parseInt(col[1]);
                });

                return colData;
              } else {
                return {
                  'xs': 1,
                  'sm': 1,
                  'md': 1,
                  'lg': 1,
                  'xl': 1
                };
              }
            };
            /*
              All Carousels
            */


            var Carousels = function Carousels() {
              this.carousels = [];
              this.carouselSelector = '[data-carousel]';
              this.addProductTooltip();

              this._buildCarousels();
            }; // Method to dynamicly add tooltip among product images


            Carousels.prototype.addProductTooltip = function () {
              //Main Product
              var tooltips = document.querySelectorAll('#productDetails .info-link.group');
              tooltips = _.uniqueArray(tooltips);
              var main_carousel = document.querySelector(".product-images-main ul");

              if (main_carousel) {
                var previews = document.querySelector(".product-images-thumbs");
                var main_fragment = document.createDocumentFragment();
                var preview_fragment = document.createDocumentFragment();
                var index = main_carousel.querySelectorAll("li").length + 1;
                var group = main_carousel.querySelector("a").dataset.lightbox;

                for (var i = 0; i < tooltips.length; i++) {
                  var ele = this.buildImageTooltip("product-image-" + (index + i), "", tooltips[i].href, tooltips[i].href, group, tooltips[i].title, "_400x400.");
                  main_fragment.appendChild(ele);
                  var ele = this.buildImageTooltip("", "product-images-thumb", "#product-image-" + (index + i), tooltips[i].href, "", tooltips[i].title, "_130x130_crop_center.");
                  preview_fragment.appendChild(ele);
                }

                main_carousel.appendChild(main_fragment); //previews.appendChild(preview_fragment);
                //if there is a last element, we put all the product images before the last element

                if (document.querySelector(".product-images-thumb.last")) {
                  document.querySelector(".product-images-thumbs").insertBefore(preview_fragment, document.querySelector(".product-images-thumb.last"));
                } else {
                  previews.appendChild(preview_fragment);
                }
              }

              var services = document.querySelectorAll(".service-item-content-wrapper");

              if (services.length) {
                for (var i = 0; i < services.length; i++) {
                  var service_main_carousel = services[i].querySelector(".product-images-main ul");
                  var tooltips = services[i].querySelectorAll(".product-variants .info-link.group");
                  tooltips = _.uniqueArray(tooltips);
                  var previews = services[i].querySelector(".product-images-thumbs");
                  var group = services[i].querySelector(".product-images-main a");
                  group = group ? group.dataset.lightbox : "";
                  var image_size = previews.getAttribute('data-image-size') || "75x75";
                  var li_class = previews.getAttribute('data-li-class') || "product-images-thumb";

                  if (service_main_carousel) {
                    var service_id = service_main_carousel.querySelector("li a").getAttribute("data-product-image-main");
                    var index = service_main_carousel.querySelectorAll("li").length + 1;
                  }

                  var services_main_fragment = document.createDocumentFragment();
                  var preview_fragment = document.createDocumentFragment();

                  for (var j = 0; j < tooltips.length; j++) {
                    var link = tooltips[j].href;

                    if (service_main_carousel) {
                      var ele = this.buildImageTooltip("service-" + service_id + "-image-" + (index + j), "", tooltips[j].href, tooltips[j].href, group, tooltips[j].title, "_400x400.");
                      services_main_fragment.appendChild(ele);
                      link = "#service-" + service_id + "-image-" + (index + j);
                    }

                    var maybeGroup = service_main_carousel ? "" : group;
                    var ele = this.buildImageTooltip("", li_class, link, tooltips[j].href, maybeGroup, tooltips[j].title, "_" + image_size + "_crop_center.");
                    preview_fragment.appendChild(ele);
                  }

                  if (service_main_carousel) {
                    service_main_carousel.appendChild(services_main_fragment);
                  }

                  previews.appendChild(preview_fragment);
                }
              }
            };

            Carousels.prototype.buildImageTooltip = function (li_id, li_class, link, url, lightboxGroup, info_img, format_img) {
              var ele = document.createElement('li');

              if (li_id != "") {
                ele.id = li_id;
              } else {
                var arr_class = li_class.split(' ');

                for (var i = 0; i < arr_class.length; i++) {
                  ele.classList.add(arr_class[i]);
                }
              }

              if (lightboxGroup != "") {
                var str_html = '<a href="' + link.replace(/_1000x1000./g, '.') + '" data-lightbox="' + lightboxGroup + '" data-lightbox-caption="' + info_img + '">';
              } else {
                var str_html = '<a href="' + link + '">';
              }

              str_html += '<img src="' + url.replace(/_1000x1000./g, format_img) + '" alt="' + info_img + '"/></a>';
              ele.innerHTML = str_html;
              return ele;
            };

            Carousels.prototype.setCarouselWidths = function () {
              _.each(this.carousels, function (carousel) {
                carousel.itemTransition('none');
                carousel.setCarouselWidth();
                carousel.itemTransition('.3s');
              });
            };

            Carousels.prototype.create = function (carouselEle) {
              var carousel = new Carousel(carouselEle);
              this.carousels.push(carousel);
              return carousel;
            }; // Private


            Carousels.prototype._buildCarousels = function () {
              var carouselEles = document.querySelectorAll(this.carouselSelector);

              _.each(carouselEles, function (carouselEle) {
                this.create(carouselEle);
              }, this);
            };

            module.exports = Carousels;
          }, {
            "./_lib.js": 14,
            "./_mq-size.js": 18
          }],
          3: [function (require, module, exports) {
            var _ = require('./_lib.js');

            var Cookies = require('./_cookies.js');

            var ShippingDate = require('./_shipping-date.js');

            var PaidShipping = require('./_paid-shipping.js'); // // get the current language, and is use to define all the link in the correct language
            // var urlBase;
            // if(document.querySelector("html[lang]").getAttribute("lang") == "en"){
            //   urlBase = "/cart";
            // }else{
            //   urlBase = "/"+document.querySelector("html[lang]").getAttribute("lang")+"/cart";
            // }


            var CartProcessing = function CartProcessing() {
              this.ShippingDate = new ShippingDate();
              this.isCartPage = CoreInit.Template == 'cart';
              this.totalPriceProductLine = document.getElementById("total_price_product_line");
              this.totalPriceProduct = document.getElementById("total_price_product");
              this.shippingFees = document.getElementById("shipping-fees");
              this.totalPrice = document.getElementById("total_price");
              this.spanRealPrice = document.getElementById("span_real_price"); //does not exist anymore
              // this.provinceSelector = document.getElementById("data_province");
              // this.freeShippingTooltip = document.getElementById("free-shipping-tooltip");
              // this.paidShippingTooltip = document.getElementById("paid-shipping-tooltip");
              this.taxIncluded = document.querySelector(".cart-total-taxes");

              this.mustAgree = document.getElementById("product-disclaimer-you-must-agree"); //this.lowOrderAmount = document.getElementById("minimum-order-amount-message");
              //call getCart
              // if(this.isCartPage){

                //console.log("getCart called 2")
              ShopifyAPI.getCart(buildCustomsInvoice); // }

              this.init();
            }; // CartProcessing.prototype.buildCustomsInvoice = function(cart, counter){
            //This function is use to set and manage the slider (with noUIslider) value and print in the cart


            var buildCustomsInvoice = function buildCustomsInvoice(cart, counter) {
              // Retry if no $visitorCountryCode
              counter = counter || 1;

              if (counter > 1000) {
                return;
              }
              /* if (typeof theme.cache.$visitorCountryCode !== "string" || theme.cache.$visitorCountryCode === "NaN") {
                    setTimeout(buildCustomsInvoice, 100, cart, counter + 1);
                    return;
                }*/


              var currentCurrency = document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary"); // Customs Invoice Slider

              var startValue = 100;

              if (cart.attributes.customs_invoice_percentage_value != undefined) {
                startValue = cart.attributes.customs_invoice_percentage_value;
              }

              var totalPriceYen = cart.total_price,
                  customsInvoiceValue = totalPriceYen * (startValue / 100),
                  $sliders = $('.customs-invoice-slider');

              for (var length = $sliders.length, i = 0; length > i; i++) {
                var clickOnPip = function clickOnPip() {
                  var value = Number(this.getAttribute('data-value'));
                  slider.noUiSlider.set(value);
                };

                var slider = $sliders[i];

                if (typeof slider.noUiSlider !== "undefined") {
                  continue;
                }

                noUiSlider.create(slider, {
                  start: 100,
                  step: 5,
                  connect: 'lower',
                  tooltips: {
                    to: function to(value) {
                      return value.toFixed(0) + "%";
                    }
                  },
                  pips: {
                    mode: 'values',
                    values: [30, 40, 50, 60, 70, 80, 90, 100],
                    density: 25
                  },
                  range: {
                    "min": 30,
                    "max": 100
                  }
                });
                var pips = slider.querySelectorAll('.noUi-value');

                for (var i = 0; i < pips.length; i++) {
                  // For this example. Do this in CSS!
                  pips[i].style.cursor = 'pointer';
                  pips[i].addEventListener('click', clickOnPip);
                } //////////////////////////////////////////////////////////////////////////////////////


                slider.noUiSlider.on('set', function (value) {// /cart/update.js
                  // ShopifyAPI.updateCustomsInvoiceValue(value, function(){});
                });
                slider.noUiSlider.on('update', function (value) {
                  // Change color
                  // var blue = "#63A7D8";
                  // var yellow = "#F7B06B";
                  // var red = "#E56F6F";
                  // var invoiceCheckText = $("#invoice-value-check-text").text();
                  // if ($(".customs-invoice-slider")[0].noUiSlider.get() != "100.00") {
                  //     $("#invoice-value-check-text").html(invoiceCheckText.strike());
                  //     $("#invoice-value-check-text").css({ opacity: 0.2 });
                  // } else {
                  //     $("#invoice-value-check-text").html(invoiceCheckText);
                  //     $("#invoice-value-check-text").css({ opacity: 1.0 });
                  // }
                  // if (value > 66) {
                  //     $(".noUi-connect").css("background-color", blue);
                  // } else if (value > 33) {
                  //     $(".noUi-connect").css("background-color", yellow);
                  // } else {
                  //     $(".noUi-connect").css("background-color", red);
                  // }
                  for (var length = $sliders.length, i = 0; length < i; i++) {
                    var updatableSlider = $sliders[i];

                    if (updatableSlider === slider) {
                      continue;
                    }

                    updatableSlider.noUiSlider.set(value);
                  } // Adjust labels


                  if(document.getElementById("DeclaredPercentage")){
                    console.log("KS slider value", parseInt(value[0]).toString());
                    document.getElementById("DeclaredPercentage").value = parseInt(value[0]).toString();
                    document.getElementById('DeclaredPercentage').innerHTML = parseInt(value[0]).toString();
                  }


                  var totalPriceYen = cart.total_price;
                  var customsInvoiceValue = totalPriceYen * (value / 100);
                  $("#dt_total_declared").html(Currency.formatMoneyInteger(customsInvoiceValue, Currency.moneyFormats[currentCurrency]["money_with_currency_format"])); // $("#dt_total_declared").html(parseInt(_.moneying(customsInvoiceValue)));
                   // $(".customs-invoice-value").html(Currency.formatMoneyUpdateCart(customsInvoiceValue, Currency.moneyFormats[currentCurrency]["money_with_currency_format"]));
                  // $(".customs-invoice-value").html(_.moneying(customsInvoiceValue));
                  //Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
                  // Estimated Taxes
                  // var hasEstimatedTaxes = false,
                  //     currencyInvoiceValueHTML = $(".customs-invoice-value span").html(),
                  //     estimatedTaxMin, estimatedTaxMax, minValue;

                  var hasEstimatedTaxes = false,
                      currencyInvoiceValueHTML = $("#dt_total_declared").html(),
                      estimatedTaxMin,
                      estimatedTaxMax,
                      minValue; // var currencyInvoiceValue = Number(currencyInvoiceValueHTML.replace(/[^0-9\.]+/g,""));
                  // var currencyInvoiceValue = Number(currencyInvoiceValueHTML.match(/\d+[0-9\.\s\,]+/g));

                  var currencyInvoiceValue; //si valeur de currencyInvoiceValueHTML.match(/\d+[0-9\.\s\,]+/g) contient une virgule, on remplace par un point

                  currencyInvoiceValue = Number(currencyInvoiceValueHTML.match(/\d+[0-9\.\s\,]*/g)[0].replaceAll(",", "")); // var shippingCountry = document.querySelector("[data-geolocation-country]").getAttribute("data-geolocation-country");

                  var shippingCountry;

                  if (document.querySelector("#shipping-fees-country")) {
                    shippingCountry = document.querySelector("#shipping-fees-country").getAttribute("data-country");
                  } //Si pas de pays selectionne, on prend le pays de la geolocalisation


                  if (!shippingCountry) {
                    shippingCountry = document.querySelector("[data-geolocation-country]").getAttribute("data-geolocation-country");
                  }


                  /**** Get from JSON vat, duties etc for the different countries */
                  // var countryTaxJson = JSON.parse(document.querySelector('.container-fluid.cart-information-taxes').nextElementSibling.innerHTML);
                  // var countryTaxJson = JSON.parse(document.querySelector('.container-fluid.cart-information-taxes').lastElementChild.innerHTML);

                  var countryTaxJson = infoCountriesJSon; // var countryTaxJson = JSON.parse(document.querySelector('.container-fluid.cart-information-taxes').firstElementChild.lastElementChild.innerHTML);
                  // var countryTaxJson = JSON.parse(document.querySelector(".container-fluid.cart-table").lastElementChild.lastElementChild.innerHTML);

                  var perceptionFee = parseInt(countryTaxJson.tax_calculator_settings.perception_fee);
                  var defaultVat = parseInt(countryTaxJson.tax_calculator_settings.vat);
                  var defaultDuty = parseInt(countryTaxJson.tax_calculator_settings.duty);
                  var defaultOther = parseInt(countryTaxJson.tax_calculator_settings.other);

                  if ((countryTaxJson.countries[shippingCountry] && countryTaxJson.countries[shippingCountry].vat != "NA") || !countryTaxJson.countries[shippingCountry]) {
                    var countryRates = countryTaxJson.countries[shippingCountry];

                    if (countryRates) {
                      if (countryRates.vat != "NA") {
                        var countryVat = parseInt(countryRates.vat);
                      }

                      if (countryRates.duty != "NA") {
                        var countryDuty = parseInt(countryRates.duty);
                      }

                      if (countryRates.other != "NA") {
                        var countryOther = parseInt(countryRates.other);
                      }
                    }

                    var perceptionFee_converted = Currency.convert(perceptionFee, "JPY",currentCurrency);
                    var perceptionFee_converted = Math.round(perceptionFee_converted);

                    //get the cheapest shipping fee
                    //declare it there because need to wait for the shopify answer for shipping rate, and the slider does not update so it does not pass in the slider "update" on loading, but still need the value
                    var cheapest_shipping_fee =0;
                    var cheapest_fdp = document.getElementById("shipping-fees-results-price-1").getAttribute("fee-value");
                    if(cheapest_fdp){
                      cheapest_shipping_fee = Number(cheapest_fdp);
                    }

                    console.log(currencyInvoiceValue)
                    console.log(perceptionFee_converted)
                    console.log(countryVat)
                    console.log(cheapest_shipping_fee)
                    console.log(estimatedTax)                     

                    if (countryRates && countryVat) {
                      var estimatedTax = perceptionFee_converted + (currencyInvoiceValue * countryVat) + (currencyInvoiceValue * countryDuty) + (currencyInvoiceValue * countryOther);
                      estimatedTax += cheapest_shipping_fee*countryVat;
                    } //Only for the US at this time (July 2020)
                    else if (countryVat) {
                      var estimatedTax = perceptionFee_converted + (currencyInvoiceValue * countryVat)
                      estimatedTax += cheapest_shipping_fee*countryVat;
                    } //if country does not exists in JSON, default values
                    else {
                        var estimatedTax = perceptionFee_converted + (currencyInvoiceValue * defaultVat) + (currencyInvoiceValue * defaultDuty) + (currencyInvoiceValue * defaultOther);
                        estimatedTax += cheapest_shipping_fee*defaultVat;
                    } //Add text VAT, DUTY and OTHER in the span depending on their value (default or not)


                    if (countryVat) {
                      $("#dt_vat_rate").html(countryVat + "%");
                    } else {
                      $("#dt_vat_rate").html(defaultVat + "%");
                    }

                    if (countryDuty || countryDuty == 0) {
                      $("#dt_duties_rate").html(countryDuty + "%");
                    } else {
                      $("#dt_duties_rate").html(defaultDuty + "%");
                    }

                    if (countryOther) {
                      $("#dt_other_rate").html(countryOther + "%");
                    } else {
                      $("#dt_other_rate").html(defaultOther + "%");
                    } // $("#dt_selected_country").html(document.querySelector("[data-geolocation-country]").getAttribute("data-geolocation-country"));


                    var shippingCountryTraduction = document.querySelector('#country_selector option[value="' + shippingCountry + '"]');

                    if (shippingCountry) {
                      $("#dt_selected_country").html(shippingCountryTraduction.innerHTML);
                    } else {
                      $("#dt_selected_country").html(document.querySelector("[data-geolocation-country]").getAttribute("data-geolocation-country"));
                    }
                  } // if (document.querySelector("[data-geolocation-country]").getAttribute("data-geolocation-country") === "France") {
                  //     minValue        = 22;
                  //     estimatedTaxMin = 0.17;
                  //     //estimatedTaxMin = 0.17;
                  //     // estimatedTaxMax = 0.22;
                  //     //estimatedTaxMax = 0.22;
                  // } else if (document.querySelector("[data-geolocation-country]").getAttribute("data-geolocation-country") === "Japan") {
                  //     minValue        = 20;
                  //     estimatedTaxMin = 0.5;
                  //     // estimatedTaxMax = 0.25;
                  // } else {
                  //     minValue        = 0;
                  //     estimatedTaxMin = 0.17;
                  //     // estimatedTaxMax = 0.25;
                  // }


                  // if NA, don't display the tax
                  if (countryTaxJson.countries[shippingCountry] && countryTaxJson.countries[shippingCountry].vat == "NA") {
                    //$(".estimated-import-fees-tilde").css("display", "none");
                    // $("#dt_estimated_taxes").css("display","none");
                    $('.container-fluid.cart-information-taxes').css("display", "none"); // $(".estimated-import-fees").css("display", "none");
                    // $(".estimated-import-fees-min").css("display", "none");
                    //$(".estimated-import-fees-max").html(Shopify.formatMoney(0, Shopify.moneyFormat));
                  } else {
                    //Total taxes = perception fee + (Total declared x vat) + (total declared x duty) + (total declared x other)
                    // var estimatedImportFeesMin = customsInvoiceValue * estimatedTax;
                    // var estimatedImportFeesMax = customsInvoiceValue * estimatedTaxMax;
                    //$(".estimated-import-fees-tilde").css("display", "inline");
                    // $(".estimated-import-fees").css("display", "inline");
                    //$(".estimated-import-fees-min").css("display", "inline");
                    $('.container-fluid.cart-information-taxes').css("display", "block");
                    $("#dt_estimated_taxes").css("display", "inline");
                    $("#dt_estimated_taxes").html(Currency.formatMoneyInteger(estimatedTax, Currency.moneyFormats[currentCurrency]["money_with_currency_format"])); //Puts inside CustomsEstimate, the value we got from estimated_taxes, withtout the monetary symbol
                    // si vaut
                    // document.getElementById('CustomsEstimate').value = Number(document.querySelector("#dt_estimated_taxes").innerHTML.match(/\d+[0-9\.\s\,]+/g));
                    // * 100 ==> pour prendre en compte comment shopify calcul apres
                    // * 100 ==> to take into account how Shopify compute the prices

                    document.getElementById('CustomsEstimate').value = Number(document.querySelector("#dt_estimated_taxes").innerHTML.match(/\d+[0-9\.\s\,]*/g)[0].replace(',', "")) * 100;
                    document.getElementById('CustomsEstimate').innerHTML = document.getElementById('CustomsEstimate').value * 100;
                     //Puts inside DecalredAmount, the value we got from total_declared, withtout the monetary symbol
                    // document.getElementById('DeclaredAmount').value = Number(document.querySelector("#dt_total_declared").innerHTML.match(/\d+[0-9\.\s\,]+/g));

                    // document.getElementById('DeclaredAmount').value = Number(document.querySelector("#dt_total_declared").innerHTML.match(/\d+[0-9\.\s\,]*/g)[0].replace(',', "")) * 100;
                    // document.getElementById('DeclaredAmount').innerHTML = document.getElementById('DeclaredAmount').value * 100;

                    //Puts the declared amount in Yen (shopify format) - easier to manipulate the data with MTA afterwards
                    //ceil the amount to avoid some errors with the cents
                    var ceilAmountInYen = Math.ceil(Currency.convert(customsInvoiceValue, currentCurrency, "JPY"));
                    document.getElementById("DeclaredAmount").value = ceilAmountInYen;
                    document.getElementById('DeclaredAmount').innerHTML = ceilAmountInYen;

                    if (!countryOther || countryOther == "NA" || countryOther == "0") {
                      $(".customs-invoice-results-method-other").css("display", "none");
                    } else {
                      $(".customs-invoice-results-method-other").css("display", "inline");
                    } //  $(".estimated-import-fees").html(Currency.formatMoneyInteger(estimatedTax, Currency.moneyFormats[currentCurrency]["money_with_currency_format"]));
                    //$(".estimated-import-fees-min").html(Shopify.formatMoney(estimatedImportFeesMin, Shopify.moneyFormat));
                    // $(".estimated-import-fees-max").html(Shopify.formatMoney(estimatedImportFeesMax, Shopify.moneyFormat));

                    if(countryTaxJson.countries[shippingCountry] && countryTaxJson.countries[shippingCountry].special_info){
                      document.getElementById("country-customs-declaration-info").innerHTML = countryTaxJson.countries[shippingCountry].special_info[laLang]
                    }else{
                      document.getElementById("country-customs-declaration-info").innerHTML = ""
                    }

                  } //Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());

                });
              }

              ; // $(".customs-invoice-value").html(Currency.formatMoneyInteger(customsInvoiceValue, Currency.moneyFormats[currentCurrency]["money_with_currency_format"]));
            };

            if (typeof ShopifyAPI === 'undefined') {
              ShopifyAPI = {};
            } //called with buildCustomsInvoice as a parameter


            ShopifyAPI.getCart = function (callback) {
              jQuery.getJSON('/cart.js', function (cart, textStatus) {
                //console.log("ShopifyAPI.getCart cart", cart);
                if (typeof callback === 'function') {
                  //console.log("pass in callback");
                  callback(cart);
                } else {
                  ShopifyAPI.onCartUpdate(cart);
                }
              });
            };

            CartProcessing.prototype.init = function () {
              this.initQuantity();
              this.initShipping();
              this.initPrice();

              if (this.isCartPage && document.getElementById('cart-product-disclaimer') && 'true' == 'true') {
                this.initDisclaimers();
              }

              this.specialOfferEnable = 'false' == 'true'; //Update 2020/03/17 -----> on update only if hasshipping

              if (this.specialOfferEnable && this.isCartPage && CartProductsData.hasshipping) {
                this.initOffers();
              } else if (CartProductsData.cleanOffers.length || !CartProductsData.hasshipping) {
                this.cleanOffers(); //Update 4 Mai 2020 --> prevent showing special offers if no shipping

                if (document.getElementById("specialoffer")) {
                  document.getElementById("specialoffer").style.display = 'none';
                }
              } // this.provinceSelector does not exists anymore
              // if (this.provinceSelector) {
              //   this.handleProvinceSelector();
              // }

              //insert taxes value at the bottom of the page
              if (this.isCartPage && Object.keys(CartProductsData.products).length > 0  && CartProductsData.hasshipping){
                var total = parseInt(this.totalPriceProduct.dataset.amount);
                this.taxIncluded.innerHTML = _.moneying(this.getIncludedTax(total));
              }

              /***
               * Needed to print this disclaimer on load
               */

              var request = new XMLHttpRequest();
              request.open('GET', '/cart.js');
              request.setRequestHeader("Cache-Control", "no-cache");
              request.send();
              request.onreadystatechange = function () {
                if (request.readyState == 4 && request.status == 200) {
                  var response = JSON.parse(request.responseText);
                  if (response) {
                    var shipped_products = document.querySelectorAll('[data-shipping]'); // Disable cart if order total < 3,000 YEN and products require shipping

                    var quotation_products_price = 0;
                    var real_products_price = 0;
                    var quotation_products_count = 0;

                    for (i = 0; i < shipped_products.length; i++) {
                      var line = CartProductsData.products[shipped_products[i].dataset.lineId];
                      var item = response.items[line - 1];
                      real_products_price += item.line_price;

                      if (!shipped_products[i].getAttribute('isDiscounted')) {
                        quotation_products_price += item.line_price;
                        quotation_products_count += item.quantity;
                      }
                    }
                    var cartQuotationInfo = document.getElementById("cart-quotation-info");
                    if('200000' != '' && cartQuotationInfo){
                      var default_currency = document.querySelector('[data-currency]').getAttribute("data-currency");
                      var real_minimum_order = Math.floor(Currency.convert('20000000',default_currency,Currency.currentCurrency));
                      // Indicate discount if cart > minimum discount setting and more than 5 tangible items requiring shipping
                      //also need to check weight to be coherent with liquid
                      var minweight_for_discount = '0';
                      var cart_total_weight = response.total_weight;
                      if(quotation_products_count>5 && quotation_products_price >= parseInt(real_minimum_order) && minweight_for_discount != 0 && cart_total_weight > minweight_for_discount){
                        cartQuotationInfo.classList.remove('display_none');
                      }
                      else{
                        cartQuotationInfo.classList.add('display_none');
                      }
                    }
                  }
                }
              }

            };

            CartProcessing.prototype.getMaxShippingDate = function () {
              var maxShippingDate = {
                "days": 0,
                "date": new Date()
              };

              for (key in CartProductsData.shippingDates) {
                var shipInfo = this.ShippingDate.getShippingDaysAndDate(key);
                if (maxShippingDate.date < shipInfo.date) {
                  maxShippingDate.date = shipInfo.date;
                  maxShippingDate.days = shipInfo.days;
                }
              }

              return maxShippingDate;
            };

            CartProcessing.prototype.updateShippingDate = function () {
              var maxShippingDate = this.getMaxShippingDate();

              if (document.getElementById("EstimatedShippingDateFormat")) {
                this.ShippingDate.insertShippingDateInHTML("EstimatedShippingDateFormat", maxShippingDate, "date");
                this.ShippingDate.insertShippingDateInHTML("ShippingDate", maxShippingDate, "short");
              }

              if ('true' == "true" || 'true' == "true") {
                var deliveryDate = new Date(maxShippingDate.date);
                deliveryDate.setDate(deliveryDate.getDate() + 2);
                var ddlDate = document.getElementById("ddlDate");
                //if ddlDate is already populated (should be), delete all then reconstruct it in the for below
                if(ddlDate){
                  if (ddlDate.hasChildNodes){
                    while (ddlDate.children[1]) {
                        ddlDate.removeChild(ddlDate.children[1]);
                    }
                  }

                  var days = [translationJSon.javascript.dates.abbr_day_names[laLang].sunday, translationJSon.javascript.dates.abbr_day_names[laLang].monday, translationJSon.javascript.dates.abbr_day_names[laLang].tuesday, translationJSon.javascript.dates.abbr_day_names[laLang].wednesday, translationJSon.javascript.dates.abbr_day_names[laLang].thursday, translationJSon.javascript.dates.abbr_day_names[laLang].friday, translationJSon.javascript.dates.abbr_day_names[laLang].saturday]; // var date_format = '%m/%d/%Y';

                  var date_format = translationJSon.javascript.dates.short[laLang];

                  for (var i = 0; i < 12; i++) {
                    var option = document.createElement("option");
                    option.text = date_format.replace('%m', (deliveryDate.getMonth() < 9 ? "0" : "") + (deliveryDate.getMonth() + 1)).replace('%d', (deliveryDate.getDate() < 10 ? "0" : "") + deliveryDate.getDate()) + ' (' + days[deliveryDate.getDay()] + ')';
                    option.value = (deliveryDate.getDate() < 10 ? "0" : "") + deliveryDate.getDate() + "/" + (deliveryDate.getMonth() < 9 ? "0" : "") + (deliveryDate.getMonth() + 1) + "/" + deliveryDate.getFullYear();
                    ddlDate.add(option);
                    deliveryDate.setDate(deliveryDate.getDate() + 1);
                  }
                }//fin if ddldate

              }


            };

            CartProcessing.prototype.handleProvinceSelector = function () {// var _this = this;
              // if(Cookies.hasItem("japanProvince")){
              //   var province = Cookies.getItem("japanProvince");
              //   _this.provinceSelector.value = province;
              //   var option = _this.provinceSelector.selectedOptions[0];
              //   var zip_code = option.getAttribute("data-province-zip");
              //   _this.getProvinceShippingFee(province, zip_code, function(){
              //     var shipping_rates = JSON.parse(this.responseText).shipping_rates;
              //     if(shipping_rates.length){
              //       var fees = shipping_rates[0].price;
              //       _this.updateShippingFeeAndTotalPrice(province, fees);
              //     }
              //   });
              // }
              // _this.provinceSelector.addEventListener('change', function() {
              //   var province = this.value;
              //   var expiryDate = new Date();
              //   expiryDate.setFullYear(expiryDate.getFullYear() + 1);
              //   Cookies.setItem("japanProvince", province, expiryDate, '/');
              //   var option = this.selectedOptions[0];
              //   var zip_code = option.getAttribute("data-province-zip");
              //   _this.getProvinceShippingFee(province, zip_code, function(){
              //     var shipping_rates = JSON.parse(this.responseText).shipping_rates;
              //     if(shipping_rates.length){
              //       var fees = shipping_rates[0].price;
              //       _this.updateShippingFeeAndTotalPrice(province, fees);
              //     }
              //   });
              // });
            }; //Only called if province selector (which does not exists like the other site now)


            CartProcessing.prototype.updateShippingFeeAndTotalPrice = function (province, fees) {
              // if (fees == 0) {
              //   var total = parseInt(this.totalPriceProduct.dataset.amount);
              //   _this.shippingFees.innerHTML = translationJSon.javascript.expedition_free[laLang];
              //   // this.shippingFees.innerHTML = "Free";
              //   this.totalPrice.innerHTML = _.moneying(total);
              //   //this.totalPrice.innerHTML = total;
              //   //this.taxIncluded.innerHTML =this.getIncludedTax(total)
              //   this.taxIncluded.innerHTML = _.moneying(this.getIncludedTax(total));
              //   this.paidShippingTooltip.classList.add("display_none");
              //   this.freeShippingTooltip.classList.remove("display_none");
              // } else {
              //   var total = parseInt(this.totalPriceProduct.dataset.amount)+parseInt(fees)*100;
              //   this.shippingFees.innerHTML = _.moneying(fees*100);
              //   this.totalPrice.innerHTML = _.moneying(total);
              //   this.taxIncluded.innerHTML = _.moneying(this.getIncludedTax(total));
              //   this.paidShippingTooltip.innerHTML = province == "Okinawa" ? translationJSon.javascript.okinawa_paid_shipping_tooltip_html[laLang] : translationJSon.javascript.paid_shipping_tooltip_html[laLang];
              //   // this.paidShippingTooltip.innerHTML = province == "Okinawa" ? "Translation missing: en.cart.summary.okinawa_paid_shipping_tooltip_html" : "Translation missing: en.cart.summary.paid_shipping_tooltip_html";
              //   this.paidShippingTooltip.classList.remove("display_none");
              //   this.freeShippingTooltip.classList.add("display_none");
              // }
            };

            CartProcessing.prototype.getProvinceShippingFee = function (province, zip_code, callback) {// var ajax = new XMLHttpRequest();
              // ajax.addEventListener('load', callback);
              // ajax.open("get", urlBase+"/shipping_rates.json?shipping_address%5Bzip%5D="+zip_code+"&shipping_address%5Bcountry%5D=Japan&shipping_address%5Bprovince%5D="+province, true);
              // ajax.send();
            };

            CartProcessing.prototype.initShipping = function () {
              if (this.isCartPage && Object.keys(CartProductsData.shippingDates).length > 0 && CartProductsData.hasshipping) {
                var maxShippingDate = this.getMaxShippingDate();

                if (document.getElementById("EstimatedShippingDateFormat")) {
                  this.ShippingDate.insertShippingDateInHTML("EstimatedShippingDateFormat", maxShippingDate, "date");
                  this.ShippingDate.insertShippingDateInHTML("ShippingDate", maxShippingDate, "short");
                }

                if ('true' == "true" || 'true' == "true") {
                  var deliveryDate = new Date(maxShippingDate.date);
                  deliveryDate.setDate(deliveryDate.getDate() + 2);
                  var ddlDate = document.getElementById("ddlDate"); // translationJSon.javascript.abbr_day_names[laLang].sunday
                  // var days = ['Translation missing: en.shopify.dates.abbr_day_names.sunday',
                  //            'Translation missing: en.shopify.dates.abbr_day_names.monday',
                  //            'Translation missing: en.shopify.dates.abbr_day_names.tuesday',
                  //            'Translation missing: en.shopify.dates.abbr_day_names.wednesday',
                  //            'Translation missing: en.shopify.dates.abbr_day_names.thursday',
                  //            'Translation missing: en.shopify.dates.abbr_day_names.friday',
                  //            'Translation missing: en.shopify.dates.abbr_day_names.saturday'];

                  var days = [translationJSon.javascript.dates.abbr_day_names[laLang].sunday, translationJSon.javascript.dates.abbr_day_names[laLang].monday, translationJSon.javascript.dates.abbr_day_names[laLang].tuesday, translationJSon.javascript.dates.abbr_day_names[laLang].wednesday, translationJSon.javascript.dates.abbr_day_names[laLang].thursday, translationJSon.javascript.dates.abbr_day_names[laLang].friday, translationJSon.javascript.dates.abbr_day_names[laLang].saturday]; // var date_format = '%m/%d/%Y';

                  var date_format = translationJSon.javascript.dates.short[laLang];

                  for (var i = 0; i < 12; i++) {
                    var option = document.createElement("option");
                    option.text = date_format.replace('%m', (deliveryDate.getMonth() < 9 ? "0" : "") + (deliveryDate.getMonth() + 1)).replace('%d', (deliveryDate.getDate() < 10 ? "0" : "") + deliveryDate.getDate()) + ' (' + days[deliveryDate.getDay()] + ')';
                    option.value = (deliveryDate.getDate() < 10 ? "0" : "") + deliveryDate.getDate() + "/" + (deliveryDate.getMonth() < 9 ? "0" : "") + (deliveryDate.getMonth() + 1) + "/" + deliveryDate.getFullYear();
                    ddlDate.add(option);
                    deliveryDate.setDate(deliveryDate.getDate() + 1);
                  }
                }
              } //if('' == "true"){


              if (CartProductsData.hasshipping) {
                var shipping_fees_country = document.getElementById("shipping-fees-country");

                var _this = this; //Test if the cart is empty


                if (shipping_fees_country) {
                  shipping_fees_country.addEventListener('change', function () {
                    //console.log("called updatetotalPrice 2")
                    _this.updateTotalPrice();

                    _this.updateCountryInfo(shipping_fees_country.getAttribute('data-country'));
                  });
                  var selectProvince = document.getElementById("address_province");
                  selectProvince.addEventListener('change', function () {
                    //console.log("called updatetotalPrice 3")
                    _this.updateTotalPrice();
                  });
                  var addressZIP = document.getElementById("address_zip");
                  addressZIP.addEventListener('change', function () {
                    //console.log("called updatetotalPrice 4")
                    _this.updateTotalPrice();
                  });
                  var countrySelector = document.getElementById("country_selector");
                  countrySelector.addEventListener('change', function(){
                    //when changing country, need to check if needed to remove oversized fee item (if switching to japan) or add it (switching from japan to overseas)
                    jQuery.getJSON('/cart.js', function (cart){
                      _this.checkOversized(cart);
                    });
                  });

                  if (Cookies.hasItem("cookieCountry")) {
                    var country_value = Cookies.getItem("cookieCountry"); //change data-default to get automatically the province list if there is any in this country

                    if (document.querySelector("#country_selector")) document.querySelector("#country_selector").setAttribute("data-default", country_value); // var country_option = document.querySelector('#sidebar-tools-country option[value="' + country_value + '"]');
                    //country can be equal to '---' if old cookies, prevent site error with this
                    if(country_value != "---"){
                      var country_option = document.querySelector('#country_selector option[value="' + country_value + '"]');
                      shipping_fees_country.innerHTML = country_option ? country_option.text : country_value;
                      shipping_fees_country.setAttribute('data-country', country_value); //recup si zip
                    }else{
                      //if country equal ---, we take the first option available in the select
                      var country_option = document.querySelector('#country_selector option[value="' + document.querySelector("#country_selector option").value + '"]');
                      shipping_fees_country.innerHTML = country_option ? country_option.text : country_value;
                      shipping_fees_country.setAttribute('data-country', country_value); //recup si zip
                    }

                    if (Cookies.hasItem("cookieZip")) {
                      var zip_value = Cookies.getItem("cookieZip");
                      document.querySelector("#address_zip").value = zip_value;
                    }

                    setTimeout(function () {
                      //console.log("called updatetotalPrice 5")
                      _this.updateTotalPrice();
                    }, 100);
                    this.updateCountryInfo(country_value);
                  } // //CREATE PROVINCE SELECTOR
                  // var cps = new Shopify.CountryProvinceSelector("country_selector","address_province", {
                  //   hideElement: 'address_zip'
                  // });

                }
              } //}

            };

            CartProcessing.prototype.updateCountryInfo = function (country_name) {
              _.each(document.querySelectorAll("[data-taxe-country]"), function (info) {
                if (info.dataset.taxeCountry == country_name) {
                  info.classList.remove('display_none');
                } else {
                  info.classList.add('display_none');
                }
              });
            };

            CartProcessing.prototype.updateTotalPrice = function () {
              // if('' == "true"){
              if (CartProductsData.hasshipping) {
                // if (document.getElementById("shipping-fees-country").getAttribute('data-country') && document.getElementById("shipping-fees-country").getAttribute('data-country')!="null"){
                var countrySelected = document.getElementById("shipping-fees-country").getAttribute('data-country');
                var countrySelectedTranslated = document.getElementById("shipping-fees-country").innerHTML; // }else {
                //   var countrySelected = "---";
                // }
                // Parsing country selector data-province and selecting first province automatically. Possible future improvement: add a province selector (and zip code field) directly on the website.
                // var countryProvinceList = JSON.parse(document.getElementById("sidebar-tools-country").querySelector('[value="'+countrySelected+'"]').getAttribute('data-provinces'));
                // var countryProvinceList = JSON.parse(document.querySelector('#country_selector option[value="'+countrySelected+'"]').getAttribute('data-provinces'));
                // if(countryProvinceList.length > 0){
                //     var countryProvince = countryProvinceList[0][0];
                // }
                // var countryProvinceList = document.getElementById("address_province");

                var countryProvince = "";
                var countryProvinceList = document.getElementById("address_province");
                countryProvince = countryProvinceList.value;
                var zip = "";

                if (document.querySelector("#address_zip").value != "") {
                  zip = document.querySelector("#address_zip").value;
                }

                var ddlDate = document.getElementById("ddlDate");
                var dlTime = document.querySelector("#DeliveryTime");
                if (countrySelected == "Japan") {
                  //useful to compute the rates. If Japan, we do not show the zip input, so we have to fill it with a bogus to no get an error for the shipping_rates
                  zip = "111-1111";
                }

                if(this.isCartPage){
                  if (countrySelected == "Japan") {
                    ddlDate.setAttribute("name","attributes[DeliveryDay]");
                    dlTime.setAttribute("name","attributes[DeliveryTime]");
                  }else{
                    ddlDate.setAttribute("name","");
                    dlTime.setAttribute("name","");
                  }
                }
              } // this.paidShippingTooltip.classList.remove("display_none");


              var ajax = new XMLHttpRequest();
              _this = this;
              ajax.addEventListener('load', function (e) {
                var shipping_rates = JSON.parse(this.responseText).shipping_rates;
                console.log("shipping_rates",shipping_rates);

                if (shipping_rates) {
                  if (_this.isCartPage) {
                    var fees = Currency.convert(shipping_rates[0].price, shipping_rates[0].currency ,Currency.currentCurrency).toFixed(2);
                    document.querySelector(".shipping-fees-results-wrapper.table-wrapper").classList.add("display_none"); //we reset the errors - will be display again if they re appear --
                    //if shipping rate to print we remove the first row of the table
                    document.getElementById("shipping-fees-results-0").classList.add("display_none"); //add display_none for the errors

                    document.getElementById("shipping-fees-results-errors").classList.add("display_none");
                    document.getElementById("shipping-fees-results-error-province").classList.add("display_none");
                    document.getElementById("shipping-fees-results-error-zip").classList.add("display_none");
                    document.getElementById("shipping-fees-results-error-other").classList.add("display_none"); //remove display_none for the shipping table

                    document.getElementById("loading-spinner").classList.remove("display_none");
                    document.body.prepend(Object.assign(document.createElement('div'),{id:"layer", style:"width:100%;height:100%;position:absolute;z-index:9999"}));
                    //if oda already checked, no need to recheck
                    if (document.querySelector("#country_selector") && ["","---","Japan"].indexOf(document.querySelector("#country_selector").value) == -1){
                      var get_oda = new XMLHttpRequest();

                      get_oda.addEventListener('load', function (e) {
                        //do stuff if oda or not
                        _this.fillShippingFeesResults(shipping_rates);
                        var fedex_included = true;
                        var jpost_available = false;
                        var fedex_exists = false;
                        for (var i = 0; i < 5; i++) {
                          if(i<shipping_rates.length){
                            //console.log("shipping_rates[i]",shipping_rates[i]);

                            if(shipping_rates[i].presentment_name.toLowerCase().indexOf("fedex") != -1){
                              fedex_exists = true;
                            }
                            if(shipping_rates[i].presentment_name.toLowerCase().indexOf("fedex express shipping") != -1){
                              fedex_included = false;
                            }
                            if(shipping_rates[i].presentment_name.toLowerCase().indexOf("japan post ems") != -1){
                              jpost_available = true;
                            }
                          }
                        }
                        document.getElementById("disc_jpost_oda").classList.add("display_none");
                        document.getElementById("disc_fedex_oda_included").classList.add("display_none");
                        document.getElementById("disc_fedex_oda_later").classList.add("display_none");
                        document.getElementById("disc_dhl_oda").classList.add("display_none");
                        document.getElementById("loading-spinner").classList.add("display_none");
                        if(document.getElementById("layer")){
                          document.getElementById("layer").remove();
                        }
                        var oda_answer = JSON.parse(this.responseText)
                        var is_fedex_oda = oda_answer.fedex_oda;
                        var is_dhl_oda = oda_answer.dhl_oda;
                        //console.log("oda answer", oda_answer)
                        // if one of them is oda, loop through all the div
                          all_disclaimer_oda = document.querySelectorAll(".disclaimer-oda");
                        if((is_fedex_oda && fedex_exists) || is_dhl_oda){
                          all_disclaimer_oda.forEach(function(disclaimer_div){
                            disclaimer_div.classList.remove("display_none");
                            disclaimer_div.style.display = "block";
                          });
                          if(jpost_available){
                            document.getElementById("disc_jpost_oda").classList.remove("display_none");
                          }
                          if(is_fedex_oda && fedex_exists){
                            //console.log("fedex_exists",fedex_exists);
                            if(fedex_included){
                              document.getElementById("disc_fedex_oda_included").classList.remove("display_none");
                              document.getElementById("disc_fedex_oda_later").classList.add("display_none");
                            }else{
                              document.getElementById("disc_fedex_oda_later").classList.remove("display_none");
                              document.getElementById("disc_fedex_oda_included").classList.add("display_none");
                            }
                          }
                          if(is_dhl_oda){
                            document.getElementById("disc_dhl_oda").classList.remove("display_none");
                          }
                        }else{
                          all_disclaimer_oda.forEach(function(disclaimer_div){
                            disclaimer_div.classList.add("display_none");
                            disclaimer_div.style.display = "none";
                          });
                          document.getElementById("disc_jpost_oda").classList.add("display_none");
                          document.getElementById("disc_fedex_oda_included").classList.add("display_none");
                          document.getElementById("disc_fedex_oda_later").classList.add("display_none");
                          document.getElementById("disc_dhl_oda").classList.add("display_none");
                        }
                        if(slider[0].noUiSlider){
                          slider[0].noUiSlider.destroy();
                          ShopifyAPI.getCart(buildCustomsInvoice);
                        }
                      });

                      get_oda.open("GET", "apps/prapp?country="+document.querySelector("#country_selector").value+"&zip="+document.querySelector("#address_zip").value, true)

                      get_oda.send();
                    }else{
                      all_disclaimer_oda = document.querySelectorAll(".disclaimer-oda");
                      all_disclaimer_oda.forEach(function(disclaimer_div){
                        disclaimer_div.classList.add("display_none");
                        disclaimer_div.style.display = "none";
                      });
                      _this.fillShippingFeesResults(shipping_rates);
                      _this.shippingFees.innerHTML = _.moneying(fees*100);
                      _this.totalPrice.innerHTML = _.moneying(parseInt(_this.totalPriceProduct.dataset.amount,10)+parseInt(fees,10)*100);
                      if('' != ''){
                        _this.spanRealPrice.innerHTML = _this.totalPrice.querySelector('span.money').getAttribute('data-currency-'+ CoreInit.ShopCurrency.toLowerCase());
                      }
                    }

                  }else{
                    _this.fillShippingFeesResults(shipping_rates);
                  }
                  // document.getElementById("shipping-fees").classList.remove("display_none");
                  // document.getElementById("shipping-fees-country-edit").classList.add("display_none");

                  // if (shipping_rates.length) {
                  //   var fees = shipping_rates[0].price;
                  //   var feesName = shipping_rates[0].name;

                  //   if (fees != 0) {
                  //     _this.shippingFees.innerHTML = _.moneying(fees * 100); // console.log("update total price fees",fees);

                  //     _this.totalPrice.innerHTML = _.moneying(parseFloat(_this.totalPriceProduct.dataset.amount, 10) + parseFloat(fees, 10) * 100);
                  //   } //fin if fees != 0
                  //   else {
                  //       _this.shippingFees.innerHTML = translationJSon.javascript.expedition_free[laLang]; //_this.shippingFees.innerHTML = "Free";
                  //       // _this.paidShippingTooltip.classList.add("display_none");

                  //       _this.totalPrice.innerHTML = _this.totalPriceProduct.innerHTML;
                  //     } //fin else if fees != 0


                  //   if (shipping_rates.length >= 1) {
                  //     var currentCurrency = document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary");

                  //     if (document.querySelector(".shipping-fees-results.table-stripes")) {
                  //       document.querySelector(".shipping-fees-results.table-stripes").style.display = "table";
                  //     }

                  //     if (_this.isCartPage) {
                  //       for (var i = 0; i < 5; i++) {
                  //         if (i < shipping_rates.length) {
                  //           //if it was not display before, we force it

                  //           document.getElementById("shipping-fees-results-" + [i + 1]).classList.remove("display_none");
                  //           document.getElementById("shipping-fees-results-name-" + [i + 1]).innerHTML = shipping_rates[i].presentment_name;

                  //           if (currentCurrency != "JPY") {
                  //             document.getElementById("shipping-fees-results-price-" + [i + 1]).innerHTML = Currency.formatMoneyUpdateCart(shipping_rates[i].price, Currency.moneyFormats[currentCurrency]["money_with_currency_format"]); // document.getElementById("shipping-fees-results-price-"+[i+1]).innerHTML = _.moneying(parseFloat(shipping_rates[i].price));
                  //             document.getElementById("shipping-fees-results-price-" + [i + 1]).setAttribute("fee-value",shipping_rates[i].price);
                  //           } else {
                  //             document.getElementById("shipping-fees-results-price-" + [i + 1]).innerHTML = "&#165;" + shipping_rates[i].price;
                  //             document.getElementById("shipping-fees-results-price-" + [i + 1]).setAttribute("fee-value",shipping_rates[i].price);
                  //           }
                  //         } else {
                  //           // document.getElementById("shipping-fees-results-"+[i+1]).style.display = "none";
                  //           //do not show the row if there is no value to show
                  //           document.getElementById("shipping-fees-results-" + [i + 1]).classList.add("display_none");
                  //         }
                  //       }
                  //     }
                  //   }
                  // } //end if shipping_rates.length
                  // else {
                  //   _this.shippingFees.innerHTML = translationJSon.javascript.non_applicable_short[laLang]; //_this.shippingFees.innerHTML = "";

                  //   _this.totalPrice.innerHTML = _this.totalPriceProduct.innerHTML; //on enleve l'affichage du tableau ?

                  //   if (_this.isCartPage) {
                  //     document.getElementById("shipping-fees-results-" + [1]).classList.remove("display_none");
                  //     document.getElementById("shipping-fees-results-name-" + [1]).innerHTML = translationJSon.javascript.no_expedition[laLang];
                  //     document.getElementById("shipping-fees-results-price-" + [1]).innerHTML = "";
                  //     for (var i = 1; i < 5; i++) {
                  //       document.getElementById("shipping-fees-results-" + [i + 1]).classList.add("display_none");
                  //     }
                  //   }
                  // }
                } //end if shipping_rates
                //No shipping_rates, so there is an error
                else {
                    //if country error (equal to ---)
                    var errCountry = JSON.parse(this.responseText).country;
                    var txtCountry = "";
                    var errProvince = JSON.parse(this.responseText).province;
                    var txtProvince = "";
                    var errZip = JSON.parse(this.responseText).zip;
                    var txtZip = "";
                    //si erreur, on reaffiche le country selector, car pas de prix a afficher

                    //if no shipping rate, remove the first fee price from the list, because we use this shipipng value to compute taxes
                    if(document.getElementById("shipping-fees-results-price-1")){
                    	document.getElementById("shipping-fees-results-price-1").removeAttribute("fee-value");
                    }

                    //if error, we display the country selector, because there is no price to show

                    document.getElementById("shipping-fees-country-edit").classList.remove("display_none");
                    document.getElementById("shipping-fees").classList.add("display_none"); //remove display_none sur la div des erreurs. Affiche les divs suivant les erreurs retournées
                    //remove display_none on the error div. We show the div depending on the error we got

                    if (_this.isCartPage) {
                      //display errors tag
                      document.querySelector("#shipping-fees-results-errors").classList.remove("display_none"); //add display_none for the shipping table

                      document.querySelector(".shipping-fees-results-wrapper.table-wrapper").classList.add("display_none"); //we reset the errors - will be display again if they re appear --
                      //prevent a display error if we change the country and we got different errors than before

                      document.getElementById("shipping-fees-results-error-province").classList.add("display_none");
                      document.getElementById("shipping-fees-results-error-zip").classList.add("display_none");
                      document.getElementById("shipping-fees-results-error-other").classList.add("display_none");
                    }

                    if (errCountry && _this.isCartPage) {
                      //display span error country
                      txtCountry = document.getElementById("country_selector").getAttribute("data-default") + " " + errCountry[0];
                      document.getElementById("shipping-fees-results-error-other").classList.remove("display_none");
                      document.querySelector("#shipping-fees-results-error-other").innerHTML = txtCountry;
                    } else {
                      if (errProvince || errZip) {
                        //Province error
                        if (errProvince && _this.isCartPage) {
                          //display span error province
                          document.getElementById("shipping-fees-results-error-province").classList.remove("display_none");

                          document.querySelector("#shipping-fees-results-error-province .selected-country-name").innerHTML = countrySelectedTranslated;
                        } //Zip error


                        if (errZip && _this.isCartPage) {
                          //display span error zip
                          txtZip = "Zip :" + errZip;
                          document.getElementById("shipping-fees-results-error-zip").classList.remove("display_none");

                          document.querySelector("#shipping-fees-results-error-zip  .selected-country-name").innerHTML = countrySelectedTranslated;
                        }
                      } else {
                        //OLther errors
                        if (_this.isCartPage) {
                          document.getElementById("shipping-fees-results-error-other").classList.remove("display_none");
                          document.querySelector("#shipping-fees-results-error-other").innerHTML = this.responseText;
                        }
                      }
                    }

                    _this.totalPrice.innerHTML = _.moneying(parseFloat(_this.totalPriceProduct.dataset.amount,10));

                    //because of loading, check disclaimer again so that america's checkbox does not appear
                  _this.displayDisclaimers();
                  _this.handleDisclaimer(); //necessary if australia or canada was selected before, need to recheck
                } //end else
                if(_this.isCartPage && $('.customs-invoice-slider')[0].noUiSlider) {
                  $('.customs-invoice-slider')[0].noUiSlider.set(document.querySelector(".noUi-handle.noUi-handle-lower").getAttribute('aria-valuenow'));
                }
              }); //end ajax addEventListener

              //fail safe, check if div exists before changing the attribute
              if (document.querySelector(".template-content.cart form")) {
                if (countrySelected != "Japan") {
                  document.querySelector(".template-content.cart form").setAttribute("action", "/cart?checkout[shipping_address][country]=" + countrySelected + "&checkout[shipping_address][province]=" + countryProvince + "&checkout[shipping_address][zip]=" + zip);
                } else {
                  document.querySelector(".template-content.cart form").setAttribute("action", "/cart?checkout[shipping_address][country]=" + countrySelected + "&checkout[shipping_address][province]=" + countryProvince);
                }
              } //add url argument for cart-print


              if (document.querySelector(".cart-actions a.checkout-button.button-primary") && countrySelectedTranslated) {
                $(".cart-actions a.checkout-button.button-primary").attr("href", "/cart/?view=print&country=" + countrySelectedTranslated);
              } // Zip code is required for almost all countries. Passing "1" as a bogus value works in most cases. Passing 1 when not required also works.
              // Passing empty province for countries without province works.
              // Some countries require a correct zip code for country or country/province combination, notably US and Canada. All paid shipping countries have been tested on May 7th 2020 and are not concerned by this limitation. To also avoid crashing the JS, we are returning "free" if the API returns any kind of error.
              // var countrySelected = document.querySelector("[data-geolocation-country]").getAttribute("data-geolocation-country");

              ajax.open("get", "/cart/shipping_rates.json?shipping_address%5Bzip%5D=" + zip + "&shipping_address%5Bcountry%5D=" + countrySelected + "&shipping_address%5Bprovince%5D=" + countryProvince, true); //ajax.open("get", "/cart/shipping_rates.json?shipping_address%5Bzip%5D=1&shipping_address%5Bcountry%5D="+countrySelected+"&shipping_address%5Bprovince%5D="+countryProvince, true);

              ajax.send();
              this.totalPriceProductLine.classList.remove('display_none'); //Restart the slider to take new country into account

              var slider = $('.customs-invoice-slider');

              //console.log("============ slider ===============",slider)
              if (slider.length > 0 && slider[0].noUiSlider) {
                slider[0].noUiSlider.destroy();
                //console.log("getCart called 1")
                ShopifyAPI.getCart(buildCustomsInvoice);
              } // }// end if settings.tools_countrylist_enable
              // else{
              //   var _this = this;
              //   var province = this.provinceSelector.value;
              //   var zip_code = this.provinceSelector.selectedOptions[0].getAttribute("data-province-zip");
              //   this.getProvinceShippingFee(province, zip_code, function(){
              //     var shipping_rates = JSON.parse(this.responseText).shipping_rates;
              //     if(shipping_rates.length){
              //       var fees = shipping_rates[0].price;
              //       _this.updateShippingFeeAndTotalPrice(province, fees);
              //     }
              //   });
              // }
              // if('' != ''){
              //     this.spanRealPrice.innerHTML = this.totalPrice.querySelector('span.money').getAttribute('data-currency-'+ CoreInit.ShopCurrency.toLowerCase());
              // }

             var isCharitySet = false;
             if('false' == "true"){
               isCharitySet = true;
             }
              //Update 27/04/2020 check if gift card inside the cart or not. If gift card, we deactive donations


              var giftcard = document.getElementById("cart-giftcard-info");

              if (isCharitySet && !giftcard) {
                var newCharityAmount = parseInt(this.totalPriceProduct.dataset.amount * parseFloat('0.10'), 10); // Update 2020 July : check if les div exists. Prevent to crash the JS if Cookies has been created during a charity event, and the customer continue after the end of the charity

                if (document.querySelector("#charity_donation_amount span") || document.querySelector("#charity_donation_amount")) {
                  var amountSpan = document.querySelector("#charity_donation_amount span") || document.querySelector("#charity_donation_amount"); // Handle JP store which doesn't have .money span

                  amountSpan.innerHTML = _.moneying(newCharityAmount);
                }

                var donatedCharityCartAttribute = document.getElementById('DonatedCharity');

                var currentCurrency = document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary");

                var charityAmountToYen = Math.ceil(Currency.convert(newCharityAmount, currentCurrency, "JPY"));

                if (donatedCharityCartAttribute !== null) {
                  donatedCharityCartAttribute.value = charityAmountToYen;
                  donatedCharityCartAttribute.innerHTML = charityAmountToYen;
                }
              }
            };

            //display the shipping rates array in the cart
            CartProcessing.prototype.fillShippingFeesResults = function (shipping_rates){
              if(this.isCartPage){
                document.querySelector(".shipping-fees-results-wrapper.table-wrapper").classList.remove("display_none");

                document.getElementById("loading-spinner").classList.add("display_none");
                if(document.getElementById("layer")){
                  document.getElementById("layer").remove();
                }
              }

              document.getElementById("shipping-fees").classList.remove("display_none");
              document.getElementById("shipping-fees-country-edit").classList.add("display_none");

              if(shipping_rates.length){
                // document.querySelector("#noShippingRate").classList.add("display_none");
                var fees = Currency.convert(shipping_rates[0].price, shipping_rates[0].currency ,Currency.currentCurrency);
                if(fees != 0){
                  this.shippingFees.innerHTML = _.moneying(fees*100);
                  this.totalPrice.innerHTML = _.moneying(parseFloat(this.totalPriceProduct.dataset.amount,10)+parseFloat(fees,10)*100);
                  if('' != ''){
                      this.spanRealPrice.innerHTML = this.totalPrice.querySelector('span.money').getAttribute('data-currency-'+ CoreInit.ShopCurrency.toLowerCase());
                  }
                  // Currency.convertAll(CoreInit.ShopCurrency, document.querySelector('[name=currencies]').value);
                }//fin if fees == 0
                else{
                  this.shippingFees.innerHTML = "Free";
                  //_this.paidShippingTooltip.classList.add("display_none");
                  this.totalPrice.innerHTML = _.moneying(parseFloat(this.totalPriceProduct.dataset.amount,10));
                }//fin else if fees != 0

                if (shipping_rates.length >= 1 && this.isCartPage) {
                  // var currentCurrency = document.getElementById("currencies").value;
                  var currentCurrency = document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary");

                  if (document.querySelector(".shipping-fees-results.table-stripes")) {
                    document.querySelector(".shipping-fees-results.table-stripes").style.display = "table";
                  }
                  for (var i = 0; i < 5; i++) {
                    if (i < shipping_rates.length) {
                      // document.getElementById("shipping-fees-results-"+[i+1]).style.display = "table-row";
                      //if it was not display before, we force it

                      document.getElementById("shipping-fees-results-" + [i + 1]).classList.remove("display_none");
                      document.getElementById("shipping-fees-results-name-" + [i + 1]).innerHTML = shipping_rates[i].presentment_name;

                      if (currentCurrency != "JPY") {
                        var price_in_currency = Currency.convert(shipping_rates[i].price, shipping_rates[i].currency ,currentCurrency);
                        //console.log("price_in_currency",price_in_currency)
                        document.getElementById("shipping-fees-results-price-" + [i + 1]).innerHTML = Currency.formatMoneyUpdateCart(price_in_currency*100, Currency.moneyFormats[currentCurrency]["money_with_currency_format"]); // document.getElementById("shipping-fees-results-price-"+[i+1]).innerHTML = _.moneying(parseFloat(shipping_rates[i].price));
                        document.getElementById("shipping-fees-results-price-" + [i + 1]).setAttribute("fee-value",shipping_rates[i].price);
                      } else {
                        var price_in_yen = Math.floor(Currency.convert(shipping_rates[i].price, shipping_rates[i].currency ,currentCurrency));
                        document.getElementById("shipping-fees-results-price-" + [i + 1]).innerHTML = "&#165;" + price_in_yen;
                        document.getElementById("shipping-fees-results-price-" + [i + 1]).setAttribute("fee-value",price_in_yen);
                      }

                    } else {
                      // document.getElementById("shipping-fees-results-"+[i+1]).style.display = "none";
                      //do not show the row if there is no value to show
                      document.getElementById("shipping-fees-results-" + [i + 1]).classList.add("display_none");
                    }
                  }
                  _this.displayDisclaimers();
                  _this.handleDisclaimer(); //necessary if australia or canada was selected before, need to recheck
                }

              }//fin if shipping_rates.length
              else{
                document.querySelector("#noShippingRate").classList.remove("display_none");
                _this.shippingFees.innerHTML = "";
                _this.totalPrice.innerHTML = _.moneying(parseFloat(_this.totalPriceProduct.dataset.amount,10));
              }
            }//fin fillShippingFeesResults

            CartProcessing.prototype.initPrice = function () {// var _this = this;
              // if(this.spanRealPrice && '' != '' ){
              //   var currencies_selector = document.getElementById('currencies');
              //   if(currencies_selector.value != CoreInit.ShopCurrency){
              //     this.totalRealPrice.classList.remove('display_none');
              //   }
              //   else{
              //     this.totalRealPrice.classList.add('display_none');
              //   }
              //   currencies_selector.addEventListener('change', function(){
              //     if(this.value != CoreInit.ShopCurrency){
              //       _this.totalRealPrice.classList.remove('display_none');
              //     }
              //     else{
              //       _this.totalRealPrice.classList.add('display_none');
              //     }
              //   });
              // }
            };

            CartProcessing.prototype.updateCounters = function (cart) {
              var _this = this;

              var counters = document.querySelectorAll('[data-cart-count]');
              //console.log("before countCartItems 2", cart);
              var cartCount = _this.countCartItems(cart);

              _.each(counters, function (counter) {
                counter.innerHTML = cartCount;
              });
            }; // Update the cart info when a quantity is changed


            CartProcessing.prototype.updateCartInfo = function (cart) {
              var _this = this;

              _this.updateCounters(cart);

              //check if cart got oversized, delete oversized item if so

              // console.log("call checkOversized 1");
              // var has_oversized = this.checkOversized();
              // console.log("after call checkOversized 1");
              if (CartProductsData.hasshipping) {
                // do smth if oversized present (get the overprized price, and retrieve it from the cart.total_price)
                if(CartProductsData.oversized_item_id){
                  //console.log("has oversized")
                  for (var i = 0; i < cart.items.length; i++) {
                    if (cart.items[i].id == CartProductsData.oversized_item_id) {
                      this.totalPriceProduct.innerHTML = _.moneying(cart.original_total_price - cart.items[i].final_price);
                    }
                  }
                }else{
                  //console.log("cart",cart)
                  this.totalPriceProduct.innerHTML = _.moneying(cart.original_total_price);
                }
                this.totalPriceProduct.dataset.amount = cart.original_total_price;
                //console.log("called updatetotalPrice 1")
                this.updateTotalPrice();
              } else {
                if (this.totalPriceProduct) {
                  this.totalPriceProduct.innerHTML = _.moneying(cart.original_total_price);
                  this.totalPriceProduct.dataset.amount = cart.original_total_price;
                }

                this.totalPrice.innerHTML = _.moneying(cart.total_price); //Update 24 March ---- call checkOffers to make the offers disappear if needed

                this.checkOffers();

                if (document.getElementById("specialoffer-section")) {
                  document.getElementById("specialoffer-section").classList.add("display_none");
                } //Update 4 Mai 2020 ---- If no shipping, we remove the offers (forjapanese shop)
                // if(document.getElementsByClassName("cart-japanoffer")[0]){
                //   document.getElementsByClassName("cart-japanoffer")[0].style.display = "none";
                // }
                //window.location.reload(true);
                //Update 4 Mai 2020 -----> If no elements to ship, we remove the display of the shipping price


                if (document.getElementsByClassName("cart-total-label-shipping") && document.getElementById("total_price_product_line")) {
                  document.getElementById("total_price_product_line").nextElementSibling.style.display = "none";
                  document.getElementById("total_price_product_line").nextElementSibling.nextElementSibling.style.display = "none";
                } //fin if

              } // $("#dt_total_declared").html(cart.total_price);
              //Restart le slider pour prendre en compte le changement de pays
              // var slider = $('.customs-invoice-slider');
              // console.log("slider update cartInfo",slider);
              // slider[0].noUiSlider.destroy();
              // ShopifyAPI.getCart(buildCustomsInvoice)

              if (this.isCartPage) {
                // if('' == "true"){
                //   var arr_offerts = [ ('' == "true" && '' != '')?
                //                     [document.getElementById('cart-japanoffer-1'),parseInt('0')]:null,
                //                     ('' == "true" && '' != '')?
                //                     [document.getElementById('cart-japanoffer-2'),parseInt('0')]:null,
                //                     ('' == "true" && '' != '')?
                //                     [document.getElementById('cart-japanoffer-3'),parseInt('0')]:null,
                //                     ('' == "true" && '' != '')?
                //                     [document.getElementById('cart-japanoffer-4'),parseInt('0')]:null,
                //                     ('' == "true" && '' != '')?
                //                     [document.getElementById('cart-japanoffer-5'),parseInt('0')]:null
                //                     ];
                //   for (var i=0;i<arr_offerts.length;i++) {
                //     if(arr_offerts[i]!=null){
                //       if(cart.total_price >= arr_offerts[i][1]){
                //         arr_offerts[i][0].classList.add('RewardPlanOk');
                //         arr_offerts[i][0].querySelector('.cart-specialoffer-left,.cart-japanoffer-left').classList.add('display_none');
                //       }
                //       else{
                //         arr_offerts[i][0].classList.remove('RewardPlanOk');
                //         arr_offerts[i][0].querySelector('.amount-left').innerHTML = _.moneying(arr_offerts[i][1]-cart.total_price);
                //         arr_offerts[i][0].querySelector('.cart-specialoffer-left,.cart-japanoffer-left').classList.remove('display_none');
                //       }
                //     }
                //   }
                // }
                if (this.specialOfferEnable && CartProductsData.hasshipping) {
                  this.checkOffers();
                } //UPDATE 18/05/2020 ---- Check if has_shippable_and_unshippable_products == false. If not the warning stays, otherwise display_none


                if (document.getElementById("cart-unshippable-info") && CartProductsData.has_shippable_and_unshippable_products == false) {
                  document.getElementById("cart-unshippable-info").classList.add("display_none");
                }

                var shipped_products = document.querySelectorAll('[data-shipping]'); // Disable cart if order total < 3,000 YEN and products require shipping

                var quotation_products_price = 0;
                var real_products_price = 0;
                var quotation_products_count = 0;

                for (i = 0; i < shipped_products.length; i++) {
                  var line = CartProductsData.products[shipped_products[i].dataset.lineId];
                  var item = cart.items[line - 1];
                  real_products_price += item.line_price;

                  if (!shipped_products[i].getAttribute('isDiscounted')) {
                    quotation_products_price += item.line_price;
                    quotation_products_count += item.quantity;
                  }
                } //========================== Update Custom Estimates in the noUislider function ShopifyAPI.getCart(buildCustomsInvoice)
                //Custom Taxes
                // if ('' == "true") {
                // var old_customs_estimate = document.getElementById("CustomsEstimate") ? Math.floor(document.getElementById("CustomsEstimate").value) : '';
                // var customs_rate = real_products_price < '0' ? '0.0' :
                //                    real_products_price < '0' ? '0.0' :
                //                    real_products_price < '0' ? '0.0' : '0.0';
                // var new_customs_estimate = parseInt(real_products_price)*customs_rate + parseInt('0');
                // if (old_customs_estimate !== Math.floor(new_customs_estimate)) {
                // document.getElementById("customs_taxes").innerHTML = _.moneying(new_customs_estimate);
                // }
                // }


                var okToPlaceOrder = true;
                var visibleCheckboxes = document.querySelectorAll('.product_disclaimer:not(.display_none) input');

                for (var i = 0; i < visibleCheckboxes.length; i++) {
                  var cb = visibleCheckboxes[i];

                  if (!cb.checked) {
                    okToPlaceOrder = false;
                  }
                }

                var cartGiftCardInfo = document.getElementById("cart-giftcard-info");
                var theresCardGift = false;
                var cartItemsLength = cart.items.length;

                for (var i = 0; i < cartItemsLength; i++) {
                  if (cart.items[i].handle == "gift-card") {
                    theresCardGift = true;
                  }
                } //fin for
                // if(!theresCardGift){
                //   if(cartGiftCardInfo){
                //   	cartGiftCardInfo.classList.add('display_none');
                //   	document.getElementById("tooltip-giftcard").classList.add("display_none");
                // if('' != '' && shipped_products.length && cart.total_price<'0'){
                //   document.getElementById("minimum-order-amount-message").setAttribute("style", "display:inline!important");
                // }
                // }
                // }
                //update 4 Mai 2020 ---> Compute the number of items in the cart to be up to date

                //console.log("before countCartItems 1", cart);
                var cartCount = _this.countCartItems(cart);

                if (theresCardGift && cartCount == 1) {
                  document.getElementById("cart-giftcard-info").classList.add("display_none"); // document.getElementById("cart-giftcard-info").firstElementChild.classList.remove("alert-error");
                  // document.getElementById("cart-giftcard-info").firstElementChild.classList.add("alert-info");
                }

                if (theresCardGift && cartCount > 1) {
                  document.getElementById("cart-giftcard-info").classList.remove("display_none"); // if(!document.getElementById("cart-giftcard-info").firstElementChild.classList.contains("alert-error")){
                  // 	document.getElementById("cart-giftcard-info").firstElementChild.classList.add("alert-error");
                  // }
                  // document.getElementById("cart-giftcard-info").firstElementChild.classList.remove("alert-info");
                } else if (document.getElementById("cart-giftcard-info") && !theresCardGift) {
                  document.getElementById("cart-giftcard-info").classList.add("display_none");
                } //UPDATE 18/05/2020 ---- Check if has_shippable_and_unshippable_products == false. If not the warning stays, otherwise display_none


                if (document.getElementById("cart-unshippable-info") && CartProductsData.has_shippable_and_unshippable_products == false) {
                  document.getElementById("cart-unshippable-info").classList.add("display_none");
                } else if (document.getElementById("cart-unshippable-info") && CartProductsData.has_shippable_and_unshippable_products == true && !theresCardGift) {
                  document.getElementById("cart-unshippable-info").classList.remove("display_none");
                } //Update 09/03/2020 ---> add condition okToPlaceOrder (same as handleDisclaimer), on update check if everything is check, if yes, can order, otherwise, not
                //Update 18/05/2020 ---> we check if minimum order mount and process the changes. Does the same thing, but with or withtout the div for the minimum order
                // if('' != ''){
                //    //All changes here are if a minimum order is activate
                //   if(shipped_products.length && cart.total_price<'0'){
                //     document.getElementById("minimum-order").classList.remove('display_none');
                //     document.getElementById("checkoutDisabled").classList.remove("display_none");
                //     document.getElementById("checkoutbtn").classList.add("display_none");
                //   }
                //   else{
                //     if(okToPlaceOrder && !theresCardGift && !CartProductsData.has_shippable_and_unshippable_products  || (theresCardGift && cartCount == 1)){
                //       document.getElementById("checkoutDisabled").classList.add("display_none");
                //       document.getElementById("checkoutbtn").classList.remove("display_none");
                //       document.getElementById("minimum-order").classList.add('display_none');
                //     }else if (!shipped_products.length){
                //       document.getElementById("checkoutDisabled").classList.add("display_none");
                //       document.getElementById("checkoutbtn").classList.remove("display_none");
                //       document.getElementById("minimum-order").classList.add('display_none');
                //     }//fin else if
                //     else{
                //       document.getElementById("checkoutDisabled").classList.remove("display_none");
                //       document.getElementById("checkoutbtn").classList.add("display_none");
                //       document.getElementById("minimum-order").classList.add('display_none');
                //     }
                //   }//fin else
                // }//if no minimum order amount
                // else{
                // if(okToPlaceOrder && !theresCardGift && CartProductsData.hasshipping && !CartProductsData.has_shippable_and_unshippable_products || (theresCardGift && cartCount == 1)){
                //   document.getElementById("checkoutDisabled").classList.add("display_none");
                //   document.getElementById("checkoutbtn").classList.remove("display_none");
                // } else{
                //   document.getElementById("checkoutDisabled").classList.remove("display_none");
                //   document.getElementById("checkoutbtn").classList.add("display_none");
                // }
                // }

                var total = parseInt(this.totalPriceProduct.dataset.amount);
                _this.taxIncluded.innerHTML = _.moneying(this.getIncludedTax(total));

                var cartQuotationInfo = document.getElementById("cart-quotation-info");
                if('200000' != '' && cartQuotationInfo){
                  var default_currency = document.querySelector('[data-currency]').getAttribute("data-currency");
                  var real_minimum_order = Currency.convert('20000000',default_currency,Currency.currentCurrency).toFixed(2);
                  // Indicate discount if cart > minimum discount setting and more than 5 tangible items requiring shipping
                  var minweight_for_discount = '0';
                  var cart_total_weight = cart.total_weight;
                  if(quotation_products_count>5 && quotation_products_price >= parseInt(real_minimum_order) && minweight_for_discount != 0 && cart_total_weight > minweight_for_discount ){
                    cartQuotationInfo.classList.remove('display_none');
                  }
                  else{
                    cartQuotationInfo.classList.add('display_none');
                  }
                }

                //process all the checks for tooltip and checkoutDisabled or not


                this.handleDisclaimer();
              } //fin if this.isCartPage

            };

            CartProcessing.prototype.countCartItems = function (cart) {
              var count = 0;
              var sets = [];
              CartProductsData.hasshipping = false;
              var has_shippable = false;
              var has_non_shippable = false;

              _.each(cart.items, function (item) {
                if (item.product_type === "XSpecial - Present") {
                  return;
                } //UPDATE 24/03/2020 ----- Put hasshipping to false, if no product is shippable besides the bonus. here to go inside the correct condition inside updateCartInfo
                //UPDATE 18/05/2020 ----- add test shippable, to set if cart have shippable and unshippable product in it


                if (item.requires_shipping) {
                  CartProductsData.hasshipping = true;
                  has_shippable = true;
                } else {
                  has_non_shippable = true;
                }

                if (!item.properties || !item.properties._set_id) {
                  count += item.quantity;
                } else if (sets.indexOf(item.properties._set_id) < 0) {
                  sets.push(item.properties._set_id);
                  count += item.quantity;
                }
              }); //UPDATE 18/05/2020 ----- set CartProductsData.has_shippable_and_unshippable_product


              //need to check again if we display disclaimer or not - the new quantity can result in a new shipping date
              if(this.isCartPage){
                this.displayDisclaimers();
                this.handleDisclaimer();
              }

              if (has_shippable == true && has_non_shippable == true) {
                CartProductsData.has_shippable_and_unshippable_products = true;
              } else {
                CartProductsData.has_shippable_and_unshippable_products = false;
              } //display the discount code input or not on update (only happen if in cart got unshippable and shippable, and delete the unshippable)


              if (has_shippable == true && has_non_shippable == false) {
                $(".checkout-discount").removeClass("display_none");
              } else {
                $(".checkout-discount").addClass("display_none");
              }

              if (has_shippable == false) {
                $(".wrapper-cart-shipping").addClass("display_none");
              } else {
                $(".wrapper-cart-shipping").removeClass("display_none");
              }

              return count;
            }; // Update the quantity of a set with the Ajax API


            CartProcessing.prototype.adjustQuantity = function (qty, array_line, index, update_set, spans_price, spans_tax) {
              var _this = this;

              if (window.XMLHttpRequest) {
                var line = CartProductsData.products[array_line[index]];
                if (line) {
                  var request = new XMLHttpRequest();

                  request.onreadystatechange = function () {
                    if (request.readyState == 4
                    /* && request.responseText*/
                    ) {
                        if (request.status == 200) {
                          if (index == 0) {
                            var response = JSON.parse(request.responseText);

                            if (qty == 0) {
                              _this.updateCartProducts(response.items);

                              _this.updateShippingDate();

                              var elt = document.querySelector("[data-line-id='" + array_line[0] + "']");

                              if (elt) {
                                elt.parentNode.removeChild(elt);
                              }

                              if (!update_set) {
                                if (document.querySelectorAll('.cart-item:not(.specialoffer-item)').length == 0) {
                                  window.location.href = '/cart/clear';
                                  return true;
                                }
                              }
                            }

                            if (qty != 0 || update_set) {
                              var set_price = 0;

                              for (var i = 0; i < update_set.length; i++) {
                                var line = CartProductsData.products[update_set[i]];

                                if (line) {
                                  set_price += response.items[line - 1].line_price;
                                }
                              }

                              _.each(spans_price, function (span_price) {
                                span_price.innerHTML = _.moneying(set_price);
                              });

                              _.each(spans_tax, function (span_tax) {
                                span_tax.innerHTML = _.moneying(_this.getIncludedTax(set_price));
                              });
                            } // if('' != ''){
                            //   Currency.convertAll(CoreInit.ShopCurrency, document.querySelector('[name=currencies]').value);
                            // }


                            if (qty == 0 && 'true' == 'true') {
                              if(_this.isCartPage){
                                _this.displayDisclaimers();
                                _this.handleDisclaimer();
                              }

                            }
                          } else {
                            _this.adjustQuantity(qty, array_line, index - 1, update_set, spans_price, spans_tax);
                          }
                        }

                        if (request.status == 400) {
                          //Update 30/03/2020 ---> temporary ? reload the page if the buttons does not work. Status 400, seems Shopify dependant and random
                          window.location.reload(true);
                        }

                        if (response) {
                          //console.log("updateCartInfo called 1")
                          _this.checkOversized(response);
                          // _this.updateCartInfo(response);
                        }
                      }
                  };

                  request.open('POST', '/cart/change.js?quantity=' + qty + '&line=' + line, true);
                  request.setRequestHeader("Cache-Control", "no-cache");
                  request.send();
                  return true;
                } else if (index > 0) {
                  this.adjustQuantity(qty, array_line, index - 1, update_set, spans_price, spans_tax);
                }
              }

              return false;
            };

            CartProcessing.prototype._eventUpdateQuantity = function (elt, ids, spans_price, spans_tax) {
              var regex = /[^0-9]/gi;
              elt.value = elt.value.replace(regex, "");

              if (elt.value != "") {
                var confirmation_txt = ids.length > 1 ? translationJSon.javascript.delete_set_confirmation[laLang] : translationJSon.javascript.delete_product_confirmation[laLang]; //var confirmation_txt = ids.length > 1 ? 'Are you sure you want to delete this set?':'Are you sure you want to delete this product?';

                if (elt.value == 0 && !window.confirm(confirmation_txt)) {
                  return false;
                } else {
                  if (elt.value == 0) {
                    this.adjustQuantity(elt.value, ids, ids.length - 1);
                  } else {
                    this.adjustQuantity(elt.value, ids, ids.length - 1, ids, spans_price, spans_tax);
                  }
                }
              }
            }; // Set event listeners on the quantity input


            CartProcessing.prototype.initQuantity = function () {
              var _this = this;

              _.each(document.querySelectorAll('.cart-item:not(.specialoffer-item)'), function (set) {
                var delete_btns = set.querySelectorAll('[data-delete-id]');
                var spans_price = set.querySelectorAll('[data-line-price-id]');
                var spans_tax = set.querySelectorAll('[data-line-tax-id]');
                var item_ids = Array.prototype.map.call(delete_btns, function (x) {
                  return x.dataset.deleteId;
                });

                for (var i = 0; i < delete_btns.length; i++) {
                  if (i != 0) {
                    var tmp_item_ids = [item_ids[i]];
                    delete_btns[i].addEventListener('click', function (e) {
                      _this.adjustQuantity(0, [e.currentTarget.dataset.deleteId], 0, item_ids, spans_price, spans_tax);
                    });
                  } else {
                    delete_btns[i].addEventListener('click', function () {
                      _this.adjustQuantity(0, item_ids, item_ids.length - 1);
                    });
                  }
                }

                var input_qty = set.querySelector('input');
                input_qty.addEventListener('keyup', _.debounce(function () {
                  _this._eventUpdateQuantity(input_qty, item_ids, spans_price, spans_tax);
                }, 500));
                input_qty.addEventListener('keypress', function (event) {
                  if (event.keyCode == 13) {
                    return false;
                  }

                  if (event.keyCode == 38) {
                    input_qty.value++;

                    _this._eventUpdateQuantity(input_qty, item_ids, spans_price, spans_tax);
                  }

                  if (event.keyCode == 40) {
                    input_qty.value--;

                    _this._eventUpdateQuantity(input_qty, item_ids, spans_price, spans_tax);
                  }
                });
              });
            };

            CartProcessing.prototype.initOffers = function () {
              var _this = this;

              this.BtnShowOffer = document.querySelector('[data-display-toggle="#specialoffer"]');
              this.Offers = {};
              var offer_wrapper = document.getElementById("specialoffer");
              var groups_offers = document.querySelectorAll("[data-amount-offer]");
              var has_choice = groups_offers.length < document.querySelectorAll('[data-offer-id]').length;

              _.each(groups_offers, function (group) {
                var inputs = group.querySelectorAll('[data-offer-id]');
                var choose_present = group.querySelector(".cart-specialoffer-choose-present");

                if (choose_present && inputs.length == 1) {
                  choose_present.classList.add('display_none');
                }

                _.each(inputs, function (input) {
                  var table_offer = document.querySelector("[data-product-offer='" + input.dataset.offerId + "']");
                  _this.Offers[input.dataset.offerId] = {
                    "group": group,
                    "input": input,
                    "table_offer": table_offer,
                    "default": inputs[0] == input,
                    "is_uniq": inputs.length == 1
                  };
                  var min_order = table_offer.querySelector(".minimum-order-value");
                  var default_currency = document.querySelector('[data-currency]').getAttribute("data-currency");
                  var valueConvert = Currency.convert(parseInt(group.dataset.amountOffer / 100), default_currency, Currency.currentCurrency).toFixed(2);

                  if (min_order) {
                    // min_order.innerHTML = _.moneying(parseInt(group.dataset.amountOffer));
                    min_order.innerHTML = _.moneying(valueConvert);
                  }

                  var btn_delete = table_offer.querySelector("[data-delete-offer]");

                  if (btn_delete) {
                    if (has_choice) {
                      btn_delete.addEventListener('click', function () {
                        input.checked = false;

                        _this.offersHandler();
                      });
                    } else {
                      btn_delete.classList.add('display_none');
                    }
                  }
                });
              });

              if (offer_wrapper) {
                if (has_choice) {
                  offer_wrapper.addEventListener('click', function (e) {
                    if (e.target.hasAttribute('data-offer-id')) {
                      _this.offersHandler();
                    }
                  });
                } else {
                  offer_wrapper.classList.add('display_none');

                  _.each(document.querySelectorAll('[data-display-toggle="#specialoffer"]'), function (btn) {
                    btn.classList.add('display_none');
                  });
                }

                this.checkOffers();
              }
            };

            CartProcessing.prototype.offersHandler = function () {
              var _this = this;

              var update_offerts = "";

              _.eachIn(this.Offers, function (offer, key) {
                if (CartProductsData.products[key] == undefined && offer["input"].checked) {
                  offer["table_offer"].classList.remove('display_none');
                  update_offerts += 'updates[' + key + ']=1&';
                } else if (CartProductsData.products[key] && !offer["input"].checked) {
                  offer["table_offer"].classList.add('display_none');
                  update_offerts += 'updates[' + key + ']=0&';
                }
              });

              if (update_offerts != "") {
                if (window.XMLHttpRequest) {
                  var request = new XMLHttpRequest();

                  request.onreadystatechange = function () {
                    if (request.readyState == 4) {
                      if (request.status == 200) {
                        var response = JSON.parse(request.responseText);

                        _this.updateCartProducts(response.items);
                      }
                    }

                    ;
                  };

                  request.open('POST', "/cart/update.js?" + update_offerts, true);
                  request.setRequestHeader("Cache-Control", "no-cache");
                  request.send();
                }
              }
            };

            CartProcessing.prototype.deleteOversized = function (oversized_product_key) {
              var _this = this;
              //delete the id from the local hash
              var update_oversized = 'updates[' + oversized_product_key + ']=0'
              if (window.XMLHttpRequest) {
                var request = new XMLHttpRequest();

                request.onreadystatechange = function () {
                  if (request.readyState == 4) {
                    if (request.status == 200) {
                      var response = JSON.parse(request.response);
                      //console.log("deleteOversized response",response);
                      //if oversized deleted, don't display the line in the cart summary
                      document.querySelector(".oversized-cart-summary").classList.add("display_none");
                      delete CartProductsData["oversized_item_id"];
                      _this.updateCartProducts(response.items);
                      if (response) {
                        //console.log("updateCartInfo called 2")
                        _this.updateCartInfo(response);
                      }
                    }
                  }
                };
                // request.open('POST', '/cart/change.js?quantity=' + 0 + '&id=' + oversized_product_key, true);
                request.open('POST', "/cart/update.js?" + update_oversized, true);
                request.setRequestHeader("Cache-Control", "no-cache");
                request.send();
              }
            }

            CartProcessing.prototype.updateCartProducts = function (items) {
              CartProductsData.products = {};

              for (var i = 0; i < items.length; i++) {
                CartProductsData.products[items[i].variant_id] = true;
                CartProductsData.products[items[i].key] = i + 1;
              }

              for (var productId in CartProductsData.shippingDates) {
                if (!CartProductsData.products.hasOwnProperty(productId)) {
                  delete CartProductsData.shippingDates[productId];
                }
              }

              for (var productId in CartProductsData.productsTags) {
                if (!CartProductsData.products.hasOwnProperty(productId)) {
                  delete CartProductsData.productsTags[productId];
                }
              }
            };

            CartProcessing.prototype.addOversizedItem = function (){
              //console.log("add oversized item");
              // var _this = this;
              //delete the id from the local hash
              //id is specific to website
              // var update_oversized = 'updates[' + 44234661200101 + ']=1'
              // if (window.XMLHttpRequest) {
              //   var request = new XMLHttpRequest();

              //   request.onreadystatechange = function () {
              //     if (request.readyState == 4) {
              //       if (request.status == 200) {
              //         var response = JSON.parse(request.response);
              //         console.log("addOversizedItem response",response);
              //         console.log("response.items[0]",response.items[0]);
              //         document.querySelector(".oversized-cart-summary td span").innerHTML = _.moneying(response.items[0].final_price)
              //         //if oversized deleted, don't display the line in the cart summary
              //         document.querySelector(".oversized-cart-summary").classList.remove("display_none");
              //         //id is specific to website
              //         CartProductsData.oversized_item_id = 44234661200101
              //         console.log("CartProductsData",CartProductsData)
              //         _this.updateCartProducts(response.items);
              //         if (response) {
              //           console.log("============= updateCartInfo called 3")
              //           _this.updateCartInfo(response);
              //         }
              //       }
              //     }
              //   };

              //   request.open('POST', "/cart/update.js?" + update_oversized, true);
              //   request.setRequestHeader("Cache-Control", "no-cache");
              //   request.send();
              // }

              var _this = this;
              var formData = {
                'items': [{
                'id': 44234661200101, //variant id is specific for the website
                'quantity': 1
                }]
              };

              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              }).then(function (response) {
                return response.json();
              }).then(function (request) {
                jQuery.getJSON('/cart.js', function (cart){
                  var response = cart;
                  //console.log("addOversizedItem response after add",response);
                  //console.log("response.items[0]",response.items[0]);
                  document.querySelector(".oversized-cart-summary td span").innerHTML = _.moneying(response.items[0].final_price)
                  //if oversized deleted, don't display the line in the cart summary
                  document.querySelector(".oversized-cart-summary").classList.remove("display_none");
                  //id is specific to website
                  CartProductsData.oversized_item_id = 44234661200101
                  //console.log("CartProductsData",CartProductsData)
                  _this.updateCartProducts(response.items);
                  if (response) {
                    //console.log("============= updateCartInfo called 3")
                    _this.updateCartInfo(response);
                  }
                });
              })

            }


            CartProcessing.prototype.checkOversized = function (cart) {
              // check if new inventory got oversized product, if it does not, remove the oversized fee from cart
              // document.body.prepend(Object.assign(document.createElement('div'),{id:"layer", style:"width:100%;height:100%;position:absolute;z-index:9999"}));
              var _this = this;
              // setTimeout(function () {
                var has_oversized = false;
                for (p in CartProductsData.productsTags){
                  for(tag in CartProductsData.productsTags[p]){
                      if(CartProductsData.productsTags[p][tag] == "oversizedShip" && CartProductsData.products[p]){
                        has_oversized = true;
                        break;
                      }
                  }
                }

                if((!has_oversized && CartProductsData.oversized_item_id && CartProductsData.products[CartProductsData.oversized_item_id]) || (has_oversized && document.getElementById("country_selector").value == "Japan" && CartProductsData.oversized_item_id && CartProductsData.products[CartProductsData.oversized_item_id])){
                  // document.getElementById("layer").remove();
                  this.deleteOversized(CartProductsData.oversized_item_id);
                }else if(has_oversized && document.getElementById("country_selector").value != "Japan" && !(CartProductsData.oversized_item_id && CartProductsData.products[CartProductsData.oversized_item_id])){
                  //console.log("pass in addOversizedItem");
                  this.addOversizedItem();
                }else{
                  this.updateCartInfo(cart);
                }

                // if(document.getElementById("layer")){
                //   document.getElementById("layer").remove();
                // }

                // return has_oversized;
              // }, 1.0 * 1000);
            }

            CartProcessing.prototype.checkOffers = function () {
              var _this = this;

              var show_offer = false;

              _.eachIn(this.Offers, function (offer, key) {
                //Update 24 March --- add !CartProductsData.hasshipping, to disable the offers if nothing to ship

                var amountOfferMoneying = _.moneying(parseInt(offer["group"].dataset.amountOffer));

                var numberAmountOffer = Number(amountOfferMoneying.match(/\d+[0-9\.\s\,]*/g)[0].replace(",", ""));
                 // var currentCurrency = document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary");

                var default_currency = document.querySelector('[data-currency]').getAttribute("data-currency");
                var offerValueConverted = Currency.convert(offer["group"].dataset.amountOffer, default_currency, Currency.currentCurrency).toFixed(2);
                 // if(parseInt(offer["group"].dataset.amountOffer) > parseInt(_this.totalPriceProduct.dataset.amount) || !CartProductsData.hasshipping){

                if (offerValueConverted > parseInt(_this.totalPriceProduct.dataset.amount) || !CartProductsData.hasshipping) {
                  offer["group"].classList.remove("RewardPlanOk");
                  offer['input'].checked = false;
                  offer['input'].disabled = true;
                } else {
                  if (!offer["group"].classList.contains("RewardPlanOk")) {
                    show_offer = true;
                    offer["group"].classList.add("RewardPlanOk");

                    if (offer["is_uniq"]) {
                      offer['input'].checked = true;
                    } else if (offer["default"]) {
                      var group_has_no_value = true;

                      _.eachIn(_this.Offers, function (tmpoffer, tmpkey) {
                        if (offer["group"] == tmpoffer["group"] && tmpoffer["input"].checked) {
                          group_has_no_value = false;
                        }
                      });

                      if (group_has_no_value) {
                        offer["input"].checked = true;
                      }
                    }
                  }

                  offer['input'].disabled = false;
                }
              });

              this.offersHandler();

              if (show_offer) {
                var event = document.createEvent('HTMLEvents');
                event.initEvent('click', false, false);
                this.BtnShowOffer.dispatchEvent(event);
              }
            };

            CartProcessing.prototype.cleanOffers = function () {
              var _this = this;

              var update_offerts = "";

              _.each(CartProductsData.cleanOffers, function (offer) {
                update_offerts += 'updates[' + offer + ']=0&';
              });

              if (update_offerts != "") {
                if (window.XMLHttpRequest) {
                  var request = new XMLHttpRequest();

                  request.onreadystatechange = function () {
                    if (request.readyState == 4 && request.status == 200) {
                      if (this.isCartPage) {
                        window.location.href = "/cart";
                      } else {
                        var cart = JSON.parse(request.responseText);

                        _this.updateCartProducts(cart.items);

                        _this.updateCounters(cart);
                      }
                    }
                  };

                  request.open('POST', "/cart/update.js?" + update_offerts, true);
                  request.setRequestHeader("Cache-Control", "no-cache");
                  request.send();
                }
              }
            };

            CartProcessing.prototype.handleDisclaimer = function () {
              var okToPlaceOrder = true;
              var visibleCheckboxes = document.querySelectorAll('.product_disclaimer:not(.display_none) input');

              for (var i = 0; i < visibleCheckboxes.length; i++) {
                var cb = visibleCheckboxes[i];
                console.log("cb",cb);
                console.log("!cb.checked",!cb.checked);
                if (cb.id == "product_disclaimer-USCustoms" && !cb.checked){
                  document.getElementById("InternalNote").value = "None";
                  document.getElementById('InternalNote').innerHTML = "None";
                }else if (cb.id == "product_disclaimer-USCustoms" && cb.checked && document.getElementById("InternalNote").value == "None"){
                  document.getElementById("InternalNote").value = "Agree Customs US Checked";
                  document.getElementById('InternalNote').innerHTML = "Agree Customs US Checked";
                }
                if (cb.id == "product_disclaimer-MiddleEast" && !cb.checked){
                  document.getElementById("InternalNote").value = "None";
                  document.getElementById('InternalNote').innerHTML = "None";
                }else if (cb.id == "product_disclaimer-MiddleEast" && cb.checked && document.getElementById("InternalNote").value != "Middle East Checked"){
                  document.getElementById("InternalNote").value = "Middle East Checked";
                  document.getElementById('InternalNote').innerHTML = "Middle East Checked";
                }

                if (!cb.checked) {
                  okToPlaceOrder = false;
                }
              } //Update 24 April - check if giftcard inside the cart or not
              //declare checkoutdisabled. Depending on its value (at the end of the function), we can order or not


              var checkoutDisabled;
              var hasGiftCard;

              if (CartProductsData.containGiftCard == true) {
                hasGiftCard = true;
              } else {
                hasGiftCard = false;
              }

              var customerBanned = false;

              if (CustomerData.tags.indexOf("customerBanned") != -1) {
                customerBanned = true;
              }

              var checkoutAuthorized = false;

              if (CustomerData.tags.indexOf("checkoutAuthorized") != -1) {
                checkoutAuthorized = true;
              }

              var cartCount = parseInt(document.querySelector('[data-cart-count]').innerHTML); // Init all disclaimer -> evrything with display_none

              document.getElementById("tooltip-customer_banned").classList.add("display_none");
              document.getElementById("tooltip-giftcard").classList.add("display_none");
              document.getElementById("tooltip-shippable_and_unshippable").classList.add("display_none"); // document.getElementById("minimum-order-amount-message").classList.add("display_none");

              this.mustAgree.classList.add("display_none"); //Update 2020 July 31 ---- get all the conditions from the liquid (cart-init)

              if (this.isCartPage) {
                if (customerBanned) {
                  checkoutDisabled = true; //disclaimer ban

                  document.getElementById("tooltip-customer_banned").classList.remove("display_none");
                } else if (checkoutAuthorized) {
                  checkoutDisabled = false;
                } else if (hasGiftCard && cartCount > 1) {
                  checkoutDisabled = true; //giftcard disclaimer

                  document.getElementById("tooltip-giftcard").classList.remove("display_none");
                } else if (CartProductsData.has_shippable_and_unshippable_products == true) {
                  checkoutDisabled = true; // shippable unshippable disclaimer

                  document.getElementById("tooltip-shippable_and_unshippable").classList.remove("display_none");
                }
              } else {
                checkoutDisabled = false;
              }

              if (customerBanned) {
                if(document.getElementById("checkoutDisabled") && document.getElementById("checkoutbtn")){
                  document.getElementById("checkoutDisabled").classList.remove("display_none");
                  document.getElementById("checkoutbtn").classList.add("display_none");
                }
              } else if (checkoutAuthorized) {
                if(document.getElementById("checkoutDisabled") && document.getElementById("checkoutbtn")){
                  document.getElementById("checkoutDisabled").classList.add("display_none");
                  document.getElementById("checkoutbtn").classList.remove("display_none");
                }
              } else if (checkoutDisabled == true) {
                if(document.getElementById("checkoutDisabled") && document.getElementById("checkoutbtn")){
                  document.getElementById("checkoutDisabled").classList.remove("display_none");
                  document.getElementById("checkoutbtn").classList.add("display_none");
                }
              } else if (okToPlaceOrder) {
                if(document.getElementById("checkoutDisabled") && document.getElementById("checkoutbtn")){
                  document.getElementById("checkoutDisabled").classList.add("display_none");
                  document.getElementById("checkoutbtn").classList.remove("display_none");
                }
              } else {
                if(document.getElementById("checkoutDisabled") && document.getElementById("checkoutbtn")){
                  document.getElementById("checkoutDisabled").classList.remove("display_none");
                  document.getElementById("checkoutbtn").classList.add("display_none");
                }
                this.mustAgree.classList.remove("display_none");
              } // //Update 09/03/2020 ---> add condition "parseInt(this.totalPriceProduct.dataset.amount) >=...." to avoid adding display_none to the checkout even if the price is not sufficent
              // //Update 16/03/2020 ---> add || "(okToPlaceOrder && !CartProductsData.hasshipping)", to take into account if the cart has only non physical product -----
              // //UPdate 18/05/2020 ---> add CartProductsData.has_shippable_and_unshippable_products = true has first test
              // if(CartProductsData.has_shippable_and_unshippable_products == true){
              //   document.getElementById("checkoutDisabled").classList.remove("display_none");
              //   document.getElementById("checkoutbtn").classList.add("display_none");
              //   if('' != ''){
              //      this.lowOrderAmount.classList.add("display_none");
              //   }
              // //Tout après ça n'a pas de shippable ou unshippable product
              // //test si gift card none, okToplaceOrder. si Shipping, test valeur, sinon pas besoin
              // }else if ((giftcardDispNone && okToPlaceOrder && CartProductsData.hasshipping && parseInt(this.totalPriceProduct.dataset.amount) >= '0') || (giftcardDispNone && okToPlaceOrder && !CartProductsData.hasshipping)) {
              //   document.getElementById("checkoutDisabled").classList.add("display_none");
              //   document.getElementById("checkoutbtn").classList.remove("display_none");
              //   if('' != ''){
              //     this.lowOrderAmount.classList.remove("display_none");
              //     this.mustAgree.classList.add("display_none");
              //   }
              //   //Si gift card présente, on ne permet pas l'achat
              // }else if ((okToPlaceOrder && CartProductsData.hasshipping && parseInt(this.totalPriceProduct.dataset.amount) >= '0') || (okToPlaceOrder && !CartProductsData.hasshipping)) {
              //   document.getElementById("checkoutDisabled").classList.remove("display_none");
              //   document.getElementById("checkoutbtn").classList.add("display_none");
              //   if('' != ''){
              //      this.lowOrderAmount.classList.add("display_none");
              //   }
              // }else {
              //     document.getElementById("checkoutDisabled").classList.remove("display_none");
              //     document.getElementById("checkoutbtn").classList.add("display_none");
              //     if('' != ''){
              //       this.lowOrderAmount.classList.add("display_none");
              //       this.mustAgree.classList.remove("display_none");
              //     }
              //   }

            };

            CartProcessing.prototype.initDisclaimers = function () {
              var disclaimersCheckboxes = document.querySelectorAll(".cart-product-disclaimer input");

              for (var i = 0; i < disclaimersCheckboxes.length; i++) {
                var cb = disclaimersCheckboxes[i];
                cb.addEventListener('change', this.handleDisclaimer.bind(this));
              }

              this.displayDisclaimers();
            };

            CartProcessing.prototype.displayDisclaimers = function () {
              var disclaimersDiv = document.getElementById('cart-product-disclaimer');
              var disc_productDisclaimers = document.getElementById('product_disclaimer-productDisclaimers');
              var disc_noExchange = document.getElementById('product_disclaimer-noExchange');
              var disc_noCancellation = document.getElementById('product_disclaimer-noCancellation');
              var disc_noModification = document.getElementById('product_disclaimer-noModification');
              var disc_chargeDisclaimer = document.getElementById('product_disclaimer-chargeDisclaimer');
              var disc_usCustoms = document.getElementById('product_disclaimer-USCustoms');
              var disc_middleEast = document.getElementById('product_disclaimer-MiddleEast');
              var all_tags = [];
              // list all middle east countries, to compare the value of the selected country and check if it is inside this array
              var list_middle_east_country = ["United Arab Emirates", "Iraq", "Iran", "Egypt", "Oman", "Qatar", "Kuwait", "Saudi Arabia", "Turkey", "Bahrain", "Jordan", "Lebanon"]

              for (var pro in CartProductsData.productsTags) {
                if (!CartProductsData.productsTags.hasOwnProperty(pro)) {
                  continue;
                }

                all_tags = all_tags.concat(CartProductsData.productsTags[pro]);
              }

              all_tags = _.uniqueArray(all_tags);
              var disableCheckout = false;

              if (all_tags.indexOf("noExchange") >= 0 && all_tags.indexOf("noCancellation") >= 0 && all_tags.indexOf("noModification") >= 0) {
                disc_productDisclaimers.parentElement.classList.remove('display_none');
                disableCheckout = true;
              } else {
                if (disc_productDisclaimers) {
                  disc_productDisclaimers.parentElement.classList.add('display_none');
                }

                if (all_tags.indexOf("noExchange") >= 0 || this.getMaxProductionDays() > 10) {
                  disc_noExchange.parentElement.classList.remove('display_none');
                  disableCheckout = true;
                } else {
                  if (disc_noExchange) {
                    disc_noExchange.parentElement.classList.add('display_none');
                  }
                }

                if (all_tags.indexOf("noCancellation") >= 0) {
                  disc_noCancellation.parentElement.classList.remove('display_none');
                  disableCheckout = true;
                } else {
                  if(disc_noCancellation){
                    disc_noCancellation.parentElement.classList.add('display_none');
                  }
                }

                if (all_tags.indexOf("noModification") >= 0) {
                  disc_noModification.parentElement.classList.remove('display_none');
                  disableCheckout = true;
                } else {
                  if(disc_noModification){
                    disc_noModification.parentElement.classList.add('display_none');
                  }
                }
              }

              var today = new Date(); //get time comparison between today and the max shipping date

              var diffTime = this.getMaxShippingDate().date.getTime() - today.getTime(); //get the value in days

              var diffDay = diffTime / (1000 * 3600 * 24); //if numebr of days >= 10 display disclaimer

              if (diffDay >= 10) {
                // if (this.getMaxProductionDays() > 9) {
                disc_chargeDisclaimer.parentElement.classList.remove('display_none');
                disableCheckout = true;
              } else {
                disc_chargeDisclaimer.parentElement.classList.add('display_none');
              }

              if(disc_middleEast && list_middle_east_country.includes(document.getElementById("country_selector").value)){
                disableCheckout = true;
                disc_middleEast.parentElement.classList.remove('display_none');
              }else if (disc_usCustoms){
                disc_middleEast.parentElement.classList.add('display_none');
              }

              if(disc_usCustoms && document.getElementById("country_selector").value == "United States"){
                disableCheckout = true;
                disc_usCustoms.parentElement.classList.remove('display_none');
              }else if (disc_usCustoms){
                //reset values if not US
                document.getElementById("InternalNote").value = "None";
                document.getElementById('InternalNote').innerHTML = "None";
                disc_usCustoms.parentElement.classList.add('display_none');
              }

              if (disableCheckout) {
                disclaimersDiv.classList.remove("display_none"); // if('' != ''){
                //   this.lowOrderAmount.classList.add("display_none");

                this.mustAgree.classList.remove("display_none"); // }

                
                if(document.getElementById("checkoutDisabled") && document.getElementById("checkoutbtn")){
                  document.getElementById("checkoutDisabled").classList.remove("display_none");
                  document.getElementById("checkoutbtn").classList.add("display_none");
                }
              } else {
                disclaimersDiv.classList.add("display_none"); // if('' != ''){
                // this.lowOrderAmount.classList.remove("display_none");

                this.mustAgree.classList.add("display_none"); // }
              } //end else disableCheckout

            };

            CartProcessing.prototype.getIncludedTax = function (price) {
              return parseFloat(price * (1 - 1 / "1.1") / 100, 10) * 100;
            };

            CartProcessing.prototype.getMaxProductionDays = function () {
              var productionDays = Object.values(CartProductsData.shippingDates).map(function (v) {
                return parseInt(v, 10);
              });
              return Math.max.apply(Math, productionDays);
            };

            module.exports = CartProcessing;
          }, {
            "./_cookies.js": 4,
            "./_lib.js": 14,
            "./_paid-shipping.js": 20,
            "./_shipping-date.js": 26
          }],
          4: [function (require, module, exports) {
            /*\
            |*|
            |*|  :: cookies.js ::
            |*|
            |*|  A complete cookies reader/writer framework with full unicode support.
            |*|
            |*|  Revision #1 - September 4, 2014
            |*|
            |*|  https://developer.mozilla.org/en-US/docs/Web/API/document.cookie
            |*|  https://developer.mozilla.org/User:fusionchess
            |*|
            |*|  This framework is released under the GNU Public License, version 3 or later.
            |*|  http://www.gnu.org/licenses/gpl-3.0-standalone.html
            |*|
            |*|  Syntaxes:
            |*|
            |*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
            |*|  * docCookies.getItem(name)
            |*|  * docCookies.removeItem(name[, path[, domain]])
            |*|  * docCookies.hasItem(name)
            |*|  * docCookies.keys()
            |*|
            \*/
            var docCookies = {
              getItem: function getItem(sKey) {
                if (!sKey) {
                  return null;
                }

                return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
              },
              setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
                if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
                  return false;
                }

                var sExpires = "";

                if (vEnd) {
                  switch (vEnd.constructor) {
                    case Number:
                      sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                      break;

                    case String:
                      sExpires = "; expires=" + vEnd;
                      break;

                    case Date:
                      sExpires = "; expires=" + vEnd.toUTCString();
                      break;
                  }
                }

                document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
                return true;
              },
              removeItem: function removeItem(sKey, sPath, sDomain) {
                if (!this.hasItem(sKey)) {
                  return false;
                }

                document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
                return true;
              },
              hasItem: function hasItem(sKey) {
                if (!sKey) {
                  return false;
                }

                return new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
              },
              keys: function keys() {
                var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);

                for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
                  aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
                }

                return aKeys;
              }
            };
            module.exports = docCookies;
          }, {}],
          5: [function (require, module, exports) {
            var _ = require('./_lib.js');

            var Customer = function Customer() {
              this.addressForms = document.getElementsByClassName("customer-address");
              this.reorderButtons = document.querySelectorAll('[data-reorder]');

              this._addEventListeners(); //USE IN ACCOUNT ADDRESSES FORM
              // Shopify.theme.addresses.AddressForm(document.querySelector('#address_form_new'), document.querySelector("[lang]").getAttribute("lang"));


              var allCountry = $("form[id^='address_form_']");
              allCountry.each(function () {
                Shopify.theme.addresses.AddressForm(document.querySelector('#' + $(this).context.id), document.querySelector("[lang]").getAttribute("lang")); // debugger;
              });
            };

            Customer.prototype._addEventListeners = function () {
              var _this = this;

              _.each(this.addressForms, function (form) {
                var countrySwitcher = form.querySelector('[data-address-field="country"]');

                if (countrySwitcher) {
                  var _this = this;

                  countrySwitcher.addEventListener('change', function (e) {
                    _this.handleAddress(form, e.target);
                  });
                }
              }, this);

              _.each(this.reorderButtons, function (btn) {
                btn.addEventListener('click', function () {
                  _this.handleReorder(btn);
                });
              });
            };

            Customer.prototype.handleAddress = function (form, countrySwitcher) {// var company = form.querySelector('[data-address-field="company"]');
              // var last = form.querySelector('[data-address-field="last_name"]');
              // var first = form.querySelector('[data-address-field="first_name"]');
              // var zip = form.querySelector('[data-address-field="zip"]');
              // var province = form.querySelector('[data-address-field="province"]');
              // var city = form.querySelector('[data-address-field="city"]');
              // var add1 = form.querySelector('[data-address-field="address1"]');
              // var add2 = form.querySelector('[data-address-field="address2"]');
              // var country = form.querySelector('[data-address-field="country"]');
              // var phone = form.querySelector('[data-address-field="phone"]');
              // var checkbox = form.querySelector('[data-address-field="checkbox"]');
              // var buttons = form.querySelector('[data-address-field="buttons"]');
              // if(("Japan" || "Japon" || "日本").indexOf(countrySwitcher.value)>-1){
              //   // if(''.indexOf(countrySwitcher.value)>-1){
              //   company.parentNode.appendChild(company);
              //   last.parentNode.appendChild(last);
              //   first.parentNode.appendChild(first);
              //   zip.parentNode.appendChild(zip);
              //   province.parentNode.appendChild(province);
              //   city.parentNode.appendChild(city);
              //   add1.parentNode.appendChild(add1);
              //   add2.parentNode.appendChild(add2);
              //   country.parentNode.appendChild(country);
              // }
              // else{
              //   last.parentNode.appendChild(last);
              //   first.parentNode.appendChild(first);
              //   company.parentNode.appendChild(company);
              //   add1.parentNode.appendChild(add1);
              //   add2.parentNode.appendChild(add2);
              //   if(("フランス" || "France").indexOf(countrySwitcher.value)>-1){
              //     city.parentNode.appendChild(city);
              //     country.parentNode.appendChild(country);
              //     province.parentNode.appendChild(province);
              //     zip.parentNode.appendChild(zip);
              //   }
              //   else{
              //     zip.parentNode.appendChild(zip);
              //     city.parentNode.appendChild(city);
              //     country.parentNode.appendChild(country);
              //     province.parentNode.appendChild(province);
              //   }
              // }
              // phone.parentNode.appendChild(phone)
              // checkbox.parentNode.appendChild(checkbox);
              // buttons.parentNode.appendChild(buttons);
            };

            Customer.prototype.handleReorder = function (btn) {
              var product_indexes = btn.dataset.reorder;

              if (product_indexes) {
                product_indexes = product_indexes.split('-');
              } else {
                product_indexes = [];

                for (var i = 0; i < ProductsData.length; i++) {
                  product_indexes.push(i);
                }
              }

              if (product_indexes.length && window.FormData) {
                this.addProduct(product_indexes);
              }
            };

            Customer.prototype.addProduct = function (product_indexes) {
              var _this = this;

              formdata = new FormData();
              var prod = ProductsData[product_indexes.pop()];
              var keys = Object.keys(prod);

              for (var i = 0; i < keys.length; i++) {
                if (prod[keys[i]].type != 'file') {
                  formdata.append(keys[i] == "id" || keys[i] == "quantity" ? keys[i] : "properties[" + keys[i] + "]", prod[keys[i]]);
                } else if (prod[keys[i]].files.length > 0) {
                  formdata.append(keys[i], prod[keys[i]]);
                }
              }

              var xhr = new XMLHttpRequest();

              xhr.onreadystatechange = function () {
                if (xhr.readyState == 4 && xhr.status == 200) {
                  if (product_indexes.length) {
                    _this.addProduct(product_indexes);
                  } else {
                    window.location.href = "/cart";
                  }
                }
              };

              xhr.open("POST", "/cart/add.js");
              xhr.send(formdata);
            };

            module.exports = Customer;
          }, {
            "./_lib.js": 14
          }],
          6: [function (require, module, exports) {
            var _ = require('./_lib.js');

            var cookies = require('./_cookies.js');

            var Disclaimer = function Disclaimer(ele) {
              this.ele = ele;
              this.actionEles = this.ele.querySelectorAll('[data-disclaimer-action]');
              this.cookieName = 'disclaimer_' + this.ele.dataset.disclaimer;
              this.init();
            };

            Disclaimer.prototype.init = function () {
              if (!cookies.hasItem(this.cookieName) || this.cookieName == "disclaimer_customs") {
                this._addEventListeners();
                if (this.ele.dataset.disclaimer != "japan" && this.ele.dataset.disclaimer != "customs" && (this.ele.dataset.disclaimer != "mailchimp" || !_.getUrlParameter('utm_campaign'))) {
                  this.ele.style.display = 'block';
                } else if (this.ele.dataset.disclaimer == "mailchimp" && _.getUrlParameter('utm_campaign')) {
                  var event = document.createEvent('HTMLEvents');
                  event.initEvent('click', false, false);
                  this.actionEles[0].dispatchEvent(event);
                }
              }
            };

            Disclaimer.prototype.actionAccept = function (actionEle) {
              // TODO: Set expirey and add other actions?
              var expiryDate = new Date(); // expiryDate.setFullYear(expiryDate.getFullYear() + 1);

              expiryDate.setDate(expiryDate.getDate() + 30);
              if(this.cookieName != "disclaimer_customs"){
              	cookies.setItem(this.cookieName, 'accepted', expiryDate, '/');
              }
              this.ele.style.display = 'none';
            }; // Private


            Disclaimer.prototype._addEventListeners = function () {
              var _this = this;

              _.each(this.actionEles, function (actionEle) {
                var actionName = 'action' + _.capitalise(actionEle.dataset.disclaimerAction);

                actionEle.addEventListener('click', function (e) {
                  //e.preventDefault();
                  _this[actionName](e.currentTarget);
                });
              });
            };
            /* Disclaimers */


            var Disclaimers = function Disclaimers() {
              this.disclaimerEles = document.querySelectorAll('[data-disclaimer]');

              _.each(this.disclaimerEles, function (ele) {
                new Disclaimer(ele);
              });

              if(document.getElementById("submit_mailing") && document.getElementById("news-email")){
                document.getElementById("submit_mailing").addEventListener("click",function(event){
                  if(document.getElementById("news-email").checkValidity()){
                    document.getElementById("submit_mailing").classList.add("display_none");
                    document.getElementById("thankyou_mailing").classList.remove("display_none");
                    var expiryDate = new Date(); // expiryDate.setFullYear(expiryDate.getFullYear() + 1);

                    expiryDate.setDate(expiryDate.getDate() + 30);
                    cookies.setItem("disclaimer_mailchimp", 'accepted', expiryDate, '/');
                  }
                });
              }
            };

            module.exports = Disclaimers;
          }, {
            "./_cookies.js": 4,
            "./_lib.js": 14
          }],
          7: [function (require, module, exports) {
            /*
              Animate a dropdowns slide effect.
              Animations are done with CSS, however you can't animate max-height without knowing the exact height
              so for variable height objects we need to use a little JS.
            */
            var _ = require('./_lib.js');

            var DisplayAnimate = function DisplayAnimate() {
              this.actionSelector = '[data-animate-display]';
              this.stateVisible = "visible";
              this.stateHidden = "hidden";
              this.classTargetOpen = "is-open";

              this._initActions();

              this._addEventListeners();
            };

            DisplayAnimate.prototype.open = function (ele) {
              ele.classList.add(this.classTargetOpen);

              if (!ele.dataset.animateDisplay) {
                this._initActions("#" + ele.id);
              }

              ele.style.maxHeight = ele.dataset.animateDisplay + 'px';
              ele.dataset.state = this.stateVisible;
            };

            DisplayAnimate.prototype.close = function (ele) {
              ele.classList.remove(this.classTargetOpen);
              ele.style.maxHeight = '';
              ele.dataset.state = this.stateHidden;
            }; // Private


            DisplayAnimate.prototype._initActions = function (actionSelector) {
              var _this = this;

              var actions = document.querySelectorAll(actionSelector ? actionSelector : this.actionSelector);

              _.each(actions, function (action) {
                var has_transition = action.dataset.animateDisplay != "none";
                var subActions = action.querySelectorAll(_this.actionSelector);
                var subOffsetHeight = 0;

                for (i = 0; i < subActions.length; i++) {
                  subActions[i].style.maxHeight = 'none';
                  subActions[i].classList.add('is-open');
                  var isOpen = false;

                  if (subActions[i].dataset.state == _this.stateVisible) {
                    isOpen = true;
                  }

                  subActions[i].dataset.state = _this.stateVisible;
                  subOffsetHeight += _.outerHeight(subActions[i]);

                  if (!isOpen) {
                    subActions[i].classList.remove('is-open');
                    subActions[i].dataset.state = _this.stateHidden;
                    subActions[i].style.maxHeight = '';
                  }
                }

                action.style.transition = '';
                action.style.maxHeight = 'none';
                action.classList.add('is-open');

                if (action.dataset.state == _this.stateVisible) {
                  action.dataset.animateDisplay = 2 * (_.outerHeight(action) + subOffsetHeight);
                  action.style.maxHeight = action.dataset.animateDisplay + 'px';
                } else {
                  action.dataset.state = _this.stateVisible;
                  action.dataset.animateDisplay = 2 * (_.outerHeight(action) + subOffsetHeight);
                  action.classList.remove('is-open');
                  action.dataset.state = _this.stateHidden;
                  action.style.maxHeight = '';
                }

                if (has_transition) {
                  if (action.dataset.animateDisplay < 4000) {
                    action.style.transition = '.6s cubic-bezier(0.65, 0.05, 0.36, 1) all';
                  } else {
                    action.style.transition = '1.5s cubic-bezier(0.65, 0.05, 0.36, 1) all';
                  }
                }
              });
            };

            DisplayAnimate.prototype._addEventListeners = function () {
              var _this = this;

              window.addEventListener('resize', _.debounce(function () {
                _this._initActions();
              }));
            };

            module.exports = DisplayAnimate;
          }, {
            "./_lib.js": 14
          }],
          8: [function (require, module, exports) {
            var _ = require('./_lib.js');

            var DisplayAnimate = require('./_display-animate.js');

            var Eventer = require('./_eventer.js');

            var Display = function Display() {
              new Eventer(this);
              this.actionSelector = '[data-display-toggle]';
              this.actionShowSelector = '[data-display-show]';
              this.stateVisible = "visible";
              this.stateHidden = "hidden";
              this.classActionOpen = "display-open";
              this.animate = new DisplayAnimate();

              this._initActions();
            };

            Display.prototype.displayShow = function (action, actionTarget) {
              if (action.dataset.state == this.stateHidden) {
                this.displayToggle(action, actionTarget, 'show');
              }
            };

            Display.prototype.displayHide = function (action, actionTarget) {
              if (action.dataset.state == this.stateVisible) {
                this.displayToggle(action, actionTarget);
              }
            };

            Display.prototype.displayToggle = function (action, actionTarget, groupTarget) {
              action.blur();

              var _this = this;

              var didAction = false;

              if (action.dataset.state == this.stateVisible) {
                didAction = this._getEles(actionTarget, function (targetEle) {
                  _this.animate.close(targetEle);
                });
                var event = 'hide';
              } else {
                didAction = this._getEles(actionTarget, function (targetEle) {
                  _this.animate.open(targetEle);
                });
                this.toggleGroup(action, groupTarget);
                var event = 'show';
              }

              if (didAction) {
                this.toggleTrigger(action);
                this.trigger(event, [action, actionTarget]);
              }
            };

            Display.prototype.toggleTrigger = function (actionEle) {
              this.toggleContent(actionEle);
              var target = "[data-trigger*='" + actionEle.dataset.trigger + "']";

              this._getEles(target, function (targetEle) {
                if (targetEle !== actionEle) {
                  this.toggleContent(targetEle);
                }
              });
            };

            Display.prototype.toggleContent = function (actionEle) {
              if (actionEle.hasAttribute('data-toggle-content')) {
                var newContent = actionEle.dataset.toggleContent;
                actionEle.dataset.toggleContent = actionEle.innerHTML;
                actionEle.innerHTML = newContent;
              }

              if (actionEle.dataset.state == this.stateVisible) {
                actionEle.dataset.state = this.stateHidden;
                actionEle.classList.remove(this.classActionOpen);
              } else {
                actionEle.dataset.state = this.stateVisible;
                actionEle.classList.add(this.classActionOpen);
              }
            };

            Display.prototype.toggleGroup = function (actionEle, dataAttr) {
              if (actionEle.hasAttribute('data-display-group')) {
                var groupSelector = '[data-display-group="' + actionEle.dataset.displayGroup + '"]';
                var groupEles = document.querySelectorAll(groupSelector);
                var groupTrigger = document.querySelectorAll('[data-trigger="' + actionEle.dataset.trigger + '"]');

                _.each(groupEles, function (groupEle) {
                  if (groupEle !== actionEle) {
                    var notInTrigger = true;

                    for (i = 0; i < groupTrigger.length; i++) {
                      if (groupEle == groupTrigger[i]) {
                        notInTrigger = false;
                        break;
                      }
                    }

                    if (notInTrigger) {
                      var targetEle = groupEle.getAttribute('data-display-' + dataAttr);
                      this.displayHide(groupEle, targetEle);
                    }
                  }
                }, this);
              }

              ;
            };

            Display.prototype._getEles = function (target, callback) {
              var _this = this;

              var targetEles = document.querySelectorAll(target);

              if (targetEles.length > 0) {
                _.each(targetEles, function (targetEle) {
                  callback.apply(_this, [targetEle]);
                });

                return true;
              }

              return false;
            }; // Private


            Display.prototype._initActions = function () {
              var _this = this;

              var actions = document.querySelectorAll(this.actionSelector);

              _.each(actions, function (action) {
                var target = action.dataset.displayToggle;

                if (action.dataset.state == _this.stateVisible) {
                  _this._getEles(target, function (targetEle) {
                    _this.animate.open(targetEle);
                  });
                }

                action.addEventListener('click', function (e) {
                  if (!action.type || action.type != 'checkbox') {
                    e.preventDefault();

                    _this.displayToggle(e.currentTarget, target, 'toggle');
                  } else if (action.dataset.state == _this.stateVisible && !action.checked || action.dataset.state == _this.stateHidden && action.checked) {
                    _this.displayToggle(e.currentTarget, target, 'toggle');
                  }
                });
              });

              var actions = document.querySelectorAll(this.actionShowSelector);

              _.each(actions, function (action) {
                var target = action.dataset.displayShow;

                if (action.dataset.state == _this.stateVisible) {
                  _this._getEles(target, function (targetEle) {
                    _this.animate.open(targetEle);
                  });
                }

                action.addEventListener('click', function (e) {
                  if (!action.type || action.type != 'checkbox') {
                    e.preventDefault();
                  }

                  _this.displayShow(e.currentTarget, target);
                });
              });
            };

            module.exports = Display;
          }, {
            "./_display-animate.js": 7,
            "./_eventer.js": 10,
            "./_lib.js": 14
          }],
          9: [function (require, module, exports) {
            /*
              Element Queries:
              Media queries but for elements rather than the window.
               html: <div class="my-ele" data-element-query="min-width: 10em, min-width: 30em"> ... </div>
              css: .my-ele[data-min-width~="30em"] { ... }
             */
            var _ = require('./_lib.js');

            var eqElementSelector = '[data-element-query]';

            var ElementQuery = function ElementQuery(eqEle, html) {
              this.eqEle = eqEle;
              this.html = html;
              this.queries = this.getQueries(eqEle.dataset.elementQuery);
              this.addEventListeners();
              this.calcElementQueries();
            };

            ElementQuery.prototype.addEventListeners = function () {
              var _this = this;

              window.addEventListener('resize', _.debounce(function () {
                _this.calcElementQueries();
              }));
            };

            ElementQuery.prototype.calcElementQueries = function () {
              this.emptyCurrentQueries();
              this.each(this.queries, function (query) {
                this.calcElementQuery(query);
              });
              this.applyQueries();
            };

            ElementQuery.prototype.calcElementQuery = function (query) {
              var offsetValue = this.getOffsetValue(query.dimension);
              var computedValue = this.getComputedValue(query.value, query.unit);

              if (query.limit === 'min') {
                if (offsetValue >= computedValue) {
                  this.currentQueries[query.dataKey].push(query);
                }
              } else if (query.limit === 'max') {
                if (offsetValue <= computedValue) {
                  this.currentQueries[query.dataKey].push(query);
                }
              }
            };

            ElementQuery.prototype.getOffsetValue = function (dimension) {
              if (dimension === 'width') {
                return this.eqEle.offsetWidth;
              } else if (dimension === 'height') {
                return this.eqEle.offsetHeight;
              }
            };

            ElementQuery.prototype.getComputedValue = function (value, unit) {
              var computedValue, baseFontSize;

              switch (unit) {
                case 'rem':
                  baseFontSize = this.getFontSize(this.html);
                  computedValue = baseFontSize * value;
                  break;

                case 'em':
                  baseFontSize = this.getFontSize(this.eqEle);
                  computedValue = baseFontSize * value;
                  break;

                default:
                  computedValue = value;
              }

              return computedValue;
            };

            ElementQuery.prototype.applyQueries = function () {
              for (var dataKey in this.currentQueries) {
                if (this.currentQueries.hasOwnProperty(dataKey)) {
                  var data = [];
                  var dataSet = this.currentQueries[dataKey];
                  this.each(dataSet, function (query) {
                    data.push(query.value + query.unit);
                  });
                  this.eqEle.dataset[dataKey] = data.join(' ');
                }
              }
            };
            /* Initial Setup */


            ElementQuery.prototype.emptyCurrentQueries = function () {
              this.currentQueries = {
                minWidth: [],
                maxWidth: [],
                minHeight: [],
                maxHeight: []
              };
            };

            ElementQuery.prototype.getQueries = function (queryStr) {
              var queries = [],
                  queryStrs = queryStr.split(',');
              this.each(queryStrs, function (query) {
                var queryObj = this.getQueryObject(query);

                if (queryObj) {
                  queries.push(queryObj);
                }
              });
              return queries;
            };

            ElementQuery.prototype.getQueryObject = function (queryStr) {
              var queryMatch = queryStr.match(/(min|max)-(width|height):\s?(\d*)(px|rem|em)/);

              if (queryMatch) {
                return {
                  limit: queryMatch[1],
                  dimension: queryMatch[2],
                  value: parseFloat(queryMatch[3]),
                  unit: queryMatch[4],
                  dataKey: this.getDataKey(queryMatch[1], queryMatch[2])
                };
              } else {
                return false;
              }
            };

            ElementQuery.prototype.getFontSize = function (ele) {
              return parseFloat(window.getComputedStyle(ele, null).getPropertyValue('font-size'));
            };

            ElementQuery.prototype.getDataKey = function (limit, dimension) {
              return limit + dimension.charAt(0).toUpperCase() + dimension.slice(1);
            };

            ElementQuery.prototype.each = function (obj, callback) {
              for (var i = 0; i < obj.length; i++) {
                var item = obj[i];
                callback.apply(this, [item, i]);
              }
            };
            /* Wrapper for multiple objects */


            var ElementQueries = function ElementQueries() {
              this.queries = [];
              var html = document.querySelector('html');
              var eqElements = document.querySelectorAll(eqElementSelector);

              for (var i = 0; i < eqElements.length; i++) {
                var eqEle = eqElements[i];
                this.queries.push(new ElementQuery(eqEle, html));
              }
            };

            ElementQueries.prototype.calcQueries = function () {
              _.each(this.queries, function (query) {
                query.calcElementQueries();
              });
            };

            module.exports = ElementQueries;
          }, {
            "./_lib.js": 14
          }],
          10: [function (require, module, exports) {
            var Eventer = function Eventer(caller) {
              this.caller = caller;
              this.caller._events = {};
              this.caller.on = this.on;
              this.caller.off = this.off;
              this.caller.trigger = this.trigger;
            }; // this === caller not Eventer


            Eventer.prototype.on = function (event, callback) {
              if (!this._events[event]) this._events[event] = [];

              this._events[event].push(callback);

              return this._events[event].length - 1;
            };

            Eventer.prototype.off = function (event, id) {
              if (event && id) {
                if (this._events[event][id]) this._events[event][id] = null;
              } else if (event) {
                if (this._events[event]) this._events[event] = null;
              } else {
                this._events = {};
              }
            };

            Eventer.prototype.trigger = function (event, args) {
              if (_typeof(args) !== 'object') args = [args];

              for (var i in this._events[event]) {
                var e = this._events[event][i];
                if (this._events[event].hasOwnProperty(i) && typeof e === 'function') e.apply(this, args);
              }
            };

            module.exports = Eventer;
          }, {}],
          11: [function (require, module, exports) {
            var _ = require('./_lib.js');

            var FloatingLabel = function FloatingLabel() {
              this.classLabel = ".form-group label, .spr-form-label";
              this.classInput = ".form-group input, .form-group textarea, .spr-form-input-text, .spr-form-input-email, .spr-form-input-textarea";
              this.classSelect = ".form-group select";
              this.initLabel();
              this.initInput();
              this.initSelect();

              this._addEventListeners();
            };

            FloatingLabel.prototype.initLabel = function () {
              var labels = document.querySelectorAll(this.classLabel);

              _.each(labels, function (label) {
                var floatingInput = document.getElementById(label.getAttribute('for'));

                if (floatingInput) {
                  var tagName = floatingInput.tagName;
                  var type = floatingInput.type;

                  if (type == "text" || type == "email" || type == "password" || type == "tel" || tagName == "TEXTAREA") {
                    label.classList.add('display_none');
                  }
                }
              });
            };

            FloatingLabel.prototype.initInput = function () {
              var inputs = document.querySelectorAll(this.classInput);

              _.each(inputs, function (input) {
                var tagName = input.tagName;
                var type = input.type;

                if (type == "text" || type == "email" || type == "password" || type == "tel" || tagName == "TEXTAREA") {
                  if (input.value !== "") {
                    input.classList.add('has-floating-label');
                    var label = document.querySelector('label[for="' + input.id + '"]');

                    if (label) {
                      label.classList.add('floating-label');
                    }

                    ;
                  }
                }
              });
            };

            FloatingLabel.prototype.initSelect = function () {
              var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
              var mac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
              var safari = this.is_safari();
              var chrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
              var selects = document.querySelectorAll(this.classSelect);

              _.each(selects, function (select) {
                var label = document.querySelector("label[for='" + select.id + "']");

                if (label) {
                  var labelParent = label.parentNode;

                  while (labelParent != null && labelParent.tagName != "FORM") {
                    labelParent = labelParent.parentNode;
                  }

                  if (labelParent != null) {
                    if (iOS || safari || mac && chrome) {
                      label.classList.add('webkit-mac');
                      select.classList.add('webkit-mac');
                    } else {
                      label.classList.add('floating-label');
                    }
                  }
                }
              });
            };

            FloatingLabel.prototype._addEventListeners = function () {
              var inputs = document.querySelectorAll(this.classInput);

              _.each(inputs, function (input) {
                input.addEventListener('focus', function () {
                  var type = input.type;
                  var tagName = input.tagName;

                  if (type == "text" || type == "email" || type == "password" || type == "tel" || tagName == "TEXTAREA") {
                    input.classList.add('has-floating-label');
                    var labelElt = document.querySelector('label[for="' + input.id + '"]');

                    if (labelElt) {
                      labelElt.classList.remove('display_none');
                      labelElt.classList.add('floating-label');
                    }
                  }
                });
                input.addEventListener('blur', function () {
                  var type = input.type;
                  var tagName = input.tagName;

                  if (type == "text" || type == "email" || type == "password" || type == "tel" || tagName == "TEXTAREA") {
                    if (input.value == "") {
                      input.classList.remove('has-floating-label');
                      var labelElt = document.querySelector('label[for="' + input.id + '"]');

                      if (labelElt) {
                        labelElt.classList.add('display_none');
                        labelElt.classList.remove('floating-label');
                      }
                    }
                  }
                });
              });
            };

            FloatingLabel.prototype._windowObject = function (value) {
              return value != null && _typeof(value) === 'object' && 'setInterval' in value;
            };

            FloatingLabel.prototype.is_safari = function () {
              var freeSelf = this._windowObject((typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self) && self;
              var navigator = freeSelf && freeSelf.navigator;
              var userAgent = (navigator && navigator.userAgent || '').toLowerCase();
              var match = userAgent.match(/version\/(\d+).+?safari/);
              return match !== null;
            };

            module.exports = FloatingLabel;
          }, {
            "./_lib.js": 14
          }],
          12: [function (require, module, exports) {
            var _ = require('./_lib.js');

            var Eventer = require('./_eventer.js');

            var ErrorMessage = function ErrorMessage() {
              this.defaultMessage = window.defaultValidationMessage;
            };

            ErrorMessage.prototype.display = function (input) {
              input.classList.add('has-error');
              var message = input.getAttribute('data-validation-message') || this.defaultMessage;

              if (input.nextElementSibling) {
                input.nextElementSibling.insertAdjacentHTML('afterend', '<p class="form-error">' + message + '</p>');
              } else {
                input.insertAdjacentHTML('afterend', '<p class="form-error">' + message + '</p>');
              }
            };

            ErrorMessage.prototype.remove = function (input) {
              input.classList.remove('has-error');
              var parent = input.parentNode;
              var error = parent.querySelector('.form-error');
              if (error) parent.removeChild(error);
            };
            /* Base validation object */


            var Validator = function Validator(form, selector, callback) {
              new Eventer(this);
              this.form = form;
              this.selector = selector;
              this.callback = callback;
              this.errorMessage = new ErrorMessage();
              this.inputs = form.querySelectorAll(this.selector);

              this._addEventListeners();
            };

            Validator.prototype.validate = function () {
              _.each(this.inputs, function (input) {
                this.validateInput(input);
              }, this);
            };

            Validator.prototype.validateInput = function (input) {
              this.errorMessage.remove(input);
              var result = this.callback(input);

              if (!result && input.getAttribute("required") !== null) {
                this.errorMessage.display(input);
                input.classList.remove('selected');
              } else {
                input.classList.add('selected');
              }

              this.trigger('validated', result);
            }; // Private


            Validator.prototype._addEventListeners = function () {
              var _this = this;

              _.each(this.inputs, function (input) {
                input.addEventListener('blur', function (e) {
                  _this.validateInput(e.currentTarget);
                });
                input.addEventListener('change', function (e) {
                  _this.validateInput(e.currentTarget);
                });

                if (this.form.action.match(/\/cart\/add/)) {
                  input.addEventListener('keypress', function (e) {
                    if (e.key == "Enter" || e.keyCode == "13") {
                      e.preventDefault();
                      return false;
                    }
                  });
                }
              });
            };
            /* Main form validation object */


            var FormValidator = function FormValidator(formEle) {
              this.formEle = formEle;
              this.validators = [];
              this.valid = true; // Return True == Valid
              // Return False == Invalid

              this._registerValidator('[required],[data-required="true"]', function (input) {
                return input.value !== '' && input.value !== null && (input.value.toLowerCase() !== 'blank' || input.tagName !== 'SELECT');
              });

              this._registerValidator('[data-confirm]', function (confirmInput) {
                var originalInput = document.getElementById(confirmInput.dataset.confirm);
                return originalInput != undefined ? originalInput.value === confirmInput.value : false;
              });

              this._registerValidator('[type="email"]', function (input) {
                return input.checkValidity();
              });

              this._registerValidator('[type="tel"]', function (input) {
                return false; // var reg_authorized_value =/^[\d -]+$/;
                // var reg_number = /\D/g;
                // return (reg_authorized_value.test(input.value) && (input.value.replace(reg_number, '').length>5));
              });

              this._addEventListeners();
            }; // Private


            FormValidator.prototype._registerValidator = function (selector, callback) {
              var validator = new Validator(this.formEle, selector, callback);
              this.validators.push(validator);
            };

            FormValidator.prototype._addEventListeners = function () {
              var _this = this; // Stop form submition if invalid


              this.formEle.addEventListener('submit', function () {
                if (!_this.valid) return false;
              }); // Update forms valid state

              _.each(this.validators, function (validator) {
                validator.on('validated', function (result) {
                  if (!result) _this.valid = false;
                });
              }, this);
            };
            /* Multiple form objects */


            var FormsValidation = function FormsValidation() {
              this.formSelector = 'form';
              this.formEles = document.querySelectorAll(this.formSelector);
              this.formValidators = [];

              _.each(this.formEles, function (formEle) {
                var formValidator = new FormValidator(formEle);
                this.formValidators.push(formValidator);
              }, this);
            };

            module.exports = FormsValidation;
          }, {
            "./_eventer.js": 10,
            "./_lib.js": 14
          }],
          13: [function (require, module, exports) {
            var _ = require('./_lib.js');

            var IndexReviews = function IndexReviews() {
              this.ProductReviews = CoreInit.ProductReviews;
              this.tmpProductReviews = {};
              this.renderedReviews = {};
              this.ShopURL = CoreInit.ShopURL;
              this.first_five = 5;
              this.filterReviews();
            };

            IndexReviews.prototype.filterReviews = function () {
              var _this = this;

              var keys = Object.keys(this.ProductReviews);

              if (keys.length > 0) {
                var randomID = keys[keys.length * Math.random() << 0];

                if (Object.keys(this.renderedReviews).length < 5) {
                  if (this.first_five > 0) {
                    this.first_five--;
                    this.tmpProductReviews[randomID] = this.ProductReviews[randomID];
                    delete this.ProductReviews[randomID];
                    $.get("//productreviews.shopifycdn.com/proxy/v4/reviews/product", {
                      product_id: randomID,
                      shop: _this.ShopURL
                    }, function (data) {
                      _this.handleReviews(data);
                    }, "jsonp");
                    this.filterReviews();
                  } else {
                    this.tmpProductReviews[randomID] = this.ProductReviews[randomID];
                    delete this.ProductReviews[randomID];
                    $.get("//productreviews.shopifycdn.com/proxy/v4/reviews/product", {
                      product_id: randomID,
                      shop: _this.ShopURL
                    }, function (data) {
                      _this.handleReviews(data);

                      _this.filterReviews();
                    }, "jsonp");
                  }
                } else {
                  this.renderReviews();
                }
              } else {
                this.renderReviews();
              }
            };

            IndexReviews.prototype.handleReviews = function (reviews) {
              //Test if really have correct reviews
              var aggreg = reviews.aggregate_rating;

              if (aggreg) {
                var sliced = aggreg.toString().slice(35, -10);
                var getRate = JSON.parse(sliced); //var productRate = reviews.product.match(/<meta itemprop="ratingValue" content="([0-9\.]*)/);
                //if(productRate && productRate.length==2){
                //var rate = parseFloat(productRate[1]);

                var rate = parseFloat(getRate.ratingValue);

                if (rate >= 4) {
                  var domReviews = document.createElement("div");
                  domReviews.innerHTML = reviews.reviews;
                  var arrReviews = domReviews.querySelectorAll(".spr-starratings.spr-review-header-starratings");

                  for (var i = 0; i < arrReviews.length; i++) {
                    if (arrReviews[i].querySelectorAll('.spr-icon.spr-icon-star').length >= 4) {
                      var tmp_review = this.tmpProductReviews[reviews.remote_id];
                      tmp_review['review_title'] = domReviews.querySelectorAll('.spr-review-header-title')[i].innerHTML;
                      tmp_review['review_author'] = domReviews.querySelectorAll('[data-author]')[i].dataset.author;
                      tmp_review['review_location'] = domReviews.querySelectorAll('[data-location]')[i].dataset.location;
                      tmp_review['review_date'] = domReviews.querySelectorAll('[data-created_at]')[i].dataset.created_at;
                      tmp_review['review_content'] = domReviews.querySelectorAll('.spr-review-content-body')[i].innerHTML.substring(0, 250) + "...";
                      this.renderedReviews[reviews.remote_id] = tmp_review;
                      break;
                    }
                  }

                  ;
                }
              }

              delete this.tmpProductReviews[reviews.remote_id];
            };

            IndexReviews.prototype.renderReviews = function () {
              var reviewsElts = document.querySelectorAll("[id^='review-']");
              var keys = Object.keys(this.renderedReviews);

              for (var i = 0; i < reviewsElts.length && i < keys.length; i++) {
                var elt = reviewsElts[i];
                var review = this.renderedReviews[keys[i]];
                var img_link = elt.querySelector(".testimonial-image.index-reviews-product-image");
                img_link.href = review["product_url"];
                var img = img_link.querySelector("img");
                img.src = review["featured_image"];
                img.alt = review["title"];
                var link = elt.querySelector(".index-reviews-product-link");
                link.href = img_link.href;
                link.innerHTML = review["title"];
                elt.querySelector(".index-reviews-title").innerHTML = review['review_title'];
                elt.querySelector(".index-reviews-name").innerHTML = review['review_author'];

                if (review['review_location'] != "") {
                  elt.querySelector(".index-reviews-location").innerHTML = review['review_location'];
                } else {
                  elt.querySelector(".index-reviews-location-from").classList.add('display_none');
                }

                elt.querySelector(".index-reviews-date").innerHTML = review['review_date'];
                var content = elt.querySelector(".index-reviews-content");
                content.querySelector("a").href = link.href + '?product_reviews=true#product-descriptions-anchor';
                content.querySelector(".index-reviews-content-text").innerHTML = review["review_content"];
              }
            };

            module.exports = IndexReviews;
          }, {
            "./_lib.js": 14
          }],
          14: [function (require, module, exports) {
            module.exports = {
              /*
                Array Functions
              */
              // For each item in Array
              each: function each(arr, callback, ctx) {
                for (var i = 0; i < arr.length; i++) {
                  ctx = ctx || arr[i];
                  callback.apply(ctx, [arr[i], i]);
                }
              },
              // For each item in Object
              eachIn: function eachIn(obj, callback, ctx) {
                for (var k in obj) {
                  if (obj.hasOwnProperty(k)) {
                    ctx = ctx || obj[k];
                    callback.apply(ctx, [obj[k], k]);
                  }
                }
              },
              // Return true if item is in Array
              inArray: function inArray(needle, haystack) {
                var found = false;
                this.each(haystack, function (hay) {
                  if (needle === hay) found = true;
                });
                return found;
              },
              // return the last item in the array
              last: function last(arr) {
                return arr[arr.length - 1];
              },

              /*
                String Functions
              */
              // Captialse the first char in String
              capitalise: function capitalise(str) {
                return str[0].toUpperCase() + str.slice(1);
              },

              /*
                Event Functions
              */
              // Run code when the page is ready
              ready: function ready(callback, ctx) {
                if (typeof callback !== 'function') return;

                if (document.readyState !== 'loading') {
                  callback.apply(ctx);
                } else {
                  document.addEventListener('DOMContentLoaded', function () {
                    callback.apply(ctx);
                  });
                }
              },
              // CUSTOM FUNC for seido to trigger things when the core is ready
              readyCore: function readyCore(callback, ctx) {
                if (typeof callback !== 'function') return;

                if (window.SeidoCore.ready) {
                  callback.apply(ctx);
                } else {
                  window.SeidoCore.on('ready', function () {
                    callback.apply(ctx);
                  });
                }
              },
              // CUSTOM FUNC for seido to trigger things when the product is ready
              readyProduct: function readyProduct(callback, ctx) {
                if (typeof callback !== 'function') return;

                if (window.ProductCore.ready) {
                  callback.apply(ctx);
                } else {
                  window.ProductCore.on('ready', function () {
                    callback.apply(ctx);
                  });
                }
              },
              // Make thing not happen until finished?
              // i.e. don't act on every window resize event, just the last one when we need it.
              debounce: function debounce(callback, wait, ctx) {
                var timeout, timestamp, args;
                wait = wait || 100;

                var later = function later() {
                  var last = new Date().getTime() - timestamp;

                  if (last < wait && last >= 0) {
                    timeout = setTimeout(later, wait - last);
                  } else {
                    timeout = null;
                    callback.apply(ctx, args);
                  }
                };

                return function () {
                  ctx = ctx || this;
                  args = arguments;
                  timestamp = new Date().getTime();
                  if (!timeout) timeout = setTimeout(later, wait);
                };
              },
              // Don't swamp us with events
              // good for things like scroll and resize
              throttle: function throttle(callback, limit, ctx) {
                limit = limit || 200;
                var wait = false;
                return function () {
                  if (!wait) {
                    callback.apply(ctx, arguments);
                    wait = true;
                    setTimeout(function () {
                      wait = false;
                    }, limit);
                  }
                };
              },
              // Get the value of a url parameter
              getUrlParameter: function getUrlParameter(sParam) {
                var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName,
                    i;

                for (i = 0; i < sURLVariables.length; i++) {
                  sParameterName = sURLVariables[i].split('=');

                  if (sParameterName[0] === sParam) {
                    return sParameterName[1] === undefined ? true : sParameterName[1];
                  }
                }
              },
              // Convenience function to add the money span markup.
              moneying: function moneying(price) {
                // if("" != '')
                //   var newPrice =  Currency.formatMoney(price,Currency.moneyFormats[currentCurrency]["money_with_currency_format"]);
                // else
                //   var newPrice =  Currency.formatMoney(price,Currency.moneyFormats[CoreInit.ShopCurrency]["money_with_currency_format"]);
                // // Currency.moneyFormats[currentCurrency]["money_with_currency_format"] +
                // // console.log("price",price);
                // //         var newPrice =  ((price/100).toLocaleString({  currency: currentCurrency }));
                // //console.log("newPrice",newPrice);
                // var currentLang = document.querySelector('[data-currency-primary]').getAttribute("lang");
                // // console.log("Shopify",Shopify.currency);
                // var formattedPrice = new Intl.NumberFormat({ style: 'currency', currency: currentCurrency, minimumFractionDigits: 2 }).format(price/100);
                // // console.log("formattedPrice",formattedPrice);
                var currentCurrency = document.querySelector('[data-currency-primary]').getAttribute("data-currency-primary");
                var daPrice = Currency.formatMoneyUpdateCart(price, Currency.moneyFormats[currentCurrency]["money_with_currency_format"]);
                return '<span data-currency-' + currentCurrency + '="' + daPrice + '">' + daPrice + '</span>';
              },
              // Get height of element (with padding and marging)
              outerHeight: function outerHeight(el) {
                var height = el.offsetHeight;
                var style = getComputedStyle(el);
                height += parseInt(style.marginTop) + parseInt(style.marginBottom);
                return height;
              },
              //
              smoothScroll: function smoothScroll(target) {
                var yPosition = -window.getComputedStyle(target, null).marginTop.replace("px", "");

                while (target) {
                  // yPosition += (target.offsetTop - window.getComputedStyle(target, null).marginTop.replace("px", ""));
                  yPosition += target.offsetTop;
                  target = target.offsetParent;
                }

                var windowSize = window.getComputedStyle(document.body, ':after').getPropertyValue('content').replace(/['"]/g, ''); //In XS the header is already fixed and in SM no header
                //In the other cases when the header is fixed the logo height is 0 or the difference after scrolling is around 65px
                // yPosition -= (windowSize == "xs" || document.querySelector('.site-logo-wrapper').offsetHeight == 0) ? parseInt(document.querySelector(".site-header-menu").offsetHeight):
                //              windowSize == "sm" ? 0 :
                //              "english" == "japanese" ? 180: 170;

                yPosition -= windowSize == "xs" || document.querySelector('.site-logo-wrapper').offsetHeight == 0 ? parseInt(document.querySelector(".site-header-menu").offsetHeight) : windowSize == "sm" ? 0 : window.location.href.indexOf("/ja") != -1 ? 180 : 170; //if (window.location.href.indexOf("/ja") != -1)

                $('.offcanvas-main').animate({
                  scrollTop: yPosition
                }, 1000);
              },
              uniqueArray: function uniqueArray(arr) {
                var n = {},
                    r = [];

                for (var i = 0; i < arr.length; i++) {
                  if (!n[arr[i]]) {
                    n[arr[i]] = true;
                    r.push(arr[i]);
                  }
                }

                return r;
              }
            };
          }, {}],
          15: [function (require, module, exports) {
            /*
               Lightbox:
               To create a light box add a `data-lightbox` attribute to an <a> element.
              The light box will be triggered when the <a> element is clicked.
               The `href` attribute on the <a> element will be used as the url for the lightboxes img src
               If the `data-lightbox` attribute has a value it will be grouped with other lightboxes that have the same value.
              This is optional.
               To add a caption to the image add a `data-lightbox-caption` attribute to the <a> element that trigers the lightbox,
              with the value containing the caption to be shown.
             */
            var _ = require('./_lib.js');

            var Eventer = require('./_eventer.js');

            var VideoPlayer = require('./_video-player.js');
            /*
              LightboxGroup
            */


            var LightboxGroup = function LightboxGroup(id, triggers, carouselFactory, videoPlayer) {
              new Eventer(this);
              this.id = id;
              this.triggers = triggers;
              this.carouselFactory = carouselFactory;
              this.videoPlayer = videoPlayer;
              this.ele = this._buildLightbox();
              this.isLoaded = false;
              var val;
              Object.defineProperty(this, 'lightboxWidth', {
                set: function set(newVal) {
                  val = newVal && newVal !== 'none' ? newVal + 'px' : newVal;
                  this.ele.querySelector('.lightbox').style.maxWidth = val;
                }
              });

              this._addEventHanders();

              this._initCarousel();
            };

            LightboxGroup.prototype.showLightbox = function (targetURL, index) {
              // Open lightbox: This order is delicate/brittle do not change it.
              this.ele.style.display = '';

              if (index == 0) {
                this.carousel.itemTransition('none'); // remove the transition so it dosn't effect the open

                this.carousel.setCarouselWidth(); // set the carousels width so that it has a width now it's visible. This is needed for it to calculate the offset of the images
              }

              var isReady = true;
              var images = this.ele.querySelectorAll('[data-carousel-clip]>ul>li img');

              for (var i = 0; i < images.length; i++) {
                //Chosen 50 because of IE
                if (images[i].offsetWidth < 250) {
                  isReady = false;
                  break;
                }
              }

              if (isReady) {
                this.lightboxWidth = this.carousel.imageWidth(); // constrain the lightbox so the controls aren't the width of the screen once things have stoped moving around

                this.carousel.setCarouselWidth(); // reset the carousels width so the lis get the new width of the lightbox
                // Set the carousel to the correct slide

                var targetId = '#' + this._carouselItemId(targetURL);

                this.carousel.goToSlide(targetId);
                this.carousel.itemTransition('.3s'); // add back in the slide transition now we are open
              } else if (index < 30) {
                this.ele.style.display = 'none';

                var _this = this;

                setTimeout(function () {
                  _this.showLightbox(targetURL, index + 1);
                }, 100);
              } else {
                this.ele.style.display = 'none';
              }
            };

            LightboxGroup.prototype.initImage = function () {
              var _this = this;

              var images = this.ele.querySelectorAll('[data-carousel-clip]>ul>li img');

              if (images.length > 0 && images[0].src == "") {
                _.each(images, function (img) {
                  img.src = img.dataset.src;
                });
              }

              this.isLoaded = true;
            };

            LightboxGroup.prototype.hideLightbox = function () {
              this.ele.style.display = 'none';
              this.carouselWidth = 'none';

              if (this.videoPlayer) {
                var playerIds = this.ele.querySelectorAll('[data-video-src]');

                _.each(playerIds, function (playerId) {
                  this.videoPlayer.Players["iframe-" + playerId.dataset.videoSrc].pauseVideo();
                }, this);
              }
            }; // LightboxGroup: Private


            LightboxGroup.prototype._addEventHanders = function () {
              var _this = this; // Open events


              _.each(this.triggers, function (trigger) {
                trigger.addEventListener('click', function (e) {
                  e.preventDefault();

                  if (!_this.isLoaded) {
                    _this.initImage();
                  }

                  _this.showLightbox(e.currentTarget.getAttribute('href'), 0);
                });
              }); // Close events


              this.ele.addEventListener('click', function (e) {
                if (e.target === _this.ele) {
                  _this.hideLightbox();
                }
              });
              this.ele.querySelector('[data-lightbox-close]').addEventListener('click', function (e) {
                _this.hideLightbox();
              });
            };

            LightboxGroup.prototype._initCarousel = function () {
              // Show and then hide the carousel as it its loaded so that it sets the correct widths for images
              if (this.carouselFactory) {
                var carouselEle = this.ele.querySelector('[data-carousel]');
                this.ele.style.display = '';
                this.carousel = this.carouselFactory.create(carouselEle);
                this.ele.style.display = 'none';
              }
            };

            LightboxGroup.prototype._buildLightbox = function () {
              var fragment = document.createDocumentFragment(); // Build lightbox markup

              var ele = document.createElement('div');
              ele.id = this.id;
              ele.classList.add('lightbox-wrapper');
              ele.style.display = 'none';
              ele.innerHTML = '<div class="lightbox">\
        <button data-lightbox-close>\
          <svg class="icon icon-close icon-inline">\
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-close"></use>\
          </svg>\
          <span class="icon-text-hidden">close</span>\
        </button>\
        ' + this._buildCarousel() + '</div>';
              fragment.appendChild(ele); // Add it to page

              document.querySelector('body').appendChild(fragment);
              return document.querySelector('#' + this.id);
            };

            LightboxGroup.prototype._buildCarousel = function () {
              return '<div data-carousel>\
          ' + (this.triggers.length == 1 ? '' : '<a href="#" data-carousel-action="prev">\
              <svg class="icon icon-arrow-left icon-inline">\
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-left"></use>\
              </svg>\
              <span class="icon-text-hidden">Previous</span>\
            </a>\
            <a href="#" data-carousel-action="next">\
              <svg class="icon icon-arrow-right icon-inline">\
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-right"></use>\
              </svg>\
              <span class="icon-text-hidden">Next</span>\
            </a>') + '\
          <div data-carousel-clip>\
            <ul>' + this._buildCarouselItems() + '</ul>\
          </div>\
        </div>';
            };

            LightboxGroup.prototype._buildCarouselItems = function () {
              var items = '';

              _.each(this.triggers, function (trigger, triggerId) {
                if (trigger.hasAttribute('data-lightbox-caption')) {
                  items += '<li id="' + this._carouselItemId(trigger.getAttribute('href')) + '">\
              <figure>\
                <img data-src="' + trigger.getAttribute('href') + '" alt="' + trigger.dataset.lightboxCaption + '">\
                <figcation>' + trigger.dataset.lightboxCaption + '</figcation>\
              </figure>\
            </li>';
                } else if (trigger.dataset.videoSrc) {
                  items += '<li id="' + this._carouselItemId(trigger.getAttribute('href')) + '" data-video-src="' + trigger.dataset.videoSrc + '"><iframe id="iframe-' + trigger.dataset.videoSrc + '" width="840" height="473" src="' + trigger.getAttribute('href') + '?enablejsapi=1" frameborder="0" allowfullscreen=""></iframe></li>';
                  this.videoPlayer.delayPlayer['iframe-' + trigger.dataset.videoSrc] = trigger.dataset.videoSrc;
                } else {
                  var alt_elt = trigger.querySelector('[alt]');
                  items += '<li id="' + this._carouselItemId(trigger.getAttribute('href')) + '"><img data-src="' + trigger.getAttribute('href') + '" alt="' + (alt_elt && alt_elt.alt != "" ? alt_elt.alt : trigger.title) + '"></li>';
                }
              }, this);

              return items;
            };

            LightboxGroup.prototype._carouselItemId = function (url) {
              var urlParts = url.split('/');

              var urlIdParts = _.last(urlParts).split('.');

              return this.id + '-' + urlIdParts[0];
            };
            /*
            LightboxGroup.prototype._carouselItemTransition = function (transition) {
              var clipLis = this.ele.querySelectorAll('[data-carousel-clip] li');
              _.each(clipLis, function (li) {
                li.style.transition = transition;
              });
            };
            */

            /*
              Main:
                Multiple Lightboxes
            */


            var Lightbox = function Lightbox(carouselFactory) {
              this.carouselFactory = carouselFactory;
              this.lightboxGroups = [];
              this.lightboxTriggers = {};
              this.addLightBoxData();
              this.lightboxTriggerEles = document.querySelectorAll('[data-lightbox]');

              for (var i = 0; i < this.lightboxTriggerEles.length; i++) {
                if (this.lightboxTriggerEles[i].dataset.videoSrc) {
                  this.videoPlayer = new VideoPlayer();
                  break;
                }
              }

              this._buildTriggerObjs();

              this._buildGroupObjs();

              if (this.videoPlayer) {
                this.videoPlayer.buildPlayers();
              }

              this._addEventHanders();
            }; //temporary function to add automatically data-lightbox


            Lightbox.prototype.addLightBoxData = function () {
              jQuery('.has-lightbox img').not('img[data-nolightbox=yes]').not('a > img').each(function () {
                $this = jQuery(this); // Matching images that aren't already shown in their original size.

                var re = /(_icon)|(_thumb)|(_small)|(_compact)|(_medium)|(_large)|(_grande)|(_\d+x\d+)|(_\d+x)/;
                var src = $this.attr('src');
                var alt = $this.attr('alt');

                if (re.test(src)) {
                  // Determining the URL to the original image.
                  var href = src.replace(re, '');
                  href = href.replace(/(_crop_top)|(_crop_center)|(_crop_bottom)|(_crop_left)|(_crop_right)/, ''); // Activating lightbox.

                  $this.wrap('<a></a>').parent().attr('data-lightbox', '').attr('href', href);

                  if (alt != "") {
                    $this.parent().attr('data-lightbox-caption', alt);
                  }
                }
              });
            }; // Main: Private


            Lightbox.prototype._buildTriggerObjs = function () {
              var groupID,
                  noGroupID = 0,
                  _this = this;

              _.each(this.lightboxTriggerEles, function (lightboxTriggerEle) {
                groupID = lightboxTriggerEle.dataset.lightbox || '_noGroup' + noGroupID++;

                if (!_this.lightboxTriggers[groupID]) {
                  _this.lightboxTriggers[groupID] = [];
                }

                _this.lightboxTriggers[groupID].push(lightboxTriggerEle);
              });
            };

            Lightbox.prototype._buildGroupObjs = function () {
              var group,
                  _this = this;

              _.eachIn(this.lightboxTriggers, function (triggers, groupID) {
                group = new LightboxGroup(groupID, triggers, _this.carouselFactory, _this.videoPlayer);

                _this.lightboxGroups.push(group);
              });
            };

            Lightbox.prototype._addEventHanders = function () {
              var _this = this;

              var loadImg = function loadImg() {
                document.querySelector('.offcanvas-main').removeEventListener('scroll', loadImg);

                _.each(_this.lightboxGroups, function (lightBox) {
                  if (!lightBox.isLoaded) {
                    lightBox.initImage();
                  }
                });
              };

              document.querySelector('.offcanvas-main').addEventListener('scroll', loadImg);
            };

            module.exports = Lightbox;
          }, {
            "./_eventer.js": 10,
            "./_lib.js": 14,
            "./_video-player.js": 29
          }],
          16: [function (require, module, exports) {
            /*
              Load an external svg file from the cdn to leverage browser caching
              source: https://css-tricks.com/ajaxing-svg-sprite/
            */
            var LoadIcons = function LoadIcons() {
              var ajax = new XMLHttpRequest();
              ajax.addEventListener('load', function (e) {
                document.body.insertBefore(this.responseXML.documentElement, document.body.childNodes[0]);
              });
              ajax.addEventListener('error', function (e) {
                console.log('AJAX ERROR:', this, e);
              });
              ajax.open("GET", this.getPath(), true);
              ajax.send();
            };

            LoadIcons.prototype.getPath = function () {
              // make sure the path includes 'https:' as it won't load on mobile safari if it doesn't
              return window.iconsPath.indexOf('https') === -1 ? window.iconsPath.indexOf('http') === -1 ? 'https:' + window.iconsPath : window.iconsPath.replace('http', 'https') : window.iconsPath;
            };

            module.exports = LoadIcons;
          }, {}],
          17: [function (require, module, exports) {
            var _ = require('./_lib.js');

            var mq = require('./_mq-size.js');

            var Eventer = require('./_eventer.js');

            var MenuToggle = function MenuToggle() {
              new Eventer(this);
              this.toggleSelector = '[data-menu]';
              this.actionSelector = '[data-menu-action]';
              this.wrapperSelector = '[data-menu-wrapper]';
              this.init();
            };

            MenuToggle.prototype.init = function () {
              this.toggleEle = document.querySelector(this.toggleSelector);
              this.wrapperEle = document.querySelector(this.wrapperSelector);

              if (this.toggleEle && this.wrapperEle) {
                this._initActions();

                this._addEventListeners(); // open the menu on all pages except product, ut only if screen is larger than mobile


                if (!(this.toggleEle.classList.contains('product') || this.toggleEle.classList.contains('product-jisei') || "the-budoexport-blog" != "" && this.toggleEle.classList.contains("the-budoexport-blog")) && mq.size() !== 'xs') {
                  this.toggleMenu(); // bump on first load

                  var _this = this;

                  setTimeout(function () {
                    _this.trigger('menuToggled');
                  }, 300);
                }
              }
            };

            MenuToggle.prototype.toggleMenu = function () {
              if (this.toggleEle.dataset.menu === 'open') {
                this.toggleEle.dataset.menu = 'closed';
              } else {
                this.toggleEle.dataset.menu = 'open';
              } // force ie repaint


              $(".offcanvas-main").addClass('forcePaint').removeClass('forcePaint');

              var _this = this;

              setTimeout(function () {
                _this.trigger('menuToggled');
              }, 100);
            }; // Private


            MenuToggle.prototype._initActions = function () {
              var _this = this;

              var actions = document.querySelectorAll(this.actionSelector);

              _.each(actions, function (action) {
                action.addEventListener('click', function (e) {
                  e.preventDefault();

                  _this.toggleMenu();
                });
              });
            };

            MenuToggle.prototype._addEventListeners = function () {
              var _this = this; // close the open draw if clicking on the disabled area


              this.wrapperEle.addEventListener('click', function (e) {
                if (e.target === _this.wrapperEle && mq.size() === 'xs') {
                  _this.toggleMenu();
                }
              }); // Swipe menu closed on small screens

              this.wrapperEle.onswipeLeft = function (e) {
                if (e.target === _this.wrapperEle && mq.size() === 'xs' && _this.toggleEle.dataset.menu === 'open') {
                  _this.toggleMenu();

                  return false;
                }
              };

              var siteMenu = document.querySelector('#site-menu');

              if (siteMenu) {
                siteMenu.onswipeLeft = function (e) {
                  if (mq.size() === 'xs' && _this.toggleEle.dataset.menu === 'open') {
                    _this.toggleMenu();

                    return false;
                  }
                };
              }
            };

            module.exports = MenuToggle;
          }, {
            "./_eventer.js": 10,
            "./_lib.js": 14,
            "./_mq-size.js": 18
          }],
          18: [function (require, module, exports) {
            module.exports.size = function () {
              return window.getComputedStyle(document.body, ':after').getPropertyValue('content').replace(/['"]/g, '');
            };
          }, {}],
          19: [function (require, module, exports) {
            var _ = require('./_lib.js');

            var Eventer = require('./_eventer.js');
            /*
              OffCanvasAction
              This is a wrapper for the action buttons to handle the click events
            */


            var OffCanavasAction = function OffCanavasAction(ele) {
              new Eventer(this);
              this.ele = ele;
              this.target = ele.dataset.offcanvasTarget;
              this.section = ele.dataset.offcanvasTargetSection || false;

              this._addEventListeners();
            };

            OffCanavasAction.prototype.addClass = function (className) {
              this.ele.classList.add(className);
            };

            OffCanavasAction.prototype.removeClass = function (className) {
              this.ele.classList.remove(className);
            }; // Private


            OffCanavasAction.prototype._addEventListeners = function () {
              var _this = this;

              this.ele.addEventListener('click', function (e) {
                e.preventDefault();

                _this.trigger('actionOffCanvas', [_this.target, _this.section]);
              });
            };
            /*
              OffCanvas Main
              Handles the main open and close functions based on the action that is triggered
            */


            var OffCanvas = function OffCanvas() {
              this.wrapperSelector = '[data-offcanvas]';
              this.actionSelector = '[data-offcanvas-target]';
              this.sidebarSelector = '.offcanvas-sidebar';
              this.currentPanel = false;
              this.currentSection = false;
              this.actions = [];
              this.init();
            };

            OffCanvas.prototype.init = function () {
              this.wrapper = document.querySelector(this.wrapperSelector);

              if (this.wrapper) {
                this.sidebar = document.querySelector(this.sidebarSelector);

                this._initActions();

                this._addEventListeners();
              }
            };

            OffCanvas.prototype.toggleOffCanvas = function (target, section) {
              if (this.currentPanel === target) {
                if (this.currentSection === section || section === false) {
                  // matches current panel so close it
                  this.closeOffCanvas();
                  this.toggleActiveAction();
                } else {
                  // keep panel open but change section
                  this.updateOffCanvasSection(section);
                }
              } else {
                // close panel and open new one
                this.closeOffCanvas();
                this.updateOffCanvasSection(section);
                this.openOffCanvas(target);
              }
            };

            OffCanvas.prototype.openOffCanvas = function (target) {
              this.currentPanel = this.wrapper.dataset.offcanvas = target; //Do this in JS because of IE11

              this.sidebar.style.transform = "translateX(0)";
            };

            OffCanvas.prototype.closeOffCanvas = function () {
              this.currentPanel = this.wrapper.dataset.offcanvas = false;
              this.sidebar.style.transform = "translateX(100%)";
            };

            OffCanvas.prototype.updateOffCanvasSection = function (section) {
              if (section) {
                this.currentSection = this.wrapper.dataset.offcanvasSection = section;
                this.toggleActiveAction(section);
              }
            };

            OffCanvas.prototype.toggleActiveAction = function (section) {
              _.each(this.actions, function (action) {
                action.removeClass('is-active');

                if (action.section === section) {
                  action.addClass('is-active');
                }
              }); // force ie repaint


              $(".offcanvas").addClass('forcePaint').removeClass('forcePaint');
            }; // Private


            OffCanvas.prototype._initActions = function () {
              var action;
              var actionButtons = document.querySelectorAll(this.actionSelector);

              var _this = this;

              _.each(actionButtons, function (actionButton) {
                action = new OffCanavasAction(actionButton);
                action.on('actionOffCanvas', function (target, section) {
                  _this.toggleOffCanvas(target, section);
                });

                _this.actions.push(action);
              });
            };

            OffCanvas.prototype._addEventListeners = function () {
              var _this = this; // close the open draw if clicking on the disabled area


              this.wrapper.addEventListener('click', function (e) {
                if (e.target === _this.wrapper) {
                  _this.closeOffCanvas();

                  _this.toggleActiveAction();
                }
              }); // Swipe menu closed

              this.wrapper.onswipeRight = function (e) {
                if (e.target === _this.wrapper) {
                  _this.closeOffCanvas();

                  _this.toggleActiveAction();

                  return false;
                }
              };

              document.querySelector('.offcanvas-sidebar').onswipeRight = function (e) {
                if (_this.currentPanel) {
                  _this.closeOffCanvas();

                  _this.toggleActiveAction();

                  return false;
                }
              };
            };

            module.exports = OffCanvas;
          }, {
            "./_eventer.js": 10,
            "./_lib.js": 14
          }],
          20: [function (require, module, exports) {
            /* Paid shipping countries */
            var zone_l = ["Chile", "Djibouti", "Ecuador", "Ghana", "Paraguay", "Uruguay"];
            var zone_m = ["Bolivia", "Falkland Islands (Malvinas)", "Angola", "Chad", "Comoros", "Equatorial Guinea", "Gambia", "Guinea", "Guinea Bissau", "Lesotho", "Liberia", "Malawi", "Mali", "Mauritania", "Mozambique", "Namibia", "Benin", "Burkina Faso", "Burundi", "Cape Verde", "Republic of Cameroon", "Sao Tome And Principe", "Suriname", "Swaziland", "Zambia"];
            var zone_n = ["Algeria", "Botswana", "Côte d'Ivoire", "Ethiopia", "Gabon", "Kenya", "Madagascar", "Reunion", "Rwanda", "Senegal", "Sierra Leone", "Tanzania, United Republic Of", "Togo", "Uganda", "Zimbabwe", "Mauritius", "Morocco", "Nigeria", "South Africa"];
            var zone_p = ["Venezuela", "Peru", "Argentina", "Colombia", "Egypt", "Tunisia"];
            var zone_q = ["Central African Republic", "Congo", "Congo, The Democratic Republic Of The", "Eritrea", "Faroe Islands", "Nauru", "Saint Helena", "Somalia", "Tuvalu", "Wallis And Futuna", "Yemen", "South Sudan", "Sudan", "Seychelles", "Niger"];
            var zone_s = ["Aland Islands", "St. Vincent", "Turks and Caicos Islands"];
            var zone_u = ["French Polynesia", "Bahamas", "Belize", "Bermuda", "Cayman Islands", "Dominica", "Dominican Republic", "Georgia", "Grenada", "Guatemala", "Guyana", "Moldova, Republic of", "Montenegro", "Montserrat", "Aruba", "French Guiana"];
            var zone_w = ["Curaçao", "Anguilla", "Antigua And Barbuda", "Haiti", "Netherlands Antilles", "Nicaragua", "Saint Barthélemy", "Saint Lucia", "Saint Martin", "Sint Maarten"];
            var PaidShipping = {
              zones: [zone_l, zone_m, zone_n, zone_p, zone_q, zone_s, zone_u, zone_w],
              countries: zone_l.concat(zone_m, zone_n, zone_p, zone_q, zone_s, zone_u, zone_w)
            };
            module.exports = PaidShipping;
          }, {}],
          21: [function (require, module, exports) {
            /*
            * classList.js: Cross-browser full element.classList implementation.
            * 1.1.20150312
            *
            * By Eli Grey, http://eligrey.com
            * License: Dedicated to the public domain.
            *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
            */

            /*global self, document, DOMException */

            /*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
            module.exports = function () {
              if ("document" in self) {
                // Full polyfill for browsers with no classList support
                // Including IE < Edge missing SVGElement.classList
                if (!("classList" in document.createElement("_")) || document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg", "g"))) {
                  (function (view) {
                    if (!('Element' in view)) return;

                    var classListProp = "classList",
                        protoProp = "prototype",
                        elemCtrProto = view.Element[protoProp],
                        objCtr = Object,
                        strTrim = String[protoProp].trim || function () {
                      return this.replace(/^\s+|\s+$/g, "");
                    },
                        arrIndexOf = Array[protoProp].indexOf || function (item) {
                      var i = 0,
                          len = this.length;

                      for (; i < len; i++) {
                        if (i in this && this[i] === item) {
                          return i;
                        }
                      }

                      return -1;
                    } // Vendors: please allow content code to instantiate DOMExceptions
                    ,
                        DOMEx = function DOMEx(type, message) {
                      this.name = type;
                      this.code = DOMException[type];
                      this.message = message;
                    },
                        checkTokenAndGetIndex = function checkTokenAndGetIndex(classList, token) {
                      if (token === "") {
                        throw new DOMEx("SYNTAX_ERR", "An invalid or illegal string was specified");
                      }

                      if (/\s/.test(token)) {
                        throw new DOMEx("INVALID_CHARACTER_ERR", "String contains an invalid character");
                      }

                      return arrIndexOf.call(classList, token);
                    },
                        ClassList = function ClassList(elem) {
                      var trimmedClasses = strTrim.call(elem.getAttribute("class") || ""),
                          classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [],
                          i = 0,
                          len = classes.length;

                      for (; i < len; i++) {
                        this.push(classes[i]);
                      }

                      this._updateClassName = function () {
                        elem.setAttribute("class", this.toString());
                      };
                    },
                        classListProto = ClassList[protoProp] = [],
                        classListGetter = function classListGetter() {
                      return new ClassList(this);
                    }; // Most DOMException implementations don't allow calling DOMException's toString()
                    // on non-DOMExceptions. Error's toString() is sufficient here.


                    DOMEx[protoProp] = Error[protoProp];

                    classListProto.item = function (i) {
                      return this[i] || null;
                    };

                    classListProto.contains = function (token) {
                      token += "";
                      return checkTokenAndGetIndex(this, token) !== -1;
                    };

                    classListProto.add = function () {
                      var tokens = arguments,
                          i = 0,
                          l = tokens.length,
                          token,
                          updated = false;

                      do {
                        token = tokens[i] + "";

                        if (checkTokenAndGetIndex(this, token) === -1) {
                          this.push(token);
                          updated = true;
                        }
                      } while (++i < l);

                      if (updated) {
                        this._updateClassName();
                      }
                    };

                    classListProto.remove = function () {
                      var tokens = arguments,
                          i = 0,
                          l = tokens.length,
                          token,
                          updated = false,
                          index;

                      do {
                        token = tokens[i] + "";
                        index = checkTokenAndGetIndex(this, token);

                        while (index !== -1) {
                          this.splice(index, 1);
                          updated = true;
                          index = checkTokenAndGetIndex(this, token);
                        }
                      } while (++i < l);

                      if (updated) {
                        this._updateClassName();
                      }
                    };

                    classListProto.toggle = function (token, force) {
                      token += "";
                      var result = this.contains(token),
                          method = result ? force !== true && "remove" : force !== false && "add";

                      if (method) {
                        this[method](token);
                      }

                      if (force === true || force === false) {
                        return force;
                      } else {
                        return !result;
                      }
                    };

                    classListProto.toString = function () {
                      return this.join(" ");
                    };

                    if (objCtr.defineProperty) {
                      var classListPropDesc = {
                        get: classListGetter,
                        enumerable: true,
                        configurable: true
                      };

                      try {
                        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                      } catch (ex) {
                        // IE 8 doesn't support enumerable:true
                        if (ex.number === -0x7FF5EC54) {
                          classListPropDesc.enumerable = false;
                          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                        }
                      }
                    } else if (objCtr[protoProp].__defineGetter__) {
                      elemCtrProto.__defineGetter__(classListProp, classListGetter);
                    }
                  })(self);
                } else {
                  // There is full or partial native classList support, so just check if we need
                  // to normalize the add/remove and toggle APIs.
                  (function () {
                    var testElement = document.createElement("_");
                    testElement.classList.add("c1", "c2"); // Polyfill for IE 10/11 and Firefox <26, where classList.add and
                    // classList.remove exist but support only one argument at a time.

                    if (!testElement.classList.contains("c2")) {
                      var createMethod = function createMethod(method) {
                        var original = DOMTokenList.prototype[method];

                        DOMTokenList.prototype[method] = function (token) {
                          var i,
                              len = arguments.length;

                          for (i = 0; i < len; i++) {
                            token = arguments[i];
                            original.call(this, token);
                          }
                        };
                      };

                      createMethod('add');
                      createMethod('remove');
                    }

                    testElement.classList.toggle("c3", false); // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
                    // support the second argument.

                    if (testElement.classList.contains("c3")) {
                      var _toggle = DOMTokenList.prototype.toggle;

                      DOMTokenList.prototype.toggle = function (token, force) {
                        if (1 in arguments && !this.contains(token) === !force) {
                          return force;
                        } else {
                          return _toggle.call(this, token);
                        }
                      };
                    }

                    testElement = null;
                  })();
                }
              }
            };
          }, {}],
          22: [function (require, module, exports) {
            module.exports = function () {
              if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
              if (!Element.prototype.closest) Element.prototype.closest = function (s) {
                var el = this;
                var ancestor = this;
                if (!document.documentElement.contains(el)) return null;

                do {
                  if (ancestor.matches(s)) return ancestor;
                  ancestor = ancestor.parentElement;
                } while (ancestor !== null);

                return null;
              };
            };
          }, {}],
          23: [function (require, module, exports) {
            module.exports = function () {
              var forEach = [].forEach,
                  regex = /^data-(.+)/,
                  dashChar = /\-([a-z])/ig;
              el = document.createElement('div');
              if (el.dataset != undefined) return;

              function toCamelCase(s) {
                return s.replace(dashChar, function (m, l) {
                  return l.toUpperCase();
                });
              }

              Object.defineProperty(Element.prototype, 'dataset', {
                get: function get() {
                  var dataset = {};
                  forEach.call(this.attributes, function (attr) {
                    if (match = attr.name.match(regex)) dataset[toCamelCase(match[1])] = attr.value;
                  });
                  return dataset;
                }
              });
            };
          }, {}],
          24: [function (require, module, exports) {
            module.exports = function () {
              if (!window.getComputedStyle) {
                window.getComputedStyle = function (el, pseudo) {
                  this.el = el;

                  this.getPropertyValue = function (prop) {
                    var re = /(\-([a-z]){1})/g;
                    if (prop == 'float') prop = 'styleFloat';

                    if (re.test(prop)) {
                      prop = prop.replace(re, function () {
                        return arguments[2].toUpperCase();
                      });
                    }

                    return el.currentStyle[prop] ? el.currentStyle[prop] : null;
                  };

                  return this;
                };
              }
            };
          }, {}],
          25: [function (require, module, exports) {
            var _ = require('./_lib.js');

            var Scroller = function Scroller() {
              this.actionAttr = 'data-scroll';
              this.actionEls = document.querySelectorAll('[' + this.actionAttr + ']');

              this._addEventListeners();
            }; // Private


            Scroller.prototype._addEventListeners = function () {
              var _this = this;

              _.each(this.actionEls, function (actionEl) {
                var target = document.querySelector(actionEl.dataset.scroll);

                if (target) {
                  actionEl.addEventListener('click', function (e) {
                    e.preventDefault();

                    _.smoothScroll(target);
                  });
                }
              });
            };

            module.exports = Scroller;
          }, {
            "./_lib.js": 14
          }],
          26: [function (require, module, exports) {
            var ShippingDate = function ShippingDate() {};
            /**
              * @desc Checks if day is shop holiday or not
              * @param Date date - Day to check if shop holiday or not (could be of any type supported by the dateFn.convert function )
              *
              * @return Bool - True if day is shop holiday, else otherwise
            */


            ShippingDate.prototype.dateIsShopHoliday = function (date) {
              // Retrieve shop holiday from meta-data (variable shopHolidayList)
              // Format is date1;date2;fromDate1/toDate1;fromDate2/toDate2;
              for (i = 0; i < CoreInit.holidayDates.length; i++) {
                if (Array.isArray(CoreInit.holidayDates[i])) {
                  if (this.inRange(date, CoreInit.holidayDates[i][0], CoreInit.holidayDates[i][1])) {
                    return true;
                  }
                } else {
                  if (this.compare(date, CoreInit.holidayDates[i]) == 0) {
                    return true;
                  }
                }
              }

              return false;
            };
            /**
              * @desc Calculate shipping date for specific product/variant, taking into account rules (week-end, holiday...)
              * @param Integer $variant_id - Id of variant for which to get the productionTime
              * @param Hash $options - Additional options:
                  day_end_time (String HH) - time after which order will be processed next day
                  skip_weekend (Bool) - Skip week-ends when calculating next day
                  skip_shopholiday (Bool) - Skip shop holidays when calculating next day
                  skip_publicholiday (Bool) - Skip public holiday when calculating next day (@TODO: not yet implemented)
              *
              * @return Date - Returns shipping date
            */


            ShippingDate.prototype.getProductionTime = function (product_id, variant_id) {
              var days_nb = typeof ProductsData !== "undefined" ? ProductsData.shippingDates[variant_id] : CartProductsData.shippingDates[variant_id];
              days_nb = days_nb || (typeof ProductsData !== "undefined" ? ProductsData.shippingDates[product_id] : CartProductsData.shippingDates[product_id]);

              if (days_nb) {
                if (isNaN(days_nb.toString()[0])) {
                  days_nb = days_nb.toString().substring(1);
                }

                return days_nb;
              } else {
                return false;
              }
            };
            /**
              * @desc Calculate shipping date (with days till shipping) for specific product/variant, taking into account rules (week-end, holiday...)
              *       Variant production time can be either absolute value (ex: 10) or offset from product production time (ex: +2, -4)
              * @param Integer $variant_id - Id of variant for which to get the productionTime
              * @param Hash $options - Additional options:
                  day_end_time (String HH) - time after which order will be processed next day
                  skip_weekend (Bool) - Skip week-ends when calculating next day
                  skip_shopholiday (Bool) - Skip shop holidays when calculating next day
                  skip_publicholiday (Bool) - Skip public holiday when calculating next day (@TODO: not yet implemented)
              *
              * @return Object{$days, $date} - Return number of days till shipping date + shipping date using offset and rules
            */


            ShippingDate.prototype.getShippingDaysAndDate = function (product_id, variant_id, options) {
              options = options || {};
              var productionTimes = typeof ProductsData !== "undefined" ? ProductsData.shippingDates : CartProductsData.shippingDates;
              var availableDates = typeof ProductsData !== "undefined" ? ProductsData.availableDates : CartProductsData.availableDates;
              var shippingDate = null;
              var days_nb = null;
              var today = new Date();
              today.setHours(0, 0, 0, 0); //var days_nb = variant_id ? (productionTimes[variant_id] ? productionTimes[variant_id] : productionTimes["Product"]) : productionTimes["Product"];
              if (variant_id) {
                days_nb = productionTimes[variant_id];
              }

              if (!days_nb && product_id) {
                days_nb = productionTimes[product_id];
              }

              if (days_nb) {
                // Check if variant's production time is absolute value or offset (based on product's production time)
                var firstChar = days_nb.toString()[0];
                var availableDate = availableDates[variant_id];
                var isDelayed = false;

                if (!availableDate) {
                  availableDate = availableDates[product_id];
                }

                ;

                if (availableDate == undefined) {
                  availableDate = today;
                } else if (this.convert(availableDate) == "Invalid Date") {
                  return {
                    "days": 9999,
                    "date": availableDate,
                    "isDelayed": true
                  };
                } else {
                  availableDate = this.convert(availableDate);
                }

                if (availableDate <= today) {
                  availableDate = today;
                } else {
                  if(firstChar == "+"){
                    days_nb = parseInt(days_nb.toString().substring(1));
                    var shipInfo = this.getNextDaysAndDate(availableDate, days_nb, options);
                    availableDate = shipInfo.date;
                  }
                  return {
                    "days": 99,
                    "date": availableDate,
                    "isDelayed": true
                  };
                } // Production time is an offset


                if (firstChar == '+' || firstChar == '-') {
                  days_nb = parseInt(days_nb.toString().substring(1));
                  var main_variant_id = $('[name="id"]:first').val(); //Only on product always empty on cart

                  main_variant_id = main_variant_id || "product";
                  var main_availableDate = availableDates[main_variant_id]; //NOT AVAILABLE

                  if (typeof main_availableDate == "string" && main_availableDate.toLocaleLowerCase() == "no" || typeof availableDate == "string" && availableDate.toLocaleLowerCase() == "no") {
                    return {
                      "days": null,
                      "date": null,
                      "isDelayed": false
                    };
                  } //Available date undefined or already passed


                  main_availableDate = main_availableDate == undefined ? today : this.convert(main_availableDate);

                  if (isNaN(main_availableDate.getTime()) || main_availableDate < today) {
                    main_availableDate = today;
                  }

                  if (isNaN(availableDate.getTime()) || availableDate < today) {
                    availableDate = today;
                  } //Shipping time for the main product

                  var max_available_date = this.getClosestProductAndDate(product_id, variant_id);
                  if(max_available_date && max_available_date.getTime() > availableDate.getTime()){
                    availableDate = max_available_date;
                  }

                  //var main_productionTime = productionTimes[main_variant_id];
                  //main_productionTime = main_productionTime ? parseInt(main_productionTime) : parseInt(productionTimes["product"]); //Positif offset
                  //get closest product (or product itself), check date, if date => add the offset to the date => return the date

                  var main_productionTime = this.getMaxDaysWithPlusOffset(productionTimes);

                  if (firstChar == '+') {
                    var shipping_main_product = this.getNextDaysAndDate(main_availableDate, main_productionTime, options); //Shipping time for the product

                    if (!isNaN(shipping_main_product.date) && shipping_main_product.date > availableDate) {
                      availableDate = shipping_main_product.date;
                    }

                    var shipInfo = this.getNextDaysAndDate(availableDate, days_nb, options);
                    return {
                      "days": shipInfo.days,
                      "date": shipInfo.date,
                      "isDelayed": false
                    };
                  } //negative offset
                  else {
                      days_nb = Math.max(main_productionTime - days_nb, 1);
                      var shipInfo = this.getNextDaysAndDate(availableDate < main_availableDate ? main_availableDate : availableDate, days_nb, options);
                      return {
                        "days": shipInfo.days,
                        "date": shipInfo.date,
                        "isDelayed": false
                      };
                    }
                } // Production time is absolute value
                else {
                    days_nb = parseInt(days_nb, 10); // Immediate shipping = 2 business days

                    if (days_nb === 1) {
                      days_nb++;
                    }
                    var shipInfo = this.getNextDaysAndDate(availableDate, days_nb, options);
                    return {
                      "days": shipInfo.days,
                      "date": shipInfo.date,
                      "isDelayed": false
                    };
                  }
              }

              return {
                "days": null,
                "date": null,
                "isDelayed": false
              };
            };
            /* Define Dates namespace */

            /**
              * @desc Get list of days between 2 dates
              * @param Date $startDate - Start date of the range
              * @param Date $endDate - End date of the range
              *
              * @return Array[Date] - Array containing all dates between the 2 dates
            */

            /* NOT USED
            function dateRangeToArray(startDate, endDate) {
              var datesArray = [];
              var tmpStartDate = startDate;
               while(tmpStartDate <= endDate) {
                var validDate = new Date(tmpStartDate.getTime());
                datesArray.push(validDate);
                tmpStartDate.setDate(tmpStartDate.getDate() + 1);
              }
               return datesArray;
            }*/
            // Define all functions on the Dates namespace

            //get the closest product of a offset time, and return the date if there is an availability date ===> Use for services and offset
            ShippingDate.prototype.getClosestProductAndDate = function(product_id, variant_id){
              // var date_val = this.convert(CartProductsData.availableDates[val]);
              //get closest product (or product itself), check date, if date => return the date, otherwise return today
              var id = variant_id;
              if(!id){id = product_id};
              var productPTId;
              if(document.querySelector("tr.cart-item-service[data-line-id^='"+id+"']")){
                productPTId = document.querySelector("tr.cart-item-service[data-line-id^='"+id+"']").closest(".cart-item[data-line-id]").getAttribute("data-line-id").split(":")[0];
                //if date, take it to compute new one
                if(CartProductsData.availableDates[productPTId]){
                  var date = new Date(CartProductsData.availableDates[productPTId]);
                  date.setHours(0,0,0,0);
                }else{
                  //if no date, date is today
                  var date = new Date();
                  date.setHours(0,0,0,0);
                }
              }
              return date;
            }



            //loop through all shipping time in the cart product
            //take the max production time and the max with the + in front
            //return the integer as the max number of day
            ShippingDate.prototype.getMaxDaysWithPlusOffset = function(cartProductionTime){

              var maxDayProd=0;
              var maxOffset=0;
              jQuery.map(Object.keys(cartProductionTime), function(val, i) {

                if (cartProductionTime[val].indexOf("+") != -1) {
                  var newMaxOffset=0;
                  //if does not exist, it's not a service, so take the production time of the product on the same line
                  var productPT;
                  if(document.querySelector("tr.cart-item-service[data-line-id^='"+val+"']")){
                    productPT = parseInt(document.querySelector("tr.cart-item-service[data-line-id^='"+val+"']").closest(".cart-item[data-line-id]").getAttribute("data-production-time"));
                    if(document.querySelector("tr.cart-item-service[data-line-id^='"+val+"']").closest(".cart-item[data-line-id]").getAttribute("data-production-offset")){
                      //compare the offset of the service and the product - took the biggest
                      productOff = parseInt(document.querySelector("tr.cart-item-service[data-line-id^='"+val+"']").closest(".cart-item[data-line-id]").getAttribute("data-production-offset"));
                      serviceOff = parseInt(cartProductionTime[val].toString().substring(1))
                      if(productOff > serviceOff){
                        newMaxOffset = parseInt(productOff) + parseInt(productPT);
                      }else{
                        newMaxOffset = parseInt(serviceOff) + parseInt(productPT);
                      }
                    }else{
                      newMaxOffset = parseInt(cartProductionTime[val].toString().substring(1)) + parseInt(productPT);
                    }
                  }else{
                    productPT = document.querySelector("tr[data-line-id^='"+val+"']").getAttribute("data-production-time");
                    newMaxOffset = parseInt(cartProductionTime[val].toString().substring(1)) + parseInt(productPT);
                  }

                  if(maxOffset < newMaxOffset){
                    maxOffset = newMaxOffset;
                  }
                }else{
                  if(maxDayProd < parseInt(cartProductionTime[val])){
                    maxDayProd = parseInt(cartProductionTime[val]);
                  }
                }
                // if(CartProductsData.availableDates[val]){
                //   console.log("availableDates presence",CartProductsData.availableDates[val]);
                // }
              });
              var sumMaxDays = 0;
              if(maxDayProd < maxOffset){
                sumMaxDays = maxOffset;
              }else{
                sumMaxDays = maxDayProd;
              }
              return sumMaxDays
            }

            ShippingDate.prototype.convert = function (date) {
              // @desc Converts the date to a date-object.
              // @param $date - The date to convert, that can be:
              //  a date object : returned without modification
              //  an array      : Interpreted as [year,month,day]. NOTE: month is 0-11.
              //  a number      : Interpreted as number of milliseconds since 1 Jan 1970 (a timestamp)
              //  a string      : Any format supported by the javascript engine, like "YYYY/MM/DD", "MM/DD/YYYY", "Jan 31 2009" etc.
              //  an object     : Interpreted as an object with year, month and date attributes.  **NOTE** month is 0-11.
              //
              // @return Date - Date in date-Object format
              return date.constructor === Date ? date : date.constructor === Array ? new Date(date[0], date[1], date[2]) : date.constructor === Number ? new Date(date) : date.constructor === String ? new Date(date) : (typeof d === "undefined" ? "undefined" : _typeof(d)) === "object" ? new Date(date.year, date.month, date.date) : NaN;
            };

            ShippingDate.prototype.compare = function (date1, date2) {
              // @desc Compare two dates
              // @param Date $date1 - First date used for comparison (could be of any type supported by the convert function above)
              // @param Date $date2 - Second date used for comparison (could be of any type supported by the convert function above)
              //
              // @return Integer - Result based on comparison:
              //  -1 : if date1 < date2
              //   0 : if date1 = date2
              //   1 : if date1 > date2
              // NaN : if date1 or date2 is an illegal date
              return isFinite(date1 = this.convert(date1).valueOf()) && isFinite(date2 = this.convert(date2).valueOf()) ? (date1 > date2) - (date1 < date2) : NaN;
            };

            ShippingDate.prototype.inRange = function (date, startDate, endDate) {
              // @desc Checks if date is between startDate and endDate.
              // @param Date $date - Date we want to check if in between start and end dates (could be of any type supported by the convert function above)
              // @param Date $startDate - Start date of the range (could be of any type supported by the convert function above)
              // @param Date $endDate - End date of the range (could be of any type supported by the convert function above)
              //
              // @return Bool - Possible values:
              //    true  : if date is between start and end (inclusive)
              //    false : if date is before start or after end
              //    NaN   : if one or more of the dates is illegal.
              return isFinite(date = this.convert(date).valueOf()) && isFinite(startDate = this.convert(startDate).valueOf()) && isFinite(endDate = this.convert(endDate).valueOf()) ? startDate <= date && date <= endDate : NaN;
            };

            ShippingDate.prototype.dateSuffix = function (date) {
              // @desc Calculates suffix of the day (st, nd, rd or th)
              // @param Date $date - Date for which to calculate day suffix (could be of any type supported by the convert function above)
              //
              // @return String - Suffix of the day (st, nd, rd or th)
              var day = this.convert(date).getDate(); // translationJSon.javascript.delete_set_confirmation[laLang]

              if (day > 3 && day < 21) return translationJSon.javascript.shipping_date.date_suffix[laLang].default; // if (day>3 && day<21) return "th";

              switch (day % 10) {
                case 1:
                  return translationJSon.javascript.shipping_date.date_suffix[laLang].st;
                // case 1:  return "st";

                case 2:
                  return translationJSon.javascript.shipping_date.date_suffix[laLang].nd;
                // case 2:  return "nd";

                case 3:
                  return translationJSon.javascript.shipping_date.date_suffix[laLang].rd;
                // case 3:  return "rd";

                default:
                  return translationJSon.javascript.shipping_date.date_suffix[laLang].default;
                // default: return "th";
              }
            };

            ShippingDate.prototype.toDaysAndWeeks = function (days_nb) {
              // @desc Transform days into weeks and remaining days (object output)
              // @param Integer $days_nb - Number of days to transform into weeks and days
              //
              // @return Object{$weeks, $days} - Returns weeks and days from initial days
              return {
                weeks: Math.floor(days_nb / 5),
                days: days_nb % 5
              };
            };

            ShippingDate.prototype.toDaysAndWeeksString = function (days_nb) {
              // @desc Transform days into weeks and remaining days (text output)
              // @param Integer $days_nb - Number of days to transform into weeks and days (text output)
              //
              // @return String - Return weeks or days string based on initial days
              var weeksAndDays = this.toDaysAndWeeks(days_nb);

              switch (weeksAndDays.weeks) {
                case 0:
                  switch (weeksAndDays.days) {
                    // default: return weeksAndDays.days + " days";
                    default:
                      return weeksAndDays.days + translationJSon.javascript.shipping_date.js_date_format_days[laLang];
                  }

                  ;

                case 1:
                  return "1" + translationJSon.javascript.shipping_date.js_date_format_week[laLang];
                // case 1:  return "1 week";

                default:
                  return weeksAndDays.weeks + translationJSon.javascript.shipping_date.js_date_format_weeks[laLang];
                // default: return weeksAndDays.weeks + " weeks";
              }
            };

            ShippingDate.prototype.insertShippingDateInHTML = function (dom_id, shipping_info, mode) {
              // @desc Insert message in HTML component
              // @param String $dom_id - ID of HTML DOM element where text should be inserted
              // @param Object $shipping_info - Shipping info to insert in HTML element (object containing "days" and "date" elements)
              // @param String $mode - "days" or "date", dependending what needs to be inserted
              //
              // @return Bool - True if component exists and text was inserted, false otherwise
              var domElement = document.getElementById(dom_id);

              if (domElement) {
                switch (mode) {
                  case "days":
                    domElement.innerHTML = shipping_info.days ? this.toDaysAndWeeksString(shipping_info.days) : "Unavailable";
                    break;

                  case "date":
                    //translationJSon.javascript.shipping_date.month_names[laLang].january;
                    // var months = '';
                    var months = translationJSon.javascript.dates.month_names[laLang].january;

                    if (months.indexOf('your error string') == -1) {
                      // months = ['january',
                      //            'february',
                      //            'march',
                      //            'april',
                      //            'may',
                      //            'june',
                      //            'july',
                      //            'august',
                      //            'september',
                      //            'october',
                      //            'november',
                      //            'december'];
                      months = [translationJSon.javascript.dates.month_names[laLang].january, translationJSon.javascript.dates.month_names[laLang].february, translationJSon.javascript.dates.month_names[laLang].march, translationJSon.javascript.dates.month_names[laLang].april, translationJSon.javascript.dates.month_names[laLang].may, translationJSon.javascript.dates.month_names[laLang].june, translationJSon.javascript.dates.month_names[laLang].july, translationJSon.javascript.dates.month_names[laLang].august, translationJSon.javascript.dates.month_names[laLang].september, translationJSon.javascript.dates.month_names[laLang].october, translationJSon.javascript.dates.month_names[laLang].november, translationJSon.javascript.dates.month_names[laLang].december];
                    } else {
                      months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                    } // if ('english' === 'french') {
                    // if (window.location.href.indexOf("/fr") != -1) {


                    if (document.querySelector("html[lang]").getAttribute("lang") == "fr") {
                      domElement.innerHTML = shipping_info.date ? shipping_info.date.getDate() + " " + months[shipping_info.date.getMonth()] : "Indisponible";
                    } else {
                      domElement.innerHTML = shipping_info.date ? months[shipping_info.date.getMonth()] + " " + shipping_info.date.getDate() + this.dateSuffix(shipping_info.date) : "Unavailable";
                    }

                    break;

                  case "short":
                    domElement.innerHTML = shipping_info.date ? (shipping_info.date.getDate() < 10 ? "0" : "") + shipping_info.date.getDate() + "/" + (shipping_info.date.getMonth() < 9 ? "0" : "") + (shipping_info.date.getMonth() + 1) + "/" + shipping_info.date.getFullYear() : "Variable";
                    break;

                  case "standard":
                    domElement.innerHTML = translationJSon.javascript.shipping_date.in_stock_label_html[laLang]; // domElement.innerHTML = 'In stock: ships within 2 working days';

                    break;
                }

                return true;
              }

              return false;
            };

            ShippingDate.prototype.dateIsWeekEnd = function (date) {
              // @desc Checks if day is during week-end (Saturday/Sunday)
              // @param Date $date - Date to check (could be of any type supported by the convert function above)
              //
              // @return Bool - True if day is in week-end, else otherwise
              var day = this.convert(date).getDay();
              return day == 6 || day == 0;
            };

            ShippingDate.prototype.dateIsSunday = function (date) {
              // @desc Checks if day is a Sunday
              // @param Date $date - Date to check (could be of any type supported by the convert function above)
              //
              // @return Bool - True if day is in week-end, else otherwise
              var day = this.convert(date).getDay();
              return day == 0;
            };

            ShippingDate.prototype.dateIsPublicHoliday = function (date) {
              // @TODO: need to automatically retrieve holiday list from API
              // @desc Checks if day is public holiday or not
              // @date Date $date - Day to check if public holiday or not (could be of any type supported by the convert function above)
              //
              // @return Bool - True if day is public holiday, else otherwise
              // HowToUse:  List National Holidays that are not the xth Monday of a month, including the observed day if it is a Sunday.
              var dateObject = this.convert(date);
              var sDate = dateObject.getMonth() + 1 + '/' + dateObject.getDate();
              if (sDate == '1/2' // Ganjitsu
              || sDate == '1/12' // Coming of Age Day
              || sDate == '2/11' // Kenkoku kinen no hi
              || sDate == '2/23' // Emperor anniversary (observed)
              || sDate == '3/20' // Spring Equinox
              || sDate == '4/29' // Shôwa no hi
              || sDate == '5/4' // Kenpô kinenbi
              || sDate == '5/5' // Midori no hi
              || sDate == '5/6' // Kodomo no hi
              || sDate == '7/20' // Umi no hi
              || sDate == '8/11' // Yama no hi
              || sDate == '9/15' // Shûbun no hi
              || sDate == '9/23' // Autumn Equinox
              || sDate == '10/12' // Sports Day
              || sDate == '11/3' // Bunka no hi
              || sDate == '11/23' // Kinrō Kansha no Hi
              || sDate == '11/27' // BlackFriday
              ) return true; // HowToUse:  The list below contains the 4 national holidays that are the xth Monday of a month for automatic calulation.
              // WARNING: Because of the 2020 olympics, 2 dates were moved and are temporarily commented until 2021.

              sDate = dateObject.getMonth() + 1 + '/' + (Math.floor((dateObject.getDate() - 1) / 7) + 1) + '/' + dateObject.getDay();
              if (sDate == '1/2/1' // Seijin no hi
              // || sDate == '7/3/1' // Umi no hi
              || sDate == '9/3/1' // Keirô no hi
              // || sDate == '10/2/1' // Taiiku no hi
              ) return true;
              return false;
            };

            ShippingDate.prototype.getNextDate = function (date, days_nb, options) {
              // @TODO should just re-use the getNextDaysAndDate and retrieve "date" value rather than maintaining 2 versions of same function
              //
              // @desc Calculate future date based on initial date, offset and rules (week-end, holiday...)
              // @param Date $date - Starting date (could be of any type supported by the convert function above)
              // @param Integer $days_nb - Numbers of days to add to starting date, taking into account options
              // @param Hash $options - Additional options:
              //   day_end_time (String HH) - time after which order will be processed next day (@TODO: not yet implemented)
              // skip_weekend (Bool) - Skip week-ends when calculating next day
              // skip_shopholiday (Bool) - Skip shop holidays when calculating next day
              // kip_publicholiday (Bool) - Skip public holiday when calculating next day (@TODO: not yet implemented)
              //
              // @return Date - Return the future date using offset and rules
              return this.getNextDaysAndDate(date, days_nb, options).date;
            };

            ShippingDate.prototype.getNextDaysAndDate = function (date, days_nb, options) {
              // @desc Calculate number of days till future day, taking into account offset and rules (week-end, holiday...)
              // @param Date $date - Starting date (could be of any type supported by the convert function above)
              // @param Integer $days_nb - Numbers of days to add to starting date (will then take into account options to get actual number of days)
              // @param Hash $options - Additional options:
              //   day_end_time (String HH) - time after which order will be processed next day (@TODO: not yet implemented)
              // skip_weekend (Bool) - Skip week-ends when calculating next day
              // skip_shopholiday (Bool) - Skip shop holidays when calculating next day
              // kip_publicholiday (Bool) - Skip public holiday when calculating next day (@TODO: not yet implemented)
              //
              // @return Hash{$days, $date} - Return number of days till future day + future date using offset and rules
              var params = $.extend(true, {
                day_end_time: '17',
                // time in HH format (24h)
                skip_weekend: 'true',
                // true, false
                skip_shopholiday: 'true',
                // true, false
                skip_publicholiday: 'true',
                // true, false
                days: 0
              }, options);
              var dateObject = this.convert(date);
              var tomorrow = new Date(date);
              tomorrow.setDate(dateObject.getDate() + 1); //@TODO: should check time and not just date (cf day_end_time)

              /*var isTodaySkipped = ((params.skip_weekend && this.dateIsWeekEnd(dateObject)) ||
                      (params.skip_shopholiday && dateIsShopHoliday(dateObject)) ||
                      (params.skip_publicholiday && this.dateIsPublicHoliday(dateObject)));*/
              if (params.skip_shopholiday && this.dateIsShopHoliday(dateObject)) {
                return this.getNextDaysAndDate(tomorrow, days_nb, $.extend(true, options, {
                  days: params.days + 1
                }));
              } else if (params.skip_publicholiday && this.dateIsPublicHoliday(dateObject) && params.skip_weekend && this.dateIsSunday(dateObject)) {
                return this.getNextDaysAndDate(tomorrow, days_nb, $.extend(true, options, {
                  days: params.days + 1
                }));
              } else if (params.skip_publicholiday && this.dateIsPublicHoliday(dateObject)) {
                return this.getNextDaysAndDate(tomorrow, days_nb, $.extend(true, options, {
                  days: params.days + 1
                }));
              } else if (params.skip_weekend && this.dateIsWeekEnd(dateObject)) {
                return this.getNextDaysAndDate(tomorrow, days_nb, $.extend(true, options, {
                  days: params.days
                }));
              } else {
                if (days_nb > 0) {
                  return this.getNextDaysAndDate(tomorrow, days_nb - 1, $.extend(true, options, {
                    days: params.days + 1
                  }));
                } else {
                  return {
                    "days": params.days,
                    "date": dateObject
                  };
                }
              }
            };

            module.exports = ShippingDate;
          }, {}],
          27: [function (require, module, exports) {
            /*
              To show, hide or toggle an element add a data attribute of data-show=""
              to the element you wish to trigger the show/hide action,
              with the value being a css selector of the target element to be shown/hidden
               `data-toggle-content`
               `data-toggle-group`
            */
            var _ = require('./_lib.js');

            var Eventer = require('./_eventer.js');

            var ShowHide = function ShowHide() {
              new Eventer(this);
              this.hiddenClass = 'display_none';
              this.activeClass = 'is-open';
              this.showSelector = '[data-show]';
              this.hideSelector = '[data-hide]';
              this.toggleSelector = '[data-toggle]';
              this.stateVisible = "visible";
              this.stateHidden = "hidden";

              this._addEventListeners();
            };

            ShowHide.prototype.show = function (target, actionEle) {
              var isCheckbox = actionEle.type && actionEle.type === 'checkbox';

              if (!isCheckbox || actionEle.checked) {
                if (actionEle.dataset.state == this.stateHidden) {
                  this.toggleTrigger(actionEle);
                }

                var didShow = this._getEles(target, function (targetEle) {
                  targetEle.dataset.state = this.stateVisible;
                  targetEle.classList.remove(this.hiddenClass);
                });

                if (didShow) {
                  this.toggleGroup('show', actionEle, 'show');
                  this.trigger('show', [actionEle, target]);
                }

                return didShow;
              }

              return false;
            };

            ShowHide.prototype.hide = function (target, actionEle) {
              if (actionEle.dataset.state == this.stateVisible) {
                this.toggleTrigger(actionEle);
              }

              var didHide = this._getEles(target, function (targetEle) {
                targetEle.dataset.state = this.stateHidden;
                targetEle.classList.add(this.hiddenClass);
              });

              if (didHide) {
                this.trigger('hide', [actionEle, target]);
              }

              return didHide;
            };

            ShowHide.prototype.toggle = function (target, actionEle) {
              var event;

              var didToggle = this._getEles(target, function (targetEle) {
                if (actionEle.dataset.state == this.stateHidden) {
                  targetEle.classList.remove(this.hiddenClass);
                  targetEle.dataset.state = this.stateVisible;
                  event = 'show';
                } else {
                  targetEle.classList.add(this.hiddenClass);
                  targetEle.dataset.state = this.stateHidden;
                  event = 'hide';
                }
              });

              if (didToggle) {
                this.toggleGroup(event, actionEle, 'toggle');
                this.toggleTrigger(actionEle);
                this.trigger(event, [actionEle, target]);
              }

              return didToggle;
            };

            ShowHide.prototype.toggleTrigger = function (actionEle) {
              this.toggleContent(actionEle);
              var target = "[data-trigger*='" + actionEle.dataset.trigger + "']";

              this._getEles(target, function (targetEle) {
                if (targetEle !== actionEle) {
                  this.toggleContent(targetEle);
                }
              });
            };

            ShowHide.prototype.toggleContent = function (actionEle) {
              if (actionEle.hasAttribute('data-toggle-content')) {
                var newContent = actionEle.dataset.toggleContent;
                actionEle.dataset.toggleContent = actionEle.innerHTML;
                actionEle.innerHTML = newContent;
              }

              actionEle.dataset.state = actionEle.dataset.state == this.stateVisible ? this.stateHidden : this.stateVisible;
            };

            ShowHide.prototype.toggleGroup = function (event, actionEle, dataAttr) {
              if (actionEle.hasAttribute('data-toggle-group')) {
                var groupSelector = '[data-toggle-group="' + actionEle.dataset.toggleGroup + '"]';
                var groupEles = document.querySelectorAll(groupSelector);
                var groupTrigger = document.querySelectorAll('[data-trigger="' + actionEle.dataset.trigger + '"]');

                _.each(groupEles, function (groupEle) {
                  if (groupEle !== actionEle) {
                    var notInTrigger = true;

                    for (i = 0; i < groupTrigger.length; i++) {
                      if (groupEle == groupTrigger[i]) {
                        notInTrigger = false;
                        break;
                      }
                    }

                    if (notInTrigger) {
                      var target = groupEle.getAttribute('data-' + dataAttr);

                      if (event === 'show') {
                        this.hide(target, groupEle);
                      }
                    }
                  }
                }, this);
              }

              ;
            }; // Private


            ShowHide.prototype._addEventListeners = function () {
              this._addEventListener(this.toggleSelector, 'toggle', this.toggle);

              this._addEventListener(this.hideSelector, 'hide', this.hide);

              this._addEventListener(this.showSelector, 'show', this.show);
            };

            ShowHide.prototype._addEventListener = function (selector, dataAttr, callback) {
              var _this = this;

              var eles = document.querySelectorAll(selector);

              _.each(eles, function (ele) {
                ele.addEventListener('click', function (e) {
                  var target = e.currentTarget.getAttribute('data-' + dataAttr);
                  var isCheckbox = e.currentTarget.type && e.currentTarget.type === 'checkbox';

                  if (callback.apply(_this, [target, e.currentTarget]) && !isCheckbox) {//e.preventDefault();
                  }
                });
              });
            };

            ShowHide.prototype._getEles = function (target, callback) {
              var _this = this;

              var targetEles = document.querySelectorAll(target);

              if (targetEles.length > 0) {
                _.each(targetEles, function (targetEle) {
                  callback.apply(_this, [targetEle]);
                });

                return true;
              }

              return false;
            };

            module.exports = ShowHide;
          }, {
            "./_eventer.js": 10,
            "./_lib.js": 14
          }],
          28: [function (require, module, exports) {
            // To use add an `onswipeLeft`, `onswipeRight`, `onswipeUp` or `onswipeDown` function on any dom element
            // i.e. document.querySelector('.my-ele').onswipeLeft = function () { ... };
            module.exports = function (threshold) {
              var Swipe = function Swipe() {
                this.threshold = threshold || 5;
                this.xDown = null;
                this.yDown = null;
                this.add_event_listeners();
              };

              Swipe.prototype.add_event_listeners = function () {
                var _this = this;

                if (Element.prototype.addEventListener) {
                  document.addEventListener('touchstart', function (evt) {
                    _this.handleTouchStart(evt);
                  }, false);
                  document.addEventListener('touchmove', function (evt) {
                    _this.handleTouchMove(evt);
                  }, false);
                }
              };

              Swipe.prototype.handleTouchStart = function (evt) {
                this.xDown = evt.touches[0].clientX;
                this.yDown = evt.touches[0].clientY;
              };

              Swipe.prototype.handleTouchMove = function (evt) {
                if (!this.xDown || !this.yDown) return;
                var current_target = evt.targetTouches[0].target;
                var xUp = evt.touches[0].clientX;
                var yUp = evt.touches[0].clientY;
                var xDiff = this.xDown - xUp;
                var yDiff = this.yDown - yUp;

                if (Math.abs(xDiff) > Math.abs(yDiff)) {
                  if (xDiff > 0) {
                    if (xDiff > this.threshold) {
                      this.trigger('swipeLeft', current_target);
                    }
                  } else {
                    if (xDiff * -1 > this.threshold) {
                      this.trigger('swipeRight', current_target);
                    }
                  }
                } else {
                  if (yDiff > 0) {
                    if (yDiff > this.threshold) {
                      this.trigger('swipeUp', current_target);
                    }
                  } else {
                    if (yDiff * -1 > this.threshold) {
                      this.trigger('swipeDown', current_target);
                    }
                  }
                } // Reset values


                this.xDown = null;
                this.yDown = null;
              };

              Swipe.prototype.trigger = function (event, current_target) {
                // Don't do events on text and comment nodes
                if (current_target.nodeType === 3 || current_target.nodeType === 8) {
                  return;
                } // Get elements for bubbling


                var element = current_target,
                    elements = [];

                while (element) {
                  elements.push(element);
                  element = element.offsetParent;
                } // Bubble up through the elements to trigger events


                var ele,
                    handle,
                    result,
                    data = {
                  type: event,
                  target: current_target
                };

                for (var i = 0; i < elements.length; i++) {
                  ele = elements[i];
                  handle = ele['on' + event];

                  if (handle && handle.apply) {
                    result = handle.apply(ele, [data]);

                    if (result === false) {
                      break;
                    }
                  }
                }
              };

              new Swipe();
            };
          }, {}],
          29: [function (require, module, exports) {
            /*
              For now the youtube video must be in a lightbox.
              So need the [data-lightbox] attribut and the attribut [data-video-src] with the value of the youtube video ID
            */
            var _ = require('./_lib.js');

            var VideoPlayer = function VideoPlayer() {
              this.isApiReady = false;
              this.Players = {};
              this.delayPlayer = {};
              this.init();
            };

            VideoPlayer.prototype.init = function () {
              var tag = document.createElement('script');
              tag.src = "https://www.youtube.com/iframe_api";
              var firstScriptTag = document.getElementsByTagName('script')[0];
              firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

              window.onYouTubeIframeAPIReady = function () {
                window.SeidoCore.lightbox.videoPlayer.isApiReady = true;
                window.SeidoCore.lightbox.videoPlayer.buildPlayers();
              };

              window.onPlayerReady = function (event) {// event.target.playVideo();
              };

              window.onPlayerStateChange = function (event) {// event.target.playVideo();
              };
            };

            VideoPlayer.prototype.createPlayer = function (playerId, src) {
              if (this.isApiReady) {
                this.Players[playerId] = new YT.Player(playerId, {
                  events: {
                    'onReady': onPlayerReady,
                    'onStateChange': onPlayerStateChange
                  }
                });
                delete this.delayPlayer[playerId];
              } else {
                this.delayPlayer[playerId] = src;
              }
            };

            VideoPlayer.prototype.buildPlayers = function () {
              _.eachIn(this.delayPlayer, function (src, playerId) {
                this.createPlayer(playerId, src);
              }, this);
            };

            module.exports = VideoPlayer;
          }, {
            "./_lib.js": 14
          }],
          30: [function (require, module, exports) {
            // Check that we have what we need to move forward
            var supports = !!document.querySelector && !!window.addEventListener;
            if (!supports) return; // Pollyfills to add functionality to older browsers

            require('./_pollyfills/pollyfill.dataset.js')();

            require('./_pollyfills/pollyfill.classlist.js')();

            require('./_pollyfills/pollyfill.getComputedStyle.js')();

            require('./_pollyfills/pollyfill.closest.js')(); // Add swipe events
            // to use add an `onswipeLeft`, `onswipeRight`, `onswipeUp` or `onswipeDown` function on any dom element
            // i.e. document.querySelector('.my-ele').onswipeLeft = function () { ... };


            require('./_swipe-events.js')(); // Modules needed for core js


            var _ = require('./_lib.js');

            var Eventer = require('./_eventer.js');

            var ElementQueries = require('./_element-queries.js');

            var OffCanvas = require('./_off-canvas.js');

            var MenuToggle = require('./_menu-toggle.js');

            var Display = require('./_display.js');

            var LoadIcons = require('./_load-icons.js');

            var ShowHide = require('./_show-hide.js');

            var Carousel = require('./_carousel.js');

            var Lightbox = require('./_lightbox.js');

            var Disclaimers = require('./_disclaimers.js');

            var IndexReviews = require('./_index-reviews.js');

            var FormValidation = require('./_form-validation.js');

            var FloatingLabel = require('./_floating-label.js');

            var Cart = require('./_cart-processing.js');

            var AffixList = require('./_affix-list.js');

            var Scroller = require('./_scroller.js');

            var Customer = require('./_customer.js');

            var IsSafari = function IsSafari() {
              var safari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
              var safariDisclaimer = document.querySelectorAll('[data-disclaimer="safari"]')[0];

              if (!safari && safariDisclaimer) {
                safariDisclaimer.style.display = 'none';
              }
            };

            var IsArticleBlog = "the-budoexport-blog" != "" && document.body.classList.contains("the-budoexport-blog");

            var Main = function Main() {
              // Update our no-js and loading classes if we have js. Needed for offcanvas css.
              this.onLoad();
              /***********Prevention Anti bugsnag */

              /******bugsnag (inséré par youtube) ajoute un listener sur le click de la fenetre qui recupere le texte de la div clique */

              /**********faire ralentir énormément les grosses pages comme les Iaito Minosaka */

              /********* ce fix a pour but d'empecher l'execution du fichier bugsnag même s'il est importé */

              /******** il est exécuté pendant le chargement de la page, et ajoute un type non fonctionnel ("javascript/blocked" dans notre cas) qui empeche l'execution du script */

              /***********Bugsnag prevention */

              /******bugsnag (insert by youtube) add a click listener on the page which get all the text contains inside the element we just click on (and when leaving Tools, the div contains all the data of the page) */

              /****** as a result, it makes the pages with a lot of content way slower, like Minosaka Iaito */

              /******** the aim of this fix is to prevent the execution of the bugsnag file even if it's inserted inside the page */

              /******** this code is executed during the loading of the page, and add a non functional type ("javascript/blocked" in our cases) which orevent the script to be executed */

              var needsToBeBlacklisted = function needsToBeBlacklisted(src) {
                return src.includes('bugsnag.min.js');
              };

              var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (_ref) {
                  var addedNodes = _ref.addedNodes;
                  addedNodes.forEach(function (node) {
                    // For each added script tag
                    if (needsToBeBlacklisted(node.src || '')) {
                      node.type = 'javascript/blocked'; // Firefox has this additional event which prevents scripts from beeing executed

                      var beforeScriptExecuteListener = function beforeScriptExecuteListener(event) {
                        // Prevent only marked scripts from executing
                        if (node.getAttribute('type') === 'javascript/blocked') {
                          event.preventDefault();
                        }

                        node.removeEventListener('beforescriptexecute', beforeScriptExecuteListener);
                      };

                      node.addEventListener('beforescriptexecute', beforeScriptExecuteListener);
                    }
                  });
                });
              });
              observer.observe(document.documentElement, {
                childList: true,
                subtree: true
              });

              var scriptBlocker = function scriptBlocker() {
                var createElementBackup = document.createElement;

                document.createElement = function () {
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  } // If this is not a script tag, bypass


                  if (args[0].toLowerCase() !== 'script') {
                    return createElementBackup.bind(document).apply(void 0, args);
                  }

                  var scriptElt = createElementBackup.bind(document).apply(void 0, args);
                  var originalSetAttribute = scriptElt.setAttribute.bind(scriptElt); // Define getters / setters to ensure that the script type is properly set

                  Object.defineProperties(scriptElt, {
                    src: {
                      get: function get() {
                        return scriptElt.getAttribute('src');
                      },
                      set: function set(value) {
                        if (needsToBeBlacklisted(value || '', scriptElt.type)) {
                          originalSetAttribute('type', 'javascript/blocked');
                        }

                        originalSetAttribute('src', value);
                        return true;
                      }
                    },
                    // eslint-disable-next-line accessor-pairs
                    type: {
                      set: function set(value) {
                        var typeValue = needsToBeBlacklisted(scriptElt.src || '', scriptElt.type) ? 'javascript/blocked' : value;
                        originalSetAttribute('type', typeValue);
                        return true;
                      }
                    }
                  }); // Monkey patch the setAttribute function so that the setter is called instead.
                  // Otherwise, setAttribute('type', 'whatever') will bypass our custom descriptors!

                  if (scriptElt) {
                    scriptElt.setAttribute = function (name, value) {
                      if (name === 'type' || name === 'src') {
                        scriptElt[name] = value;
                      } else {
                        HTMLScriptElement.prototype.setAttribute.call(scriptElt, name, value);
                      }
                    };

                    return scriptElt;
                  }
                };
              };

              scriptBlocker(); // Trigger a ready even when the core has finished loading

              new Eventer(this); // Run all scripts that need the DOM as soon as the DOM is ready

              var _this = this;

              _.ready(function () {
                // Init modules
                new LoadIcons();
                new Disclaimers();

                if (CoreInit.Template == 'index') {
                  _this.reviews = new IndexReviews();
                }

                new FormValidation();
                new FloatingLabel();

                if (!IsArticleBlog) {
                  new Cart();
                }

                _this.showHide = new ShowHide();
                _this.elementQueries = new ElementQueries();
                _this.menuToggle = new MenuToggle();
                _this.offCanvas = new OffCanvas();
                _this.display = new Display();
                _this.carousel = new Carousel();

                if (CoreInit.Template == 'product') {
                  _.readyProduct(function () {
                    _this.lightbox = new Lightbox(_this.carousel);
                  });
                } else {
                  _this.lightbox = new Lightbox(_this.carousel);
                }

                new AffixList();
                new Scroller();

                if (CoreInit.Template == 'customers-addresses' || CoreInit.Template == 'customers-order') {
                  new Customer();
                } // Run internal methods


                if (window.location.hash) {
                  var initScroolElt = document.querySelector(window.location.hash);

                  if (initScroolElt) {
                    setTimeout(function () {
                      _.smoothScroll(initScroolElt);
                    }, 500);
                  }
                }

                function eventFire(el, etype) {
                  if (el.fireEvent) {
                    el.fireEvent('on' + etype);
                  } else {
                    var evObj = document.createEvent('Events');
                    evObj.initEvent(etype, true, false);
                    el.dispatchEvent(evObj);
                  }
                } // Dirty fix reviews and guide tabs not showing when directly linked
                // @TODO fix the way carousels are created to avoid this dirty fix


                var hash = document.location.hash;

                if (document.location.href.indexOf('/products/') >= 0 && hash !== "") {
                  document.location.href = "#description-tab";

                  if (hash === "#reviews") {
                    eventFire(document.getElementById("action-tabReviews"), 'click');
                  } else if (hash.indexOf('#tab-') >= 0) {
                    eventFire(document.getElementById("action-tabContent"), 'click');
                  }

                  document.location.href = hash;
                }

                _this.addEventListeners();

                _this.triggerReady();

                IsSafari();
              });
            }; // fin var Main = function () {


            Main.prototype.onLoad = function () {
              // Add the `js` class and remove the `no-js` class
              document.documentElement.classList.add('js');
              document.documentElement.classList.remove('no-js'); // Remove the `loading` class
              var _this = this;

              window.addEventListener('load', function () {
                document.documentElement.classList.remove('loading');
                if (document.getElementsByClassName("jdgm-write-rev-link").length > 0){
                  document.getElementsByClassName("jdgm-write-rev-link")[0].addEventListener("click", function() {
                    _this.translate_judge_me();
                    if(document.querySelector("input[name='reviewer_name']")){
                      document.querySelector("input[name='reviewer_name']").value = anonymous_text;
                      if($("select[id^=jdgm_review_reviewer_name_format] option").size() > 3){
                        $("select[id^=jdgm_review_reviewer_name_format] option:first").remove();
                      }
                      $("select[id^=jdgm_review_reviewer_name_format]").val("last_initial").change();
                    }
                    if(document.querySelector("input.jdgm-submit-rev[type=submit]")){
                      console.log("pass in submit rev")
                      document.querySelector("input.jdgm-submit-rev[type=submit]").addEventListener("click", function() {
                        setTimeout(function () {
                          console.log("translate post review");
                          _this.translate_judge_me();
                        }, 1000);
                      });
                    }
                  });
                }
                
                if(document.getElementsByClassName("jdgm-paginate__load-more").length > 0){
                  document.getElementsByClassName("jdgm-paginate__load-more")[0].addEventListener("click", function() {
                    setTimeout(function () {
                      _this.translate_judge_me();
                    }, 1000);
                  });
                }
                _this.translate_judge_me();
              });

              //change link when the alert with a link generated by shopify appears
              if(document.querySelector("form#create_customer a[href='/login#recover']")){
              	document.querySelector("form#create_customer a[href='/login#recover']").setAttribute("href", "/account/login#recover")
              }

            };

            Main.prototype.translate_judge_me = function (){

              if (translations_judge_me_json_parsed){
                for (var key of Object.keys(translations_judge_me_json_parsed)) {
                  if(key.indexOf("definition") == -1){
                    for (var keylvl2 of Object.keys(translations_judge_me_json_parsed[key])){
                      //if the key contains a dot, it means instead of just a class, we need to get the attribute and replace the text or a placeholder

                      if (keylvl2.indexOf("data-capture") == -1){
                        //check if texts has { bracket, mean there's text to replace
                        //for this, check which data-capture what it is, and search in the tag
                        if(translations_judge_me_json_parsed[key][keylvl2][laLang].indexOf("{") != -1){
                          var replaced_text = translations_judge_me_json_parsed[key][keylvl2][laLang];
                          for (var data of Object.keys(translations_judge_me_json_parsed[key]["data-capture"])){

                            //get the attribute value in the html
                            var attribute_value = $("."+key).find('['+[translations_judge_me_json_parsed[key]["data-capture"][data]]+']').attr(translations_judge_me_json_parsed[key]["data-capture"][data]);

                            // replace the value in brackets of our json text with the real value
                            replaced_text = replaced_text.replace("{"+data+"}",attribute_value);

                            // and now we replace the real text with replaced_text
                            $("."+key).find("."+keylvl2.split(".")[1]).text(replaced_text);
                          }
                        }else{
                          if(keylvl2.indexOf(".") != -1){
                            var type = keylvl2.split(".")[0];
                            var value_of_type = keylvl2.split(".")[1];
                            //if type is a name, need to replace the placeholder
                            if(type.indexOf("name") != -1){
                              $("["+type+"^="+value_of_type+"]").each(function(){
                                $(this).attr("placeholder",translations_judge_me_json_parsed[key][keylvl2][laLang]);
                              })
                            }else if(type.indexOf("class") != -1){
                              $("."+value_of_type).each(function(){
                                console.log("value_of_type",value_of_type)
                                console.log("translations_judge_me_json_parsed[key][keylvl2][laLang]",translations_judge_me_json_parsed[key][keylvl2][laLang]);
                                $("."+value_of_type).text(translations_judge_me_json_parsed[key][keylvl2][laLang]);
                              });
                            }else if(type.indexOf("for") != -1){
                              $("["+type+"^="+value_of_type+"]").each(function(){
                                $(this).text(translations_judge_me_json_parsed[key][keylvl2][laLang]);
                              });
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            Main.prototype.addEventListeners = function () {
              if (this.menuToggle) {
                var _this = this; // Make element queries recalculate when the menu is toggled _after_ the animation has completed.


                this.menuToggle.on('menuToggled', function () {
                  setTimeout(function () {
                    _this.carousel.setCarouselWidths(); // wait till carosels have finished jumping around before setting the element queries
                    //Update 27/04/2020 --> Add document.location.pathname.indexOf to trigger the function inside collections (search.indexOf seems to be equal -1 with some url)


                    setTimeout(function () {
                      _this.elementQueries.calcQueries();

                      if (typeof Seido !== 'undefined' && (document.location.search.indexOf("collections/") > -1 || document.location.pathname.indexOf("collections/") > -1)) {
                        Seido.Filters.apply_uri_filters();
                      }
                    }, 300);
                  }, 300);
                });
              }
            };

            Main.prototype.triggerReady = function () {
              // Let anyone that is listening for the core know that it's now ready.
              this.ready = true;
              this.trigger('ready');
            };

            window.SeidoCore = new Main();
          }, {
            "./_affix-list.js": 1,
            "./_carousel.js": 2,
            "./_cart-processing.js": 3,
            "./_customer.js": 5,
            "./_disclaimers.js": 6,
            "./_display.js": 8,
            "./_element-queries.js": 9,
            "./_eventer.js": 10,
            "./_floating-label.js": 11,
            "./_form-validation.js": 12,
            "./_index-reviews.js": 13,
            "./_lib.js": 14,
            "./_lightbox.js": 15,
            "./_load-icons.js": 16,
            "./_menu-toggle.js": 17,
            "./_off-canvas.js": 19,
            "./_pollyfills/pollyfill.classlist.js": 21,
            "./_pollyfills/pollyfill.closest.js": 22,
            "./_pollyfills/pollyfill.dataset.js": 23,
            "./_pollyfills/pollyfill.getComputedStyle.js": 24,
            "./_scroller.js": 25,
            "./_show-hide.js": 27,
            "./_swipe-events.js": 28
          }]
        }, {}, [30]);
      });
    }); //fin "then responseCountries =>" du fetch
  });
}); //fin "then response =>" du fetch
// }); // fin ajax